webpackJsonp([17],{

/***/ "/SUS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/uEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2C5d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2RxU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "3wwE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4W1K":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4mot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5LIk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7c9T":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7sMP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9rC8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BMRp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BkQZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C5za":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CFbh":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./aboutUs-de.vue": [
		"eFod",
		15
	],
	"./aboutUs-en.vue": [
		"G9P+",
		14
	],
	"./aboutUs-es.vue": [
		"7rwu",
		13
	],
	"./aboutUs-fr.vue": [
		"t9Vx",
		12
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "CFbh";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./src/_common/js/bus.js
var bus = __webpack_require__("fMn/");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/header.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var header = ({

  name: 'header',

  data: function data() {
    var _this = this;

    return {
      showLangSheet: false,
      showCurrencySheet: false,
      currentCurrency: localStorage.getItem('currency') || 'EUR',
      // ✅ 币种列表：名称已清理 (去掉重复符号)，汇率更新至 2025.12
      currencyActions: [
      // --- 核心币种 ---
      { code: 'EUR', name: 'Euro', symbol: '€', rate: 1.0 }, { code: 'USD', name: 'US Dollar', symbol: '$', rate: 1.16 }, { code: 'GBP', name: 'British Pound', symbol: '£', rate: 0.87 }, { code: 'SAR', name: 'Saudi Riyal', symbol: 'SR', rate: 4.35 }, { code: 'AED', name: 'UAE Dirham', symbol: 'AED', rate: 4.27 },

      // --- 美洲 ---
      { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', rate: 1.61 }, { code: 'MXN', name: 'Mexican Peso', symbol: '$', rate: 21.18 }, { code: 'COP', name: 'Colombian Peso', symbol: '$', rate: 4425.0 }, { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', rate: 6.19 },

      // --- 亚洲 & 中东 ---
      { code: 'INR', name: 'Indian Rupee', symbol: '₹', rate: 104.55 }, { code: 'PHP', name: 'Philippine Peso', symbol: '₱', rate: 68.73 }],
      // ✅ 提示文案字典
      currencyNoteText: {
        en: 'Reference only. Transactions are settled in Euro (€).',
        de: 'Nur zur Orientierung. Die Zahlung erfolgt in Euro (€).',
        fr: 'À titre indicatif. Le règlement s\'effectue en Euro (€).',
        es: 'Solo como referencia. El pago se procesará en Euro (€).'
      },
      isFading: false,
      currentLang: localStorage.getItem('lang') || 'en',
      langActions: [{ name: 'English', method: function method() {
          return _this.changeLang('en');
        } }, { name: 'Deutsch', method: function method() {
          return _this.changeLang('de');
        } }, { name: 'Español', method: function method() {
          return _this.changeLang('es');
        } }, { name: 'Français', method: function method() {
          return _this.changeLang('fr');
        } }],
      isMenu: '',
      menuItems: ['Browse', 'transaction', 'transactionDetail', 'Settings'],
      isPageName: '',
      PageItems: ['Browse', 'Details', 'searchResult', 'Settings'],
      isCategoryMenu: '',
      categoryItems: ['Browse'],
      isSearchMenu: '',
      searchItems: ['Browse', 'Details', 'searchResult'],
      titleName: '',
      isCartZoom: false,
      cartCount: null,
      showLogo: 'y'
    };
  },

  methods: {
    goHome: function goHome() {
      if (this.$route.path === '/') {
        window.location.reload();
      } else {
        this.$router.push('/');
      }
    },

    // 币种切换
    changeCurrency: function changeCurrency(code) {
      // 找到选中的币种对象
      var selectedCurrency = this.currencyActions.find(function (c) {
        return c.code === code;
      });
      var rate = selectedCurrency ? selectedCurrency.rate : 1;

      // 写入 Storage
      localStorage.setItem('currency', code);
      localStorage.setItem('currencyRate', rate); // 关键：把汇率存进去

      this.currentCurrency = code;
      this.showCurrencySheet = false;
      this.isFading = true;
      setTimeout(function () {
        window.location.reload();
      }, 250);
    },

    // 语言切换
    changeLang: function changeLang(lang) {
      localStorage.setItem('lang', lang);
      this.currentLang = lang;
      this.showLangSheet = false;
      this.isFading = true;
      setTimeout(function () {
        window.location.reload();
      }, 250);
    },
    signIn: function signIn() {
      this.$router.push({ path: '/login' });
    },
    fetch: function fetch() {
      var _this2 = this;

      this.$axios(this.ApiList.cart).then(function (response) {
        var cartInfo = response.data.carts;
        var total = 0;
        for (var i = 0; i < cartInfo.cartItems.length; i++) {
          total += cartInfo.cartItems[i].quantity;
        }
        _this2.cartCount = total;
      }).catch(function (err) {
        console.log(err);
      });
    },
    goCart: function goCart() {
      this.$router.push({ path: '/cart' });
    },
    showAsideMenu: function showAsideMenu() {
      bus["a" /* default */].$emit('show-menu');
    },
    showCategoryMenu: function showCategoryMenu() {
      bus["a" /* default */].$emit('show-category');
    },
    changeTitleName: function changeTitleName() {
      switch (this.$route.name) {
        case 'searchResult':
          this.titleName = this.$route.params.text;
          break;
      }

      if (this.$route.name === 'Browse') {
        this.showLogo = true;
      } else {
        this.showLogo = false;
      }

      if (this.menuItems.indexOf(this.$route.name) > -1) {
        this.isMenu = true;
      } else {
        this.isMenu = false;
      }

      if (this.categoryItems.indexOf(this.$route.name) > -1) {
        this.isCategoryMenu = true;
      } else {
        this.isCategoryMenu = false;
      }

      if (this.PageItems.indexOf(this.$route.name) > -1) {
        this.isPageName = true;
      } else {
        this.isPageName = false;
      }

      if (this.searchItems.indexOf(this.$route.name) > -1) {
        this.isSearchMenu = true;
      } else {
        this.isSearchMenu = false;
      }
    },
    goBack: function goBack() {
      var _this3 = this;

      if (window.history.length <= 1) {
        this.$router.push({ path: '/' });
        return false;
      } else {
        this.$router.back(-1);
      }
      setTimeout(function () {
        _this3.$router.push({ path: '/' });
      }, 500);
    },
    search: function search() {
      this.$router.push({ path: '/search' });
    }
  },
  watch: {
    showLangSheet: function showLangSheet(val) {
      var tg = document.querySelector('.telegram-btn');
      var wa = document.querySelector('.whatsapp-btn');
      if (tg) tg.style.visibility = val ? 'hidden' : 'visible';
      if (wa) wa.style.visibility = val ? 'hidden' : 'visible';
    },

    // ✅ 监听币种弹窗：隐藏悬浮的 Telegram/WhatsApp 按钮
    showCurrencySheet: function showCurrencySheet(val) {
      var tg = document.querySelector('.telegram-btn');
      var wa = document.querySelector('.whatsapp-btn');
      if (tg) tg.style.visibility = val ? 'hidden' : 'visible';
      if (wa) wa.style.visibility = val ? 'hidden' : 'visible';
    }
  },
  created: function created() {
    var _this4 = this;

    if (!localStorage.getItem('currencyRate')) {
      var current = this.currencyActions.find(function (c) {
        return c.code === _this4.currentCurrency;
      });
      var rate = current ? current.rate : 1;
      localStorage.setItem('currencyRate', rate);
    }

    if (!localStorage.getItem('lang')) {
      var navLang = navigator.language.toLowerCase();
      if (navLang.includes('fr')) {
        this.changeLang('fr');
      } else if (navLang.includes('de')) {
        this.changeLang('de');
      } else if (navLang.includes('es')) {
        this.changeLang('es');
      } else {
        this.changeLang('en');
      }
    }
    this.changeTitleName();
    this.fetch();
    bus["a" /* default */].$on('cart-refresh', function () {
      _this4.fetch();
    });
    bus["a" /* default */].$on('cart-zoom', function () {
      _this4.isCartZoom = true;
      setTimeout(function () {
        _this4.isCartZoom = false;
      }, 2000);
    });
  },

  computed: {
    isLogin: function isLogin() {
      return this.$store.getters.getLoginStatus;
    },
    pageTitle: function pageTitle() {
      var key = 'header' + this.$route.name;
      var translated = this.$t ? this.$t(key) : key;
      if (translated === key) {
        return this.$route.name;
      }
      return translated;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35220ecf","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"parentDiv"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFading),expression:"isFading"}],staticClass:"fade-layer"},[_vm._m(0)]),_vm._v(" "),_c('div',{class:{ isMenu: _vm.isMenu && _vm.isLogin },attrs:{"id":"header"}},[_c('div',{staticClass:"menu",class:{ 'is-home': _vm.showLogo }},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMenu&_vm.isLogin),expression:"isMenu&isLogin"}],staticClass:"menu-button-container",on:{"click":_vm.showAsideMenu}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isMenu),expression:"!isMenu"}],staticClass:"go-back-button",on:{"click":_vm.goBack}}),_vm._v(" "),(_vm.titleName?_vm.titleName:_vm.$route.name=='Browse')?_c('div',{staticClass:"page-name"},[_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLogo),expression:"showLogo"}],staticStyle:{"cursor":"pointer"},attrs:{"id":"logo","src":"https://www.calmpurr.com/img/logo/logo-tou6.webp"},on:{"click":_vm.goHome}})]):_c('div',{staticClass:"page-name"},[_vm._v("\n        "+_vm._s(_vm.pageTitle)+"\n      ")])]),_vm._v(" "),_c('ul',{staticClass:"right-btn"},[_c('li',{staticClass:"currency-button-container",on:{"click":function($event){_vm.showCurrencySheet = true}}}),_vm._v(" "),_c('li',{staticClass:"lang-button-container",on:{"click":function($event){_vm.showLangSheet = true}}}),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLogin),expression:"isLogin"}],staticClass:"cart-button-container",class:{'bounce' : _vm.isCartZoom },on:{"click":_vm.goCart}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.cartCount !== 0),expression:"cartCount !== 0"}],staticClass:"cart-quantity"},[_vm._v(_vm._s(_vm.cartCount))])]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLogin),expression:"!isLogin"}],staticClass:"sign-button-container",on:{"click":_vm.signIn}})])]),_vm._v(" "),(_vm.showLangSheet)?_c('div',{staticClass:"lang-overlay",on:{"click":function($event){_vm.showLangSheet = false}}},[_c('div',{staticClass:"lang-panel",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"lang-title"},[_vm._v("Select Language")]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('en')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇬🇧")]),_vm._v(" "),_c('span',[_vm._v("English")])]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('de')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇩🇪")]),_vm._v(" "),_c('span',[_vm._v("Deutsch")])]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('fr')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇫🇷")]),_vm._v(" "),_c('span',[_vm._v("Français")])]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('es')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇪🇸")]),_vm._v(" "),_c('span',[_vm._v("Español")])]),_vm._v(" "),_c('div',{staticClass:"lang-cancel",on:{"click":function($event){_vm.showLangSheet = false}}},[_vm._v("\n        Cancel\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.showCurrencySheet)?_c('div',{staticClass:"lang-overlay",on:{"click":function($event){_vm.showCurrencySheet = false}}},[_c('div',{staticClass:"lang-panel",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"lang-title"},[_vm._v(_vm._s(_vm.$t('selectCurrency')))]),_vm._v(" "),_vm._l((_vm.currencyActions),function(item){return _c('div',{key:item.code,staticClass:"lang-item",on:{"click":function($event){_vm.changeCurrency(item.code)}}},[_c('span',{staticClass:"flag"},[_vm._v(_vm._s(item.symbol))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name)+" ("+_vm._s(item.code)+")")])])}),_vm._v(" "),_c('div',{staticClass:"currency-note"},[_vm._v("\n          "+_vm._s(_vm.$t('currencyChangeTips'))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"lang-cancel",on:{"click":function($event){_vm.showCurrencySheet = false}}},[_vm._v("\n          Cancel\n        ")])],2)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-cat"},[_c('div',{staticClass:"loader-shadow"}),_vm._v(" "),_c('img',{attrs:{"src":"https://www.calmpurr.com/img/logo/logo-tou6.webp"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_header = (esExports);
// CONCATENATED MODULE: ./src/components/header.vue
function injectStyle (ssrContext) {
  __webpack_require__("BMRp")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-35220ecf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  header,
  components_header,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_header = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "G6LU":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAYAAABiS3YzAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAaZJREFUeNqclNFHQ3EUx+9+Y8TUU4yxiugpImIsIo3sYXoqUSTKUnrrMfYUEeulRP0BvRR7mhI9jJFipBQ9pRgjIkZE36Nzcxxn67YvH7Nz7vne3/39zu+ERlMpr4n6wSyYAMOgg+P34Aocg5JVGDJMu8AWWAJhr7VOwTKoy6AzVncNcgEMSVPgjn9N0xi4ZOP/qBucgDltGuZEXDz8xntn6QOUVewQDEpTektSPPAO0mDcKCbDSc6fi3iEz+LXdF0VLoAbYVBWhvS/AbKgJuoytFrHezikTLfFVvhGJfUC0g6fhVTGqc+WXXBhGEvDAneJVsqpw5EaYOOYkSsYW+Yr7v5olwToUzG6WSMtaqKOW8dSg0+4EjDuq06m1RaGcg831R6njXYjVR23Tk0l5lXBHsjzjdOHp2uLZPoFdlUiz9fPN8yJrpDGeXWQj3Qh/CkVBQ+qE275mi4an/jEfbuq4nQZinL0JXkVEa897YMVPaUqvJefbRjSwF5rNk8pOcbTPYioSzbADJ/Nz8jrSST0gy/gALyCTtBrmD2DIzANznTyW4ABAAGlXRzxTenAAAAAAElFTkSuQmCC"

/***/ }),

/***/ "HJnX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JZBs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jr96":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KSrR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Knql":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MZ1S":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAEVUlEQVRYR72XbYhUZRTH//+5L+sL9KLU1u7ca21tc69W5geDXj5YUFoUCkXkQhS9YPRikRRRklZoBCVkYVEQIkFFiVkY2JcSKyOC0tjmDmuF95lZ3W0lo9K8z517Ymac3ZndHXfUHZ9vc5l7/r/nPP97nnOI07RyaXRm8iiMluPp0M92mFfDTG2eciSad+EfOFCrOekAQad5HQxe7oX6tZJQn2vPLkJ2ATyDIg9nlN7QEoBewDbS5uMg15KyMj4Sv2G0mQ8JuYrktJKoiLzvK91zUgAqjamHYSyQVGqRCK4k2Q5IB8C2scco/wGcMua5yG5P6StOGCDrWPeAWEfw7FPxjAhCX0WzmgbY2wEnNqxNIBecivDwuyI/Q/iylUQ7L+pHWHre0ISBa98ByNsAz5wU8ZoghNydCfWmhgBBp3E7DOOjyRauxhNJnvRV/Mq4AHvTuFjT2l11bisgKMmKjIrXjQEQgDnH+hHk3FYIj3ihuMRTxa1jALKutYzgW60Vl6GzIn3BeQP4tw6gXEgcKw/ynJYCAL97YdRV1Rj+CrKOeSOZ2t5i8XJ4oyhXdRf0d3UZyDrW6yQfOSEAkURIBZEDJLymP1nBi56KnqsDCBzrp5L5mCSrMvn4hcC1twG4uVzDgf1+GHVkXeNWwvj0WF3vNaEXdyv8WoXOpu0epuRdEWzwlX5ivM0EjrVbiEE/1DeMzsBBkjOaA5C/p0LPckMcyjnmSoJdVqxXd+3HvsC1lotgKcjtlER7Kl5TqqjatO+rAMmDFMaeitLDAAKYOdfW5QdNZIDA6kwYPZ91zBVkqlxQAPkrofb9fRgMXKtAsB0iRzylpwWueQ2Q+nqkEMlhX+nptQBWzrWjWoBs2r4MSGZWYuOoX4h3VY9AJFnkq3h74Nq/APBHUi2PeaFen3Xtzwjc0hAA8qcf6hmjj2CI5MxqBsY7v2EPiMz3lP4hcK0BgOcO7wzJM34YvxQ49hYQS46TgV5f6UtP3oQJ7vLy0XuBY38CYnEVwEiSBd35eEfg2iVjdjUGwBe+ihbWAeRca72AjzbjAUC+zYT62t9K90bK2igCj+Q7Xhg9nU0btzFlfFw5ukYeSJ71Vbx21BFUClFzAABFNsZKL5sDlL1TWn0d1rzY5DYC5x8PAAnmevloTx1AH9BWdCwFoFfIHRD0kOiubET+AfkqRC4hubTGHzmIfANySIDZgCwkaNW4PQa5hiIOyHsrsbDXV1E5bh1A6cfpuYxGbsIxAKXrOHCsPSTLDp3sJSI7fKXr2rsxLVmrGhIROdh2VM/pGsRA7cbG7Qkr/SA+nLQMSHld7+fjr0bHbNiU5tLWA0K8CdI4NRAZRFHu9Arxl+PFOe5odmzM+qC22p0QjGAri9H9mX4MNXpvwtnwQDumH7LLI9dTpfmuKQBBv0hxuZ8vbp7o/xMCVANURzOkUjclgvnV0UwEmuQgRAoCfM9EPs8U4p0EyrfrROt/pKJBP40O7cYAAAAASUVORK5CYII="

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var filters_namespaceObject = {};
__webpack_require__.d(filters_namespaceObject, "orderDate", function() { return orderDate; });

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./src/_common/js/bus.js
var bus = __webpack_require__("fMn/");

// CONCATENATED MODULE: ./src/_common/js/cookies.js
function getCookie(cName) {
  if (document.cookie.length > 0) {
    var cStart = document.cookie.indexOf(cName + '=');
    if (cStart !== -1) {
      cStart = cStart + cName.length + 1;
      var cEnd = document.cookie.indexOf(';', cStart);
      if (cEnd === -1) cEnd = document.cookie.length;
      return unescape(document.cookie.substring(cStart, cEnd));
    }
  }
  return '';
}

function setCookie(cName, value, expiredays) {
  var exdate = new Date();
  exdate.setDate(exdate.getDate() + expiredays);
  document.cookie = cName + '=' + escape(value) + (expiredays == null ? '' : ';expires=' + exdate.toGMTString());
}

function checkCookie() {
  var user = getCookie('user');
  if (user !== null && user !== '') {
    return user;
  } else {
    user = prompt('Please enter your name:', '');
    if (user !== null && user !== '') {
      setCookie('user', user, 365);
    }
  }
}
var cookieApi = { getCookie: getCookie, setCookie: setCookie, checkCookie: checkCookie };
/* harmony default export */ var cookies = (cookieApi);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/asideMenu.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var asideMenu = ({

  name: 'asideMenu',

  data: function data() {
    return {
      activeMenu: '', // 当前激活的菜单
      isMenuShow: false, // 是否显示
      loginName: '',
      personImage: ''
    };
  },
  created: function created() {
    var _this = this;

    var current = this;
    bus["a" /* default */].$on('show-menu', function () {
      _this.isMenuShow = true;
      _this.person();
    });
    this.getActiveMenu(this.$route.name);
  },

  methods: {
    hideMenu: function hideMenu() {
      this.isMenuShow = false;
    },
    goTo: function goTo(path) {
      this.hideMenu();
      this.$router.push({ path: path });
    },
    getActiveMenu: function getActiveMenu(name) {
      this.activeMenu = name;
    },
    person: function person() {
      var _this2 = this;

      this.$axios.post(this.ApiList.personInfo).then(function (response) {
        _this2.loginName = response.data.userName;
        var gender = response.data.gender;
        if (gender) {
          //if ('M' == gender) {
          //   this.personImage = 'https://www.hitryfun.com/logo/male.jpeg'
          //} else if ('F' == gender) {
          //   this.personImage = 'https://www.hitryfun.com/logo/female.jpeg'
          //}
          _this2.personImage = 'https://www.calmpurr.com/img/logo/logo.png';
        }
      }).catch(function (err) {
        console.log(error);
      });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      console.log(to);
      this.activeMenu = to.name;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0063fd36","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/asideMenu.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'show-menu': _vm.isMenuShow},attrs:{"id":"aside"}},[_c('div',{attrs:{"id":"asideMenu"}},[_c('div',{attrs:{"id":"personalInfo"}},[_c('div',{staticClass:"mobile-profile-header main-color-background"},[_c('div',{staticClass:"user-image"},[_c('img',{attrs:{"src":_vm.personImage}})]),_vm._v(" "),_c('div',{staticClass:"user-detail"},[_c('div',{staticClass:"user-name"},[_vm._v("\n            "+_vm._s(_vm.loginName)+"\n          ")])])])]),_vm._v(" "),_c('div',{staticClass:"mobile-profile-menu"},[_c('ul',[_c('a',{staticClass:"menu-item ui-link",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.goTo('/')}}},[_c('li',{staticClass:"profile-menu-row",class:{'active':_vm.activeMenu==='Browse'}},[_c('div',{staticClass:"row-icon home-icon"}),_vm._v(" "),_c('div',{staticClass:"row-description"},[_vm._v("\n              "+_vm._s(_vm.$t('home'))+"\n            ")])])]),_vm._v(" "),_c('a',{staticClass:"menu-item ui-link",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.goTo('/cart')}}},[_c('li',{staticClass:"profile-menu-row",class:{'active':_vm.activeMenu==='cart'}},[_c('div',{staticClass:"row-icon shopping-cart-icon"}),_vm._v(" "),_c('div',{staticClass:"row-description"},[_vm._v("\n                "+_vm._s(_vm.$t('shoppingcart'))+"\n            ")])])]),_vm._v(" "),_c('a',{staticClass:"menu-item ui-link",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.goTo('/transaction')}}},[_c('li',{staticClass:"profile-menu-row",class:{'active':_vm.activeMenu==='transaction'}},[_c('div',{staticClass:"row-icon order-history-icon"}),_vm._v(" "),_c('div',{staticClass:"row-description"},[_vm._v("\n              "+_vm._s(_vm.$t('orderhistory'))+"\n            ")])])]),_vm._v(" "),_c('li',{staticClass:"mobile-profile-menu-section-devider"}),_vm._v(" "),_c('a',{staticClass:"menu-item ui-link",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.goTo('/settings')}}},[_c('div',{staticClass:"profile-menu-row",class:{'active':_vm.activeMenu==='Settings'}},[_c('div',{staticClass:"row-icon settings-icon"}),_vm._v(" "),_c('div',{staticClass:"row-description"},[_vm._v("\n               "+_vm._s(_vm.$t('settings'))+"\n            ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"menu-mask",on:{"click":_vm.hideMenu}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_asideMenu = (esExports);
// CONCATENATED MODULE: ./src/components/asideMenu.vue
function injectStyle (ssrContext) {
  __webpack_require__("Jr96")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0063fd36"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  asideMenu,
  components_asideMenu,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_asideMenu = (Component.exports);

// CONCATENATED MODULE: ./src/assets/js/category.js
var categories = [{
  name: 'Category',
  hasChildren: true,
  isSelected: false,
  children: [{
    name: 'Bottoms',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Pajamas',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Fashion Sets',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Robes',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Uniforms',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Waterproof Jackets',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Reversible',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Retro Fashion',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Dance Wear',
    isSelected: false,
    hasChildren: false
  }, {
    name: 'Beach Wear',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Overalls',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Capes',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Costumes & Cosplay',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'U-Necks',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Custom Made Clothing',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Business Casual',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Shorts',
    hasChildren: false,
    isSelected: false
  }, {
    name: 'Plus Size Fashion',
    hasChildren: false,
    isSelected: false
  }]
}];

/* harmony default export */ var js_category = (categories);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/asideCategory.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var asideCategory = ({

  name: 'asideCategory',

  data: function data() {
    return {
      isShowMenu: false,
      categories: [],
      currentLevel: 0, // 层级 一开始是0层 每次点击下一个，层级就+1
      selectedCategories: [] // 选中的category
      // selectedCategoriesString: '' // 被选中的category的字符串组合
    };
  },
  created: function created() {
    var _this = this;

    this.categories = js_category;
    bus["a" /* default */].$on('show-category', function () {
      _this.isShowMenu = true;
    });
  },

  computed: {
    selectedCategoriesString: function selectedCategoriesString() {
      return this.selectedCategories.join('，');
    }
  },
  methods: {
    apply: function apply() {
      // 重新请求产品接口
      bus["a" /* default */].$emit('reload-product');
      this.hideMenu();
    },
    clearAll: function clearAll() {
      // 清空该大类目下的选中的搜素条件
      this.selectedCategories = [];
      _.each(js_category[0].children, function (n, k) {
        n.isSelected = false;
      });
      bus["a" /* default */].$emit('reload-product');
      this.hideMenu();
    },
    hideMenu: function hideMenu() {
      this.isShowMenu = false;
    },
    nextCategory: function nextCategory(item) {
      var _this2 = this;

      if (item.hasChildren) {
        this.currentLevel++;
        this.categories = item.children;
      } else {
        item.isSelected = !item.isSelected;
        this.selectedCategories = [];
        _.each(js_category[0].children, function (n, k) {
          if (n.isSelected) {
            _this2.selectedCategories.push(n.name);
          }
        });
        bus["a" /* default */].$emit('reload-product');
      }
    },
    goback: function goback() {
      // 回到上一个层级
      this.categories = js_category;
      this.currentLevel--;
    }
  },
  watch: {
    isShowMenu: function isShowMenu(newVal, val) {
      if (!newVal) {
        this.currentLevel = 0;
        this.categories = js_category;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0766caf8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/asideCategory.vue
var asideCategory_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{ 'show-category': _vm.isShowMenu}},[_c('div',{attrs:{"id":"category-aside"}},[_c('div',{staticClass:"category-aside-container"},[_c('div',{staticClass:"category-header"},[_c('svg',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentLevel !== 0),expression:"currentLevel !== 0"}],staticClass:"wm category-back",attrs:{"aria-hidden":"true"},on:{"click":_vm.goback}},[_c('use',{attrs:{"xlink:href":"#wm-huitui"}})]),_vm._v("\n        Refine\n      ")]),_vm._v(" "),_c('div',{staticClass:"category-content"},_vm._l((_vm.categories),function(item){return _c('div',{staticClass:"category-aside-item",on:{"click":function($event){_vm.nextCategory(item)}}},[_c('span',[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentLevel === 0),expression:"currentLevel === 0"}],staticClass:"selected-categories"},[_vm._v(_vm._s(_vm.selectedCategoriesString))]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(item.hasChildren),expression:"item.hasChildren"}],staticClass:"wm",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#wm-arrow-right"}})]),_vm._v(" "),_c('svg',{directives:[{name:"show",rawName:"v-show",value:(item.isSelected),expression:"item.isSelected"}],staticClass:"wm category-select",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#wm-gou"}})])])})),_vm._v(" "),_c('div',{staticClass:"category-foot"},[_c('div',{staticClass:"category-foot-btn clear-btn",on:{"click":_vm.clearAll}},[_vm._v("Clear all")]),_vm._v(" "),_c('div',{staticClass:"category-foot-btn apply-btn",on:{"click":_vm.apply}},[_vm._v("Apply")])])])]),_vm._v(" "),_c('div',{staticClass:"menu-mask",on:{"click":_vm.hideMenu}})])}
var asideCategory_staticRenderFns = []
var asideCategory_esExports = { render: asideCategory_render, staticRenderFns: asideCategory_staticRenderFns }
/* harmony default export */ var components_asideCategory = (asideCategory_esExports);
// CONCATENATED MODULE: ./src/components/asideCategory.vue
function asideCategory_injectStyle (ssrContext) {
  __webpack_require__("wwva")
}
var asideCategory_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var asideCategory___vue_template_functional__ = false
/* styles */
var asideCategory___vue_styles__ = asideCategory_injectStyle
/* scopeId */
var asideCategory___vue_scopeId__ = "data-v-0766caf8"
/* moduleIdentifier (server only) */
var asideCategory___vue_module_identifier__ = null
var asideCategory_Component = asideCategory_normalizeComponent(
  asideCategory,
  components_asideCategory,
  asideCategory___vue_template_functional__,
  asideCategory___vue_styles__,
  asideCategory___vue_scopeId__,
  asideCategory___vue_module_identifier__
)

/* harmony default export */ var src_components_asideCategory = (asideCategory_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/loadingCircle.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var loadingCircle = ({

  name: 'loadingThreePoints',
  props: {
    isShowMask: {
      default: false,
      type: Boolean
    }
  },
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07725b30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/loadingCircle.vue
var loadingCircle_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{'show-mask': _vm.isShowMask }},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"loading"},[_c('mt-spinner',{attrs:{"type":"snake","color":"#8dd9bf","size":60}})],1)])}
var loadingCircle_staticRenderFns = []
var loadingCircle_esExports = { render: loadingCircle_render, staticRenderFns: loadingCircle_staticRenderFns }
/* harmony default export */ var base_loadingCircle = (loadingCircle_esExports);
// CONCATENATED MODULE: ./src/components/base/loadingCircle.vue
function loadingCircle_injectStyle (ssrContext) {
  __webpack_require__("Y6Yn")
}
var loadingCircle_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var loadingCircle___vue_template_functional__ = false
/* styles */
var loadingCircle___vue_styles__ = loadingCircle_injectStyle
/* scopeId */
var loadingCircle___vue_scopeId__ = "data-v-07725b30"
/* moduleIdentifier (server only) */
var loadingCircle___vue_module_identifier__ = null
var loadingCircle_Component = loadingCircle_normalizeComponent(
  loadingCircle,
  base_loadingCircle,
  loadingCircle___vue_template_functional__,
  loadingCircle___vue_styles__,
  loadingCircle___vue_scopeId__,
  loadingCircle___vue_module_identifier__
)

/* harmony default export */ var components_base_loadingCircle = (loadingCircle_Component.exports);

// EXTERNAL MODULE: ./src/components/SiteFooter.vue + 1 modules
var SiteFooter = __webpack_require__("S7Ll");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//
//
//
//
//







// import LoginModal from './components/signIn'
// import MyHeader from './components/header'
/* harmony default export */ var App = ({
  name: 'app',
  components: { AsideMenu: src_components_asideMenu, AsideCategory: src_components_asideCategory, LoadingCircle: components_base_loadingCircle, SiteFooter: SiteFooter["a" /* default */] },
  data: function data() {
    return {
      showLoadingCircle: false
    };
  },

  watch: {
    '$route': function $route(to, from) {
      console.log(to);
      // document.body.docu
    }
  },
  created: function created() {
    var _this = this;

    var user = cookies.getCookie('user');
    var email = cookies.getCookie('email');
    if (user) {
      this.$store.commit('changeLoginStatus', {
        isLogin: true,
        account: {
          userName: user,
          email: email
        }
      });
    } else {
      this.$store.commit('changeLoginStatus', {
        isLogin: false
      });
    }
    bus["a" /* default */].$on('show-circle-loading', function (type) {
      if (type === 'show') {
        _this.showLoadingCircle = true;
      } else {
        _this.showLoadingCircle = false;
      }
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-149cd16a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper",attrs:{"id":"app"}},[_c('keep-alive',{attrs:{"include":"index"}},[(_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"page-container"}):_vm._e()],1),_vm._v(" "),(!_vm.$route.meta.keepAlive)?_c('router-view',{staticClass:"page-container"}):_vm._e(),_vm._v(" "),_c('aside-menu'),_vm._v(" "),_c('aside-category'),_vm._v(" "),_c('loading-circle',{attrs:{"isShowMask":_vm.showLoadingCircle}})],1)}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("Knql")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./src/components/header.vue + 2 modules
var header = __webpack_require__("Cz8s");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/base/loadingThreePoints.vue
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loadingThreePoints = ({

  name: 'loadingCircle',

  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ff9e791e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/base/loadingThreePoints.vue
var loadingThreePoints_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var loadingThreePoints_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-page-state-default-loading"},[_c('div',{staticClass:"wish-loader"},[_c('div',{staticClass:"circle1 main-color-background"}),_vm._v(" "),_c('div',{staticClass:"circle2 main-color-background"}),_vm._v(" "),_c('div',{staticClass:"circle3 main-color-background"})])])}]
var loadingThreePoints_esExports = { render: loadingThreePoints_render, staticRenderFns: loadingThreePoints_staticRenderFns }
/* harmony default export */ var base_loadingThreePoints = (loadingThreePoints_esExports);
// CONCATENATED MODULE: ./src/components/base/loadingThreePoints.vue
function loadingThreePoints_injectStyle (ssrContext) {
  __webpack_require__("4mot")
}
var loadingThreePoints_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var loadingThreePoints___vue_template_functional__ = false
/* styles */
var loadingThreePoints___vue_styles__ = loadingThreePoints_injectStyle
/* scopeId */
var loadingThreePoints___vue_scopeId__ = "data-v-ff9e791e"
/* moduleIdentifier (server only) */
var loadingThreePoints___vue_module_identifier__ = null
var loadingThreePoints_Component = loadingThreePoints_normalizeComponent(
  loadingThreePoints,
  base_loadingThreePoints,
  loadingThreePoints___vue_template_functional__,
  loadingThreePoints___vue_styles__,
  loadingThreePoints___vue_scopeId__,
  loadingThreePoints___vue_module_identifier__
)

/* harmony default export */ var components_base_loadingThreePoints = (loadingThreePoints_Component.exports);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/qs/lib/index.js
var lib = __webpack_require__("mw3O");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HeroCarousel.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var HeroCarousel = ({
  name: "HeroCarousel",
  data: function data() {
    return {
      active: 0,

      // 这里就是你的 CDN 多分辨率 Banner
      imgs: [{
        src390: "https://www.calmpurr.com/img/banner/banner-390.webp",
        src780: "https://www.calmpurr.com/img/banner/banner-780.webp"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    setInterval(function () {
      _this.active = (_this.active + 1) % _this.imgs.length;
    }, 3000);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41fde5dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/HeroCarousel.vue
var HeroCarousel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-carousel"},[_c('div',{staticClass:"cp-slides",style:({ transform: 'translateX(-' + _vm.active * 100 + '%)' })},_vm._l((_vm.imgs),function(img,i){return _c('img',{key:i,attrs:{"src":img.src390,"srcset":img.src390 + ' 390w, ' + img.src780 + ' 780w',"sizes":"100vw","width":"780","height":"430","fetchpriority":"high","decoding":"async","alt":"Custom cat squishy banner"}})}))])}
var HeroCarousel_staticRenderFns = []
var HeroCarousel_esExports = { render: HeroCarousel_render, staticRenderFns: HeroCarousel_staticRenderFns }
/* harmony default export */ var components_HeroCarousel = (HeroCarousel_esExports);
// CONCATENATED MODULE: ./src/components/HeroCarousel.vue
function HeroCarousel_injectStyle (ssrContext) {
  __webpack_require__("KSrR")
}
var HeroCarousel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var HeroCarousel___vue_template_functional__ = false
/* styles */
var HeroCarousel___vue_styles__ = HeroCarousel_injectStyle
/* scopeId */
var HeroCarousel___vue_scopeId__ = "data-v-41fde5dc"
/* moduleIdentifier (server only) */
var HeroCarousel___vue_module_identifier__ = null
var HeroCarousel_Component = HeroCarousel_normalizeComponent(
  HeroCarousel,
  components_HeroCarousel,
  HeroCarousel___vue_template_functional__,
  HeroCarousel___vue_styles__,
  HeroCarousel___vue_scopeId__,
  HeroCarousel___vue_module_identifier__
)

/* harmony default export */ var src_components_HeroCarousel = (HeroCarousel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CouponsRow.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CouponsRow = ({
  name: 'CouponsRow',
  data: function data() {
    return {
      copiedIndex: null,
      coupons: [{ title: this.$t('couponoff5title'), desc: this.$t('couponoff5desc'), code: "OFF5" }, { title: this.$t('couponoff10title'), desc: this.$t('couponoff10desc'), code: "OFF10" }, { title: this.$t('couponoff15title'), desc: this.$t('couponoff15desc'), code: "OFF15" }]
    };
  },

  methods: {
    copyCode: function copyCode(code, index) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.clipboard.writeText(code);

              case 3:
                _this.copiedIndex = index;
                setTimeout(function () {
                  return _this.copiedIndex = null;
                }, 1000); // 动画1秒消失
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                alert('Copied: ' + code);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5239e22","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CouponsRow.vue
var CouponsRow_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-coupons"},_vm._l((_vm.coupons),function(coupon,i){return _c('div',{key:i,staticClass:"cp-coupon",on:{"click":function($event){_vm.copyCode(coupon.code, i)}}},[_c('div',{staticClass:"cp-coupon-body"},[_c('strong',[_vm._v(_vm._s(coupon.title))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(coupon.desc))]),_vm._v(" "),_c('span',{staticClass:"cp-code"},[_vm._v("CODE: "+_vm._s(coupon.code))])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.copiedIndex === i)?_c('div',{staticClass:"cp-toast"},[_vm._v("Copied!")]):_vm._e()])],1)}))}
var CouponsRow_staticRenderFns = []
var CouponsRow_esExports = { render: CouponsRow_render, staticRenderFns: CouponsRow_staticRenderFns }
/* harmony default export */ var components_CouponsRow = (CouponsRow_esExports);
// CONCATENATED MODULE: ./src/components/CouponsRow.vue
function CouponsRow_injectStyle (ssrContext) {
  __webpack_require__("gAK1")
}
var CouponsRow_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var CouponsRow___vue_template_functional__ = false
/* styles */
var CouponsRow___vue_styles__ = CouponsRow_injectStyle
/* scopeId */
var CouponsRow___vue_scopeId__ = "data-v-b5239e22"
/* moduleIdentifier (server only) */
var CouponsRow___vue_module_identifier__ = null
var CouponsRow_Component = CouponsRow_normalizeComponent(
  CouponsRow,
  components_CouponsRow,
  CouponsRow___vue_template_functional__,
  CouponsRow___vue_styles__,
  CouponsRow___vue_scopeId__,
  CouponsRow___vue_module_identifier__
)

/* harmony default export */ var src_components_CouponsRow = (CouponsRow_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/BestSellerGrid.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var BestSellerGrid = ({
  name: 'BestSellerGrid',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    // ✅ 新增：价格格式化方法 (与 Index.vue 逻辑一致)
    formatPrice: function formatPrice(basePrice) {
      if (basePrice === null || basePrice === undefined) return '';

      var currency = localStorage.getItem('currency') || 'EUR';
      var rate = parseFloat(localStorage.getItem('currencyRate')) || 1;

      var finalPrice = basePrice * rate;

      // 非欧元强制 .99 结尾
      if (currency !== 'EUR') {
        finalPrice = Math.floor(finalPrice) + 0.99;
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(finalPrice);
    },
    getDiscount: function getDiscount(item) {
      if (!item.originalPrice || !item.productPrice) return 0;
      var diff = item.originalPrice - item.productPrice;
      return Math.round(diff / item.originalPrice * 100);
    },
    placeholder: function placeholder(i) {
      var c = ['#f6fffa', '#f0fff4', '#ecfdf5', '#e0f2f1'][i % 4];
      return 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">\n             <rect width="300" height="300" fill="' + c + '"/>\n             <text x="50%" y="50%" text-anchor="middle" font-size="18" fill="#666">cat' + (i + 1) + '</text>\n           </svg>');
    },

    // 显示商品详情
    showDetail: function showDetail(id) {
      this.$router.push({ path: '/product/' + id });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48532ccb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BestSellerGrid.vue
var BestSellerGrid_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cp-section"},[_c('h2',{staticClass:"cp-section-title"},[_vm._v(_vm._s(_vm.$t('bestseller')))]),_vm._v(" "),_c('div',{staticClass:"cp-grid"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"cp-product",on:{"click":function($event){_vm.showDetail(item.id)}}},[_c('div',{staticClass:"cp-img-wrapper"},[_c('img',{attrs:{"src":item.mainImage || _vm.placeholder(i),"alt":item.name}}),_vm._v(" "),(item.originalPrice && _vm.getDiscount(item) >= 20)?_c('span',{staticClass:"cp-sale-badge"},[_vm._v("\n          ✨ "+_vm._s(_vm.$t('specialOffer'))+"\n        ")]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"cp-product-title",style:({display: '-webkit-box', WebkitLineClamp: 2,WebkitBoxOrient: 'vertical',overflow: 'hidden',textOverflow: 'ellipsis'})},[_vm._v(_vm._s(item.name || 'Product ' + (i + 1)))]),_vm._v(" "),_c('p',{staticClass:"cp-price"},[_vm._v("\n        "+_vm._s(_vm.formatPrice(item.productPrice))+"\n        "),(item.originalPrice)?_c('span',{staticClass:"cp-old-price"},[_vm._v("\n          "+_vm._s(_vm.formatPrice(item.originalPrice))+"\n        ")]):_vm._e()])])}))])}
var BestSellerGrid_staticRenderFns = []
var BestSellerGrid_esExports = { render: BestSellerGrid_render, staticRenderFns: BestSellerGrid_staticRenderFns }
/* harmony default export */ var components_BestSellerGrid = (BestSellerGrid_esExports);
// CONCATENATED MODULE: ./src/components/BestSellerGrid.vue
function BestSellerGrid_injectStyle (ssrContext) {
  __webpack_require__("tGic")
}
var BestSellerGrid_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var BestSellerGrid___vue_template_functional__ = false
/* styles */
var BestSellerGrid___vue_styles__ = BestSellerGrid_injectStyle
/* scopeId */
var BestSellerGrid___vue_scopeId__ = "data-v-48532ccb"
/* moduleIdentifier (server only) */
var BestSellerGrid___vue_module_identifier__ = null
var BestSellerGrid_Component = BestSellerGrid_normalizeComponent(
  BestSellerGrid,
  components_BestSellerGrid,
  BestSellerGrid___vue_template_functional__,
  BestSellerGrid___vue_styles__,
  BestSellerGrid___vue_scopeId__,
  BestSellerGrid___vue_module_identifier__
)

/* harmony default export */ var src_components_BestSellerGrid = (BestSellerGrid_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/RecommendScroller.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var RecommendScroller = ({
  name: 'RecommendScroller',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  methods: {
    // ✅ 新增：价格格式化方法 (统一逻辑)
    formatPrice: function formatPrice(basePrice) {
      if (basePrice === null || basePrice === undefined) return '';

      var currency = localStorage.getItem('currency') || 'EUR';
      var rate = parseFloat(localStorage.getItem('currencyRate')) || 1;

      var finalPrice = basePrice * rate;

      // 非欧元强制 .99 结尾
      if (currency !== 'EUR') {
        finalPrice = Math.floor(finalPrice) + 0.99;
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(finalPrice);
    },
    placeholder: function placeholder(i) {
      var c = ['#f6fffa', '#fff4f2', '#f0fdfa'][i % 3];
      return 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="300" height="300">\n             <rect width="300" height="300" fill="' + c + '"/>\n             <text x="50%" y="50%" text-anchor="middle" font-size="18" fill="#666">Rec' + (i + 1) + '</text>\n           </svg>');
    },

    // 显示商品详情
    showDetail: function showDetail(id) {
      this.$router.push({ path: '/product/' + id });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02e48e24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecommendScroller.vue
var RecommendScroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cp-recommend"},[_c('h2',{staticClass:"cp-section-title"},[_vm._v(_vm._s(_vm.$t('recommendforyou')))]),_vm._v(" "),_c('div',{staticClass:"cp-scroll"},_vm._l((_vm.list),function(item,i){return _c('div',{key:i,staticClass:"cp-item",on:{"click":function($event){_vm.showDetail(item.id)}}},[_c('img',{attrs:{"src":item.mainImage || _vm.placeholder(i),"alt":item.name}}),_vm._v(" "),_c('h3',{staticClass:"cp-item-title",style:({display: '-webkit-box', WebkitLineClamp: 2,WebkitBoxOrient: 'vertical',overflow: 'hidden',textOverflow: 'ellipsis'})},[_vm._v(_vm._s(item.name || 'Recommended ' + (i + 1)))]),_vm._v(" "),_c('p',{staticClass:"cp-price"},[_vm._v("\n        "+_vm._s(_vm.formatPrice(item.productPrice))+"\n        "),(item.originalPrice)?_c('span',{staticClass:"cp-old-price"},[_vm._v("\n          "+_vm._s(_vm.formatPrice(item.originalPrice))+"\n        ")]):_vm._e()])])}))])}
var RecommendScroller_staticRenderFns = []
var RecommendScroller_esExports = { render: RecommendScroller_render, staticRenderFns: RecommendScroller_staticRenderFns }
/* harmony default export */ var components_RecommendScroller = (RecommendScroller_esExports);
// CONCATENATED MODULE: ./src/components/RecommendScroller.vue
function RecommendScroller_injectStyle (ssrContext) {
  __webpack_require__("vDM/")
}
var RecommendScroller_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var RecommendScroller___vue_template_functional__ = false
/* styles */
var RecommendScroller___vue_styles__ = RecommendScroller_injectStyle
/* scopeId */
var RecommendScroller___vue_scopeId__ = "data-v-02e48e24"
/* moduleIdentifier (server only) */
var RecommendScroller___vue_module_identifier__ = null
var RecommendScroller_Component = RecommendScroller_normalizeComponent(
  RecommendScroller,
  components_RecommendScroller,
  RecommendScroller___vue_template_functional__,
  RecommendScroller___vue_styles__,
  RecommendScroller___vue_scopeId__,
  RecommendScroller___vue_module_identifier__
)

/* harmony default export */ var src_components_RecommendScroller = (RecommendScroller_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ReviewGallery.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var ReviewGallery = ({
  name: 'ReviewGalleryMasonry',
  data: function data() {
    var makeImg = function makeImg(t, c, h) {
      return 'data:image/svg+xml;utf8,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" width="400" height="' + h + '">\n          <rect width="400" height="' + h + '" fill="' + c + '"/>\n          <text x="50%" y="50%" text-anchor="middle" font-size="18" fill="#666">' + t + '</text>\n        </svg>');
    };

    return {
      reviews: [{
        name: 'Dawn',
        rating: 5,
        img: "https://www.calmpurr.com/img/review/1763435324992.webp",
        text: this.$t('review1')
      }, {
        name: 'Kimbrell',
        rating: 5,
        img: "https://www.calmpurr.com/img/review/1763435450725.webp",
        text: this.$t('review2')
      }, {
        name: 'Joel',
        rating: 5,
        img: "https://www.calmpurr.com/img/review/1763435471471.webp",
        text: this.$t('review3')
      }, {
        name: 'Emily',
        rating: 5,
        img: 'https://www.calmpurr.com/img/review/1763435495131.webp',
        text: this.$t('review4')
      }, {
        name: 'Lucas',
        rating: 5,
        img: "https://www.calmpurr.com/img/review/1763435514747.webp",
        text: this.$t('review5')
      }, {
        name: 'Sophie',
        rating: 5,
        img: 'https://www.calmpurr.com/img/review/1763435532292.webp',
        text: this.$t('review6')
      }, {
        name: 'Mark',
        rating: 5,
        img: 'https://www.calmpurr.com/img/review/1763435554690.webp',
        text: this.$t('review7')
      }, {
        name: 'Anna',
        rating: 5,
        img: "https://www.calmpurr.com/img/review/1763435572493.webp",
        text: this.$t('review8')
      }]
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39866ee8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReviewGallery.vue
var ReviewGallery_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cp-reviews"},[_c('h2',{staticClass:"cp-section-title"},[_vm._v(_vm._s(_vm.$t('ourcustomershow')))]),_vm._v(" "),_c('div',{staticClass:"cp-masonry"},_vm._l((_vm.reviews),function(r,i){return _c('div',{key:i,staticClass:"cp-rev-card"},[_c('img',{staticClass:"cp-rev-img",attrs:{"src":r.img,"alt":"review","loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"cp-rev-body"},[_c('div',{staticClass:"cp-name"},[_vm._v(_vm._s(r.name))]),_vm._v(" "),_c('div',{staticClass:"cp-stars"},_vm._l((5),function(n){return _c('span',{key:n,staticClass:"star",class:{ filled: n <= r.rating }},[_vm._v("★")])})),_vm._v(" "),_c('div',{staticClass:"cp-rev-text"},[_vm._v(_vm._s(r.text))])])])}))])}
var ReviewGallery_staticRenderFns = []
var ReviewGallery_esExports = { render: ReviewGallery_render, staticRenderFns: ReviewGallery_staticRenderFns }
/* harmony default export */ var components_ReviewGallery = (ReviewGallery_esExports);
// CONCATENATED MODULE: ./src/components/ReviewGallery.vue
function ReviewGallery_injectStyle (ssrContext) {
  __webpack_require__("/uEr")
}
var ReviewGallery_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var ReviewGallery___vue_template_functional__ = false
/* styles */
var ReviewGallery___vue_styles__ = ReviewGallery_injectStyle
/* scopeId */
var ReviewGallery___vue_scopeId__ = "data-v-39866ee8"
/* moduleIdentifier (server only) */
var ReviewGallery___vue_module_identifier__ = null
var ReviewGallery_Component = ReviewGallery_normalizeComponent(
  ReviewGallery,
  components_ReviewGallery,
  ReviewGallery___vue_template_functional__,
  ReviewGallery___vue_styles__,
  ReviewGallery___vue_scopeId__,
  ReviewGallery___vue_module_identifier__
)

/* harmony default export */ var src_components_ReviewGallery = (ReviewGallery_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FaqAccordion.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var FaqAccordion = ({
  name: 'FaqAccordion',
  data: function data() {
    return {
      active: null,
      faqList: [{
        q: this.$t('faq1'),
        a: this.$t('faq1answer')
      }, {
        q: this.$t('faq2'),
        a: this.$t('faq2answer')
      }, {
        q: this.$t('faq3'),
        a: this.$t('faq3answer')
      }, {
        q: this.$t('faq4'),
        a: this.$t('faq4answer')
      }, {
        q: this.$t('faq5'),
        a: this.$t('faq5answer')
      }]
    };
  },

  methods: {
    toggle: function toggle(i) {
      this.active = this.active === i ? null : i;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-742cf134","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FaqAccordion.vue
var FaqAccordion_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"cp-faq"},[_c('h2',{staticClass:"cp-section-title"},[_vm._v(_vm._s(_vm.$t('faq')))]),_vm._v(" "),_vm._l((_vm.faqList),function(item,i){return _c('div',{key:i,staticClass:"cp-faq-item",class:{ active: _vm.active === i }},[_c('div',{staticClass:"cp-faq-q",on:{"click":function($event){_vm.toggle(i)}}},[_vm._v("\n      "+_vm._s(item.q)+"\n      "),_c('span',[_vm._v(_vm._s(_vm.active === i ? '-' : '+'))])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.active === i),expression:"active === i"}],staticClass:"cp-faq-a"},[_vm._v("\n        "+_vm._s(item.a)+"\n      ")])])],1)})],2)}
var FaqAccordion_staticRenderFns = []
var FaqAccordion_esExports = { render: FaqAccordion_render, staticRenderFns: FaqAccordion_staticRenderFns }
/* harmony default export */ var components_FaqAccordion = (FaqAccordion_esExports);
// CONCATENATED MODULE: ./src/components/FaqAccordion.vue
function FaqAccordion_injectStyle (ssrContext) {
  __webpack_require__("7c9T")
}
var FaqAccordion_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var FaqAccordion___vue_template_functional__ = false
/* styles */
var FaqAccordion___vue_styles__ = FaqAccordion_injectStyle
/* scopeId */
var FaqAccordion___vue_scopeId__ = "data-v-742cf134"
/* moduleIdentifier (server only) */
var FaqAccordion___vue_module_identifier__ = null
var FaqAccordion_Component = FaqAccordion_normalizeComponent(
  FaqAccordion,
  components_FaqAccordion,
  FaqAccordion___vue_template_functional__,
  FaqAccordion___vue_styles__,
  FaqAccordion___vue_scopeId__,
  FaqAccordion___vue_module_identifier__
)

/* harmony default export */ var src_components_FaqAccordion = (FaqAccordion_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














window.PointerEvent = undefined;

// ⭐ 模块级变量
var indexScrollY = 0;

/* harmony default export */ var pages = ({
  name: 'index',
  components: {
    MyHeader: header["a" /* default */],
    MyLoading: components_base_loadingThreePoints,
    HeroCarousel: src_components_HeroCarousel,
    CouponsRow: src_components_CouponsRow,
    BestSellerGrid: src_components_BestSellerGrid,
    RecommendScroller: src_components_RecommendScroller,
    ReviewGallery: src_components_ReviewGallery,
    FaqAccordion: src_components_FaqAccordion,
    SiteFooter: SiteFooter["a" /* default */]
  },

  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.$nextTick(function () {
        window.scrollTo(0, indexScrollY || 0);
      });
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    indexScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    next();
  },


  watch: {
    currentCategoryId: function currentCategoryId(newVal, oldVal) {
      if (newVal === 550 && oldVal !== 550) {
        this.fetchBestSellers();
        this.fetchRecommend();
      }
    }
  },

  mounted: function mounted() {
    if (this.currentCategoryId === 550) {
      this.fetchBestSellers();
      this.fetchRecommend();
    }

    this.$nextTick(function () {
      var video = document.querySelector('.intro-video');
      if (video) {
        video.muted = true;
        video.volume = 0;
      }
    });

    window.addEventListener('scroll', this.handleWindowScroll, {
      passive: true
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleWindowScroll);
  },
  data: function data() {
    return {
      // Index 不需要存储汇率表了，直接读取 Storage
      loadMoreThreshold: 200,
      showXmasPopup: false,
      copiedIndex: null,
      loadTimer: null,
      bestSellers: [],
      recommendList: [],
      isBestLoading: false,
      isRecLoading: false,
      slidePosition: 120,
      showFreeNotice: false,
      currentCategory: 'Popular',
      currentCategoryId: 550,
      categories: [{ name: this.$t('categoryPopular'), id: 550 }, { name: this.$t('categoryCustom'), id: 603, showHot: true }, { name: this.$t('categoryFat'), id: 600 }, { name: this.$t('categorySlim'), id: 601 }, { name: this.$t('categoryMini'), id: 602 }],
      isIndexPage: true,
      pagination: {
        params: { start: 1, max: 15, categoryId: 550 },
        total: 999
      },
      searchPagination: {
        params: { start: 1, max: 15, q: '' },
        total: 999
      },
      isScrollLoading: false,
      showAdBanner: false,
      isFirstLoading: true,
      noMoreProducts: false,
      products: [],
      placeholderImg: ''
    };
  },
  created: function created() {
    this.fetch();
    bus["a" /* default */].$on('reload-product', this.fetch);
  },


  methods: {
    // ✅ 关键方法：读取 Storage 并强制 .99
    formatPrice: function formatPrice(basePrice) {
      if (basePrice === null || basePrice === undefined) return '';

      var currency = localStorage.getItem('currency') || 'EUR';
      // 如果读取不到汇率，默认是 1
      var rate = parseFloat(localStorage.getItem('currencyRate')) || 1;

      var finalPrice = basePrice * rate;

      // 强制以 .99 结尾的逻辑
      // 只有当不是基础货币(EUR)时才处理？或者全部处理？
      // 根据您的描述“换算成其他币种的时候”，我这里加了判断。
      // 如果您希望欧元也变 .99，请删掉 `if (currency !== 'EUR')`
      if (currency !== 'EUR') {
        finalPrice = Math.floor(finalPrice) + 0.99;
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        // 强制 2 位小数，确保 .99 即使在日元下也能显示
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(finalPrice);
    },
    closeXmasPopup: function closeXmasPopup() {
      this.showXmasPopup = false;
    },
    copyCode: function copyCode(code, index) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.clipboard.writeText(code);

              case 3:
                _this.copiedIndex = index;
                setTimeout(function () {
                  return _this.copiedIndex = null;
                }, 1000);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                alert('Copied: ' + code);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    fetchBestSellers: function fetchBestSellers() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var res;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isBestLoading = true;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios(_this2.ApiList.productPage, {
                  params: { categoryId: 650, max: 8, start: 1 }
                });

              case 4:
                res = _context2.sent;

                _this2.bestSellers = res && res.data && res.data.products ? res.data.products : [];
                _context2.next = 11;
                break;

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2['catch'](1);

                console.error('BestSellers load error', _context2.t0);

              case 11:
                _context2.prev = 11;

                _this2.isBestLoading = false;
                return _context2.finish(11);

              case 14:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 8, 11, 14]]);
      }))();
    },
    fetchRecommend: function fetchRecommend() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var res;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isRecLoading = true;
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.$axios(_this3.ApiList.productPage, {
                  params: { categoryId: 651, max: 6, start: 1 }
                });

              case 4:
                res = _context3.sent;

                _this3.recommendList = res && res.data && res.data.products ? res.data.products : [];
                _context3.next = 11;
                break;

              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3['catch'](1);

                console.error('Recommend load error', _context3.t0);

              case 11:
                _context3.prev = 11;

                _this3.isRecLoading = false;
                return _context3.finish(11);

              case 14:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 8, 11, 14]]);
      }))();
    },
    handleWindowScroll: function handleWindowScroll() {
      var _this4 = this;

      if (this.currentCategoryId === 550) return;
      if (this.isScrollLoading || this.noMoreProducts) return;

      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
      var windowHeight = window.innerHeight || document.documentElement.clientHeight || 0;
      var docHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0;

      var distanceToBottom = docHeight - (scrollTop + windowHeight);

      if (distanceToBottom < this.loadMoreThreshold) {
        clearTimeout(this.loadTimer);
        this.loadTimer = setTimeout(function () {
          if (!_this4.isScrollLoading && !_this4.noMoreProducts) {
            _this4.loadMore();
          }
        }, 80);
      }
    },
    showDetail: function showDetail(id) {
      this.$router.push({ path: '/product/' + id });
    },
    showKR: function showKR() {
      window.location.href = 'https://www.kissyrose.com';
    },
    loadMore: function loadMore() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var res, data;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(_this5.isScrollLoading || _this5.noMoreProducts)) {
                  _context4.next = 2;
                  break;
                }

                return _context4.abrupt('return');

              case 2:
                _this5.isScrollLoading = true;
                _context4.prev = 3;

                if (!_this5.isIndexPage) {
                  _context4.next = 12;
                  break;
                }

                _context4.next = 7;
                return _this5.$axios(_this5.ApiList.productPage, {
                  params: _this5.pagination.params
                });

              case 7:
                res = _context4.sent;
                data = res.data;

                if (Array.isArray(data.products) && data.products.length > 0) {
                  _this5.products = _this5.products.concat(data.products);
                  _this5.pagination.total = data.count || _this5.pagination.total;
                  if (_this5.products.length >= _this5.pagination.total) {
                    _this5.noMoreProducts = true;
                  } else {
                    _this5.pagination.params.start++;
                  }
                } else {
                  _this5.noMoreProducts = true;
                }
                _context4.next = 14;
                break;

              case 12:
                _context4.next = 14;
                return _this5.fetchBySearch('scroll');

              case 14:
                _context4.next = 19;
                break;

              case 16:
                _context4.prev = 16;
                _context4.t0 = _context4['catch'](3);

                console.log('loadMore error:', _context4.t0);

              case 19:
                _context4.prev = 19;

                _this5.isScrollLoading = false;
                return _context4.finish(19);

              case 22:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[3, 16, 19, 22]]);
      }))();
    },
    searchByCategory: function searchByCategory(category, e) {
      if (this.currentCategoryId === category.id) {
        return;
      }

      this.currentCategory = category.name;
      this.currentCategoryId = category.id;

      var slideOffsetLeft = e.target.offsetLeft;
      var slideScrollLeft = jquery_default()('.category-nav').scrollLeft();
      var fixedLeft = slideScrollLeft + this.slidePosition;

      if (slideOffsetLeft > fixedLeft) {
        var toScroll = slideOffsetLeft - fixedLeft;
        jquery_default()('.category-nav').animate({ scrollLeft: slideScrollLeft + toScroll + 'px' }, 200);
      } else {
        var _toScroll = fixedLeft - slideOffsetLeft;
        jquery_default()('.category-nav').animate({ scrollLeft: slideScrollLeft - _toScroll + 'px' }, 200);
      }

      this.pagination.params.start = 1;
      this.noMoreProducts = false;
      this.products = [];

      if (category.id && category.id > 0) {
        this.pagination.params.categoryId = category.id;
      } else {
        this.pagination.params.categoryId = null;
      }

      this.$nextTick(function () {
        window.scrollTo(0, 0);
      });

      this.fetch();
    },
    goDetail: function goDetail() {
      this.$router.push({ path: '/product/999' });
    },
    fetch: function fetch() {
      var _this6 = this;

      if (this.currentCategoryId === 550) {
        this.isFirstLoading = false;
        this.isIndexPage = true;
        return;
      }

      this.isFirstLoading = true;
      this.products = [];

      if (this.$route.name !== 'Browse') {
        this.isIndexPage = false;
        this.searchPagination.params.q = this.$route.params.text;
        this.fetchBySearch('first');
      } else {
        if (this.pagination.params.categoryId && this.pagination.params.categoryId === 300) {
          this.showFreeNotice = true;
        } else {
          this.showFreeNotice = false;
        }

        this.isIndexPage = true;

        this.$axios(this.ApiList.productPage, {
          params: this.pagination.params
        }).then(function (res) {
          var data = res.data;
          _this6.isFirstLoading = false;
          _this6.products = _this6.products.concat(data.products);
          _this6.pagination.total = data.count;
          if (_this6.products.length >= _this6.pagination.total) {
            _this6.noMoreProducts = true;
          } else {
            _this6.pagination.params.start++;
          }
        }).catch(function (err) {
          _this6.isFirstLoading = false;
          console.log(err);
        });
      }
    },
    fetchBySearch: function fetchBySearch(type) {
      var _this7 = this;

      this.$axios.post(this.ApiList.search, lib_default.a.stringify(this.searchPagination.params)).then(function (res) {
        if (type === 'first') {
          _this7.isFirstLoading = false;
        } else {
          _this7.isScrollLoading = false;
        }

        if (res.data.products) {
          if (type === 'first') {
            _this7.products = res.data.products;
          } else {
            _this7.products = _this7.products.concat(res.data.products);
          }

          if (res.data.products.length === res.data.count) {
            _this7.noMoreProducts = true;
          } else {
            _this7.noMoreProducts = false;
            _this7.searchPagination.params.start++;
          }
        } else {
          _this7.noMoreProducts = true;
        }
      }).catch(function (err) {
        console.log('search err', err);
        if (type === 'first') {
          _this7.isFirstLoading = false;
        } else {
          _this7.isScrollLoading = false;
        }
        _this7.$toast({
          message: err.data && err.data.msg,
          position: 'middle'
        });
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49751630","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
var pages_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-page"},[_c('my-header'),_vm._v(" "),_c('ul',{directives:[{name:"show",rawName:"v-show",value:(_vm.isIndexPage),expression:"isIndexPage"}],staticClass:"category-nav"},_vm._l((_vm.categories),function(item){return _c('li',{key:item.id,staticClass:"category-name",class:{ selected: _vm.currentCategory === item.name },on:{"click":function($event){_vm.searchByCategory(item, $event)}}},[_vm._v("\n      "+_vm._s(item.name)+"\n      "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(item.showHot),expression:"item.showHot"}],attrs:{"src":__webpack_require__("MZ1S"),"width":"20px","height":"20px"}})])})),_vm._v(" "),(_vm.currentCategoryId === 550)?_c('div',{staticClass:"popular-content"},[_c('HeroCarousel'),_vm._v(" "),_c('div',{staticClass:"cp-freeship-banner"},[_vm._v("\n      🌎 "+_vm._s(_vm.$t('freeShippingTips'))+" ✨\n    ")]),_vm._v(" "),_c('CouponsRow'),_vm._v(" "),_c('BestSellerGrid',{attrs:{"list":_vm.bestSellers}}),_vm._v(" "),_c('RecommendScroller',{attrs:{"list":_vm.recommendList}}),_vm._v(" "),_c('ReviewGallery'),_vm._v(" "),_c('FaqAccordion'),_vm._v(" "),_c('site-footer',{staticClass:"local-footer"})],1):_c('div',{staticClass:"scroll-view"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentCategoryId !== 550),expression:"currentCategoryId !== 550"}],staticClass:"mobile-page-content ui-content",attrs:{"data-role":"content","role":"main"}},[(_vm.products.length !== 0)?_c('div',{staticClass:"mobile-page-state-content"},[_c('div',{staticClass:"mobile-feed-page"},[_c('div',{staticClass:"mobile-feed-container-show"},_vm._l((_vm.products),function(product){return _c('div',{key:product.id,staticClass:"mobile-feed-item",on:{"click":function($event){_vm.showDetail(product.id)}}},[_c('div',{staticClass:"feed-card"},[_c('div',{staticClass:"cp-img-wrapper"},[_c('img',{staticClass:"feed-image",attrs:{"src":product.mainImage || _vm.placeholderImg,"alt":product.name}}),_vm._v(" "),([2500, 2460, 2461].includes(product.id))?_c('span',{staticClass:"cp-badge"},[_vm._v("\n                    Custom Link\n                  ")]):_vm._e()]),_vm._v(" "),_c('h3',{staticClass:"feed-title",style:({
                    display: '-webkit-box',
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: 'vertical',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                  })},[_vm._v("\n                  "+_vm._s(product.name || 'Custom Cat Squishy')+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"feed-price"},[_c('span',{staticClass:"current-price"},[_vm._v("\n                    "+_vm._s(_vm.formatPrice(product.productPrice))+"\n                  ")]),_vm._v(" "),(product.originalPrice)?_c('span',{staticClass:"old-price"},[_vm._v("\n                    "+_vm._s(_vm.formatPrice(product.originalPrice))+"\n                  ")]):_vm._e()])])])})),_vm._v(" "),_c('div',{staticClass:"mobile-infinite-scroll-footer"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isScrollLoading),expression:"isScrollLoading"}],staticClass:"footer-loading-view"},[_c('img',{staticClass:"footer-loading-spinner",attrs:{"src":__webpack_require__("yg1H")}}),_vm._v("\n              Loading\n            ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.noMoreProducts),expression:"noMoreProducts"}],staticClass:"footer-no-more-view"},[_vm._v("\n              No more items\n            ")])])])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.products.length === 0 && !_vm.isFirstLoading)?_c('div',{staticClass:"mobile-page-state-no-items"},[_vm._v("\n        No products found\n      ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mobile-page-state-error default-hide",staticStyle:{"display":"none"}},[_vm._v("\n        Error loading\n      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFirstLoading),expression:"isFirstLoading"}],staticClass:"circle-loading"},[_c('mt-spinner',{attrs:{"type":"snake","color":"#8dd9bf","size":60}})],1)])]),_vm._v(" "),(_vm.showXmasPopup)?_c('div',{staticClass:"xmas-popup-overlay",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.closeXmasPopup($event)}}},[_c('div',{staticClass:"xmas-popup-content"},[_c('button',{staticClass:"close-btn",on:{"click":_vm.closeXmasPopup}},[_vm._v("×")]),_vm._v(" "),_c('div',{staticClass:"xmas-header"},[_vm._v("\n        🎆 "+_vm._s(_vm.$t('christmasOffer'))+" 🎆\n      ")]),_vm._v(" "),_c('div',{staticClass:"discount-highlight"},[_vm._v("20% OFF")]),_vm._v(" "),_c('div',{staticClass:"xmas-body"},[_c('p',{staticClass:"instruction"},[_vm._v(_vm._s(_vm.$t('christmasOfferCopy'))+":")]),_vm._v(" "),_c('div',{staticClass:"xmas-code",on:{"click":function($event){_vm.copyCode('2026', 0)}}},[_vm._v("\n          2026\n          "),(_vm.copiedIndex === 0)?_c('div',{staticClass:"copied-bubble"},[_vm._v("Copied!")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"xmas-info"},[_c('p',[_vm._v(_vm._s(_vm.$t('christmasOfferCondition')))])])])])]):_vm._e()],1)}
var pages_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mobile-page-state-loading",staticStyle:{"display":"none"}},[_c('div',{staticClass:"page-state-loading-icon"}),_vm._v("\n        Loading\n      ")])}]
var pages_esExports = { render: pages_render, staticRenderFns: pages_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages = (pages_esExports);
// CONCATENATED MODULE: ./src/pages/index.vue
function pages_injectStyle (ssrContext) {
  __webpack_require__("hfyF")
}
var pages_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var pages___vue_template_functional__ = false
/* styles */
var pages___vue_styles__ = pages_injectStyle
/* scopeId */
var pages___vue_scopeId__ = "data-v-49751630"
/* moduleIdentifier (server only) */
var pages___vue_module_identifier__ = null
var pages_Component = pages_normalizeComponent(
  pages,
  selectortype_template_index_0_src_pages,
  pages___vue_template_functional__,
  pages___vue_styles__,
  pages___vue_scopeId__,
  pages___vue_module_identifier__
)

/* harmony default export */ var src_pages = (pages_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/headerProductDetails.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var headerProductDetails = ({
  name: 'header',

  data: function data() {
    var _this = this;

    return {
      showLangSheet: false,
      showCurrencySheet: false,
      currentCurrency: localStorage.getItem('currency') || 'EUR',
      // ✅ 币种列表：名称已清理 (去掉重复符号)，汇率更新至 2025.12
      currencyActions: [
      // --- 核心币种 ---
      { code: 'EUR', name: 'Euro', symbol: '€', rate: 1.0 }, { code: 'USD', name: 'US Dollar', symbol: '$', rate: 1.16 }, { code: 'GBP', name: 'British Pound', symbol: '£', rate: 0.87 }, { code: 'SAR', name: 'Saudi Riyal', symbol: 'SR', rate: 4.35 }, { code: 'AED', name: 'UAE Dirham', symbol: 'AED', rate: 4.27 },

      // --- 美洲 ---
      { code: 'CAD', name: 'Canadian Dollar', symbol: 'C$', rate: 1.61 }, { code: 'MXN', name: 'Mexican Peso', symbol: '$', rate: 21.18 }, { code: 'COP', name: 'Colombian Peso', symbol: '$', rate: 4425.0 }, { code: 'BRL', name: 'Brazilian Real', symbol: 'R$', rate: 6.19 },

      // --- 亚洲 & 中东 ---
      { code: 'INR', name: 'Indian Rupee', symbol: '₹', rate: 104.55 }, { code: 'PHP', name: 'Philippine Peso', symbol: '₱', rate: 68.73 }],
      isFading: false,
      currentLang: localStorage.getItem('lang') || 'en',
      langActions: [{ name: 'English', method: function method() {
          return _this.changeLang('en');
        } }, { name: 'Deutsch', method: function method() {
          return _this.changeLang('de');
        } }, { name: 'Español', method: function method() {
          return _this.changeLang('es');
        } }, { name: 'Français', method: function method() {
          return _this.changeLang('fr');
        } }],
      isCartZoom: false,
      cartCount: null
    };
  },


  methods: {
    changeCurrency: function changeCurrency(code) {
      var selectedCurrency = this.currencyActions.find(function (c) {
        return c.code === code;
      });
      var rate = selectedCurrency ? selectedCurrency.rate : 1;

      localStorage.setItem('currency', code);
      localStorage.setItem('currencyRate', rate);

      this.currentCurrency = code;
      this.showCurrencySheet = false;
      this.isFading = true;
      setTimeout(function () {
        window.location.reload();
      }, 250);
    },
    changeLang: function changeLang(lang) {
      localStorage.setItem('lang', lang);
      this.currentLang = lang;
      this.showLangSheet = false;
      this.isFading = true;
      setTimeout(function () {
        window.location.reload();
      }, 250);
    },
    signIn: function signIn() {
      this.$router.push({ path: '/login' });
    },
    fetch: function fetch() {
      var _this2 = this;

      this.$axios(this.ApiList.cart).then(function (response) {
        var cartInfo = response.data.carts;
        var total = 0;
        for (var i = 0; i < cartInfo.cartItems.length; i++) {
          total += cartInfo.cartItems[i].quantity;
        }
        _this2.cartCount = total;
      }).catch(function (err) {
        console.log(err);
      });
    },
    goCart: function goCart() {
      this.$router.push({ path: '/cart' });
    },
    goBack: function goBack() {
      this.$router.push({ path: '/' });
    }
  },

  watch: {
    showLangSheet: function showLangSheet(val) {
      var tg = document.querySelector('.telegram-btn');
      var wa = document.querySelector('.whatsapp-btn');
      if (tg) tg.style.visibility = val ? 'hidden' : 'visible';
      if (wa) wa.style.visibility = val ? 'hidden' : 'visible';
    },

    // ✅ 监听币种弹窗：隐藏悬浮的 Telegram/WhatsApp 按钮
    showCurrencySheet: function showCurrencySheet(val) {
      var tg = document.querySelector('.telegram-btn');
      var wa = document.querySelector('.whatsapp-btn');
      if (tg) tg.style.visibility = val ? 'hidden' : 'visible';
      if (wa) wa.style.visibility = val ? 'hidden' : 'visible';
    }
  },

  created: function created() {
    var _this3 = this;

    if (!localStorage.getItem('currencyRate')) {
      var current = this.currencyActions.find(function (c) {
        return c.code === _this3.currentCurrency;
      });
      var rate = current ? current.rate : 1;
      localStorage.setItem('currencyRate', rate);
    }

    if (!localStorage.getItem('lang')) {
      var navLang = navigator.language.toLowerCase();
      if (navLang.includes('fr')) {
        this.changeLang('fr');
      } else if (navLang.includes('de')) {
        this.changeLang('de');
      } else if (navLang.includes('es')) {
        this.changeLang('es');
      } else {
        this.changeLang('en');
      }
    }

    this.fetch();

    bus["a" /* default */].$on('cart-refresh', function () {
      _this3.fetch();
    });
    bus["a" /* default */].$on('cart-zoom', function () {
      _this3.isCartZoom = true;
      setTimeout(function () {
        _this3.isCartZoom = false;
      }, 2000);
    });
  },


  computed: {
    isLogin: function isLogin() {
      return this.$store.getters.getLoginStatus;
    },
    pageTitle: function pageTitle() {
      var key = 'header' + this.$route.name;
      var translated = this.$t ? this.$t(key) : key;
      if (translated === key) {
        return this.$route.name;
      }
      return translated;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d085f82","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerProductDetails.vue
var headerProductDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"parentDiv"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFading),expression:"isFading"}],staticClass:"fade-layer"},[_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"detail-header",attrs:{"id":"header"}},[_c('div',{staticClass:"menu"},[_c('div',{staticClass:"go-back-button",on:{"click":_vm.goBack}}),_vm._v(" "),_c('div',{staticClass:"page-name"},[_vm._v("\n        "+_vm._s(_vm.pageTitle)+"\n      ")])]),_vm._v(" "),_c('ul',{staticClass:"right-btn"},[_c('li',{staticClass:"currency-button-container",on:{"click":function($event){_vm.showCurrencySheet = true}}}),_vm._v(" "),_c('li',{staticClass:"lang-button-container inline-block",on:{"click":function($event){_vm.showLangSheet = true}}}),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLogin),expression:"isLogin"}],staticClass:"cart-button-container inline-block",class:{ 'bounce': _vm.isCartZoom },on:{"click":_vm.goCart}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.cartCount !== 0),expression:"cartCount !== 0"}],staticClass:"cart-quantity"},[_vm._v(_vm._s(_vm.cartCount))])])])]),_vm._v(" "),(_vm.showLangSheet)?_c('div',{staticClass:"lang-overlay",on:{"click":function($event){_vm.showLangSheet = false}}},[_c('div',{staticClass:"lang-panel",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"lang-title"},[_vm._v("Select Language")]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('en')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇬🇧")]),_vm._v(" "),_c('span',[_vm._v("English")])]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('de')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇩🇪")]),_vm._v(" "),_c('span',[_vm._v("Deutsch")])]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('fr')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇫🇷")]),_vm._v(" "),_c('span',[_vm._v("Français")])]),_vm._v(" "),_c('div',{staticClass:"lang-item",on:{"click":function($event){_vm.changeLang('es')}}},[_c('span',{staticClass:"flag"},[_vm._v("🇪🇸")]),_vm._v(" "),_c('span',[_vm._v("Español")])]),_vm._v(" "),_c('div',{staticClass:"lang-cancel",on:{"click":function($event){_vm.showLangSheet = false}}},[_vm._v("\n        Cancel\n      ")])])]):_vm._e(),_vm._v(" "),(_vm.showCurrencySheet)?_c('div',{staticClass:"lang-overlay",on:{"click":function($event){_vm.showCurrencySheet = false}}},[_c('div',{staticClass:"lang-panel",on:{"click":function($event){$event.stopPropagation();}}},[_c('div',{staticClass:"lang-title"},[_vm._v(_vm._s(_vm.$t('selectCurrency')))]),_vm._v(" "),_vm._l((_vm.currencyActions),function(item){return _c('div',{key:item.code,staticClass:"lang-item",on:{"click":function($event){_vm.changeCurrency(item.code)}}},[_c('span',{staticClass:"flag"},[_vm._v(_vm._s(item.symbol))]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.name)+" ("+_vm._s(item.code)+")")])])}),_vm._v(" "),_c('div',{staticClass:"currency-note"},[_vm._v("\n        "+_vm._s(_vm.$t('currencyChangeTips'))+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"lang-cancel",on:{"click":function($event){_vm.showCurrencySheet = false}}},[_vm._v("\n        Cancel\n      ")])],2)]):_vm._e()])}
var headerProductDetails_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loader-cat"},[_c('div',{staticClass:"loader-shadow"}),_vm._v(" "),_c('img',{attrs:{"src":"https://www.calmpurr.com/img/logo/logo-tou6.webp"}})])}]
var headerProductDetails_esExports = { render: headerProductDetails_render, staticRenderFns: headerProductDetails_staticRenderFns }
/* harmony default export */ var components_headerProductDetails = (headerProductDetails_esExports);
// CONCATENATED MODULE: ./src/components/headerProductDetails.vue
function headerProductDetails_injectStyle (ssrContext) {
  __webpack_require__("HJnX")
}
var headerProductDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var headerProductDetails___vue_template_functional__ = false
/* styles */
var headerProductDetails___vue_styles__ = headerProductDetails_injectStyle
/* scopeId */
var headerProductDetails___vue_scopeId__ = "data-v-4d085f82"
/* moduleIdentifier (server only) */
var headerProductDetails___vue_module_identifier__ = null
var headerProductDetails_Component = headerProductDetails_normalizeComponent(
  headerProductDetails,
  components_headerProductDetails,
  headerProductDetails___vue_template_functional__,
  headerProductDetails___vue_styles__,
  headerProductDetails___vue_scopeId__,
  headerProductDetails___vue_module_identifier__
)

/* harmony default export */ var src_components_headerProductDetails = (headerProductDetails_Component.exports);

// EXTERNAL MODULE: ./node_modules/swiper/dist/css/swiper.css
var swiper = __webpack_require__("v2ns");
var swiper_default = /*#__PURE__*/__webpack_require__.n(swiper);

// EXTERNAL MODULE: ./node_modules/vue-awesome-swiper/dist/vue-awesome-swiper.js
var vue_awesome_swiper = __webpack_require__("7QTg");
var vue_awesome_swiper_default = /*#__PURE__*/__webpack_require__.n(vue_awesome_swiper);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/h-video.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var h_video = ({
  name: 'h-video',
  data: function data() {
    return {
      videoShow: false,
      playerOptions: {
        playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: 'zh-CN',
        aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [{
          type: '',
          src: ''
        }],
        poster: '', // 你的封面地址 暂无
        // width: document.documentElement.clientWidth,
        notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true // 全屏按钮
        }
      }
    };
  },

  methods: {
    onloadeddata: function onloadeddata() {
      // 播放按钮样式
      var videoPlayButton = document.querySelector('.vjs-big-play-button');
      videoPlayButton.setAttribute('id', 'm-small-play-button');
    },
    cancelVideo: function cancelVideo() {
      this.$emit('on-cancel');
    },
    onError: function onError() {
      this.$emit('on-error');
    }
  },
  mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f1fe0f8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/h-video.vue
var h_video_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contest-video"},[_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",staticStyle:{"width":"inherit"},attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"loadeddata":function($event){_vm.onloadeddata($event)},"error":_vm.onError}}),_vm._v(" "),_c('span',{staticClass:"close-video",on:{"click":function($event){_vm.cancelVideo()}}},[_c('img',{attrs:{"src":__webpack_require__("G6LU")}})])],1)}
var h_video_staticRenderFns = []
var h_video_esExports = { render: h_video_render, staticRenderFns: h_video_staticRenderFns }
/* harmony default export */ var components_h_video = (h_video_esExports);
// CONCATENATED MODULE: ./src/components/h-video.vue
function h_video_injectStyle (ssrContext) {
  __webpack_require__("x0eS")
}
var h_video_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var h_video___vue_template_functional__ = false
/* styles */
var h_video___vue_styles__ = h_video_injectStyle
/* scopeId */
var h_video___vue_scopeId__ = "data-v-2f1fe0f8"
/* moduleIdentifier (server only) */
var h_video___vue_module_identifier__ = null
var h_video_Component = h_video_normalizeComponent(
  h_video,
  components_h_video,
  h_video___vue_template_functional__,
  h_video___vue_styles__,
  h_video___vue_scopeId__,
  h_video___vue_module_identifier__
)

/* harmony default export */ var src_components_h_video = (h_video_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/CouponsRowDetail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var CouponsRowDetail = ({
  name: "CouponsRowDetail",
  data: function data() {
    return {
      copiedIndex: null,
      coupons: [{ title: this.$t('couponoff5title'), desc: this.$t('couponoff5desc'), code: "OFF5" }, { title: this.$t('couponoff10title'), desc: this.$t('couponoff10desc'), code: "OFF10" }, { title: this.$t('couponoff15title'), desc: this.$t('couponoff15desc'), code: "OFF15" }]
    };
  },

  methods: {
    copy: function copy(code, idx) {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return navigator.clipboard.writeText(code);

              case 3:
                _this.copiedIndex = idx;
                setTimeout(function () {
                  return _this.copiedIndex = null;
                }, 900);
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context['catch'](0);

                alert("Copied: " + code);

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e70990c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CouponsRowDetail.vue
var CouponsRowDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cp-detail-coupons"},_vm._l((_vm.coupons),function(c,i){return _c('div',{key:i,staticClass:"cp-detail-coupon",on:{"click":function($event){_vm.copy(c.code, i)}}},[_c('div',{staticClass:"cp-main"},[_c('div',{staticClass:"cp-title"},[_vm._v(_vm._s(c.title))]),_vm._v(" "),_c('div',{staticClass:"cp-code"},[_vm._v(_vm._s(_vm.$t('code'))+": "+_vm._s(c.code))]),_vm._v(" "),_c('div',{staticClass:"cp-desc"},[_vm._v(_vm._s(c.desc))])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(_vm.copiedIndex === i)?_c('div',{staticClass:"cp-toast"},[_vm._v("\n        Copied!\n      ")]):_vm._e()])],1)}))}
var CouponsRowDetail_staticRenderFns = []
var CouponsRowDetail_esExports = { render: CouponsRowDetail_render, staticRenderFns: CouponsRowDetail_staticRenderFns }
/* harmony default export */ var components_CouponsRowDetail = (CouponsRowDetail_esExports);
// CONCATENATED MODULE: ./src/components/CouponsRowDetail.vue
function CouponsRowDetail_injectStyle (ssrContext) {
  __webpack_require__("/SUS")
}
var CouponsRowDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var CouponsRowDetail___vue_template_functional__ = false
/* styles */
var CouponsRowDetail___vue_styles__ = CouponsRowDetail_injectStyle
/* scopeId */
var CouponsRowDetail___vue_scopeId__ = "data-v-e70990c0"
/* moduleIdentifier (server only) */
var CouponsRowDetail___vue_module_identifier__ = null
var CouponsRowDetail_Component = CouponsRowDetail_normalizeComponent(
  CouponsRowDetail,
  components_CouponsRowDetail,
  CouponsRowDetail___vue_template_functional__,
  CouponsRowDetail___vue_styles__,
  CouponsRowDetail___vue_scopeId__,
  CouponsRowDetail___vue_module_identifier__
)

/* harmony default export */ var src_components_CouponsRowDetail = (CouponsRowDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/productDetail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import $ from 'jquery'









var $ = function $(ele) {
  return document.querySelector(ele);
};

/* harmony default export */ var productDetail = ({

  name: 'productDetail',
  components: { MyHeader: src_components_headerProductDetails, MyLoading: components_base_loadingThreePoints, swiper: vue_awesome_swiper["swiper"], swiperSlide: vue_awesome_swiper["swiperSlide"], hVideo: src_components_h_video, CouponsRowDetail: src_components_CouponsRowDetail },
  data: function data() {
    return {
      hasVideo: false,
      hasPlayVideo: false,
      /*localCurrencyName: '',*/
      swiperOption: {
        // some swiper options/callbacks
        on: {
          slideChange: this.handleSlideChange
        }
      },
      isShow: {
        '#descr': false,
        '#ship': false,
        '#spec': false
      },
      isShowMask: false, // 是否显示购买弹出的遮罩
      popupVisible: false, // 是否显示购买成功后的商品动画
      isFirstLoading: false, // 是否首次加载（区别于滚动加载） 3个点的loading
      detail: {
        images: []
      }, // 产品详情
      colorStatus: {
        colorValues: [], // color变种
        existence: false, // 是否存在color该变种
        isShow: false, // 颜色的sku展示和隐藏
        isSelected: true, // color的子sku是否选择
        value: null // 被选中的值
      },
      sizeStatus: {
        sizeValues: [], // size变种
        existence: false, // 是否存在size该变种
        isShow: false, // 尺寸的sku展示和隐藏
        isSelected: true, // size的子sku是否选择
        value: null // 被选中的值
      },
      currentSku: {
        type: '',
        list: [],
        step: '' // 当前选择sku到第几步 begin 和 end
      }, // 当前的sku的类型
      variationsCache: {}, // 用来存储改变后的变量
      sizeColorMap: {}, // 尺寸和颜色的映射
      prodcutId: '', // 产品id
      currentImg: '', // 当前放大的图片url
      currentImgIndex: 0, // 当前图片的下标
      clientWidth: '', // 设备宽度
      dataObject: '', // data对象
      isSkuPopupShow: false // 是否显示多sku
    };
  },
  created: function created() {
    this.prodcutId = this.$route.params.id;
    this.clientWidth = document.documentElement.clientWidth + 'px';
    this.fetch();
    //this.localCurrencyName = localStorage.getItem('currency') || 'EUR';
  },

  methods: {

    // ✅ 新增：价格格式化方法 (与 Index.vue 逻辑一致)
    formatPrice: function formatPrice(basePrice) {
      if (basePrice === null || basePrice === undefined) return '';

      var currency = localStorage.getItem('currency') || 'EUR';
      var rate = parseFloat(localStorage.getItem('currencyRate')) || 1;

      var finalPrice = basePrice * rate;

      // 非欧元强制 .99 结尾
      if (currency !== 'EUR') {
        finalPrice = Math.floor(finalPrice) + 0.99;
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(finalPrice);
    },
    handleSlideChange: function handleSlideChange() {
      var swiperRef = this.$refs.mySwiper;
      if (swiperRef && swiperRef.swiper) {
        var _swiper = swiperRef.swiper;
        this.currentImgIndex = typeof _swiper.realIndex !== 'undefined' ? _swiper.realIndex : typeof _swiper.activeIndex !== 'undefined' ? _swiper.activeIndex : 0;
      }

      // 控制视频暂停
      var video = this.$refs.introVideo;
      if (video) {
        if (this.currentImgIndex === 0) {
          // 回到视频页：恢复播放
          if (video.paused) {
            console.log('[DEBUG] 重新播放视频');
            video.play().catch(function () {});
          }
        } else {
          // 滑走时暂停
          if (!video.paused) {
            console.log('[DEBUG] 离开视频页 -> 暂停播放');
            video.pause();
          }
        }
      }
    },
    hideSkuPopup: function hideSkuPopup() {
      // 隐藏sku弹窗
      this.isSkuPopupShow = false;
    },
    backToSize: function backToSize() {
      // 返回size选择的目录
      this.currentSku.step = 'begin';
      this.currentSku.type = 'size';
      this.currentSku.list = [];
      var sizeList = this.sizeStatus.sizeValues;
      for (var i = 0; i < sizeList.length; i++) {
        this.currentSku.list.push({
          size: sizeList[i]
        });
      }
    },
    selectSku: function selectSku(sku) {
      // 如果是第一步 ，那么需要跳转到第二部
      if (this.currentSku.step === 'begin') {
        this.currentSku.step = 'end';
        this.currentSku.type = 'color';
        this.sizeStatus.value = sku.size;
        console.log(sku);
        // this.currentSku.list = this.sizeColorMap[sku.size]
        // 选择某个size后: 如果某个color存在并且quantity大于0就显示价格；否则就都是中划线
        // 拼接
        // 颜色分组[red,blue,green]
        // 看看red_xs是否有这个组合，没有的话，就给他push一个quantity:0
        // 动态生成的。
        var colorValues = this.colorStatus.colorValues;
        var colorList = [];
        for (var i = 0; i < colorValues.length; i++) {
          var key = colorValues[i] + '_' + sku.size;
          if (this.variationsCache[key]) {
            colorList.push(this.variationsCache[key]);
          } else {
            colorList.push({
              color: colorValues[i],
              quantity: 0
            });
          }
        }
        this.currentSku.list = colorList;
      } else {
        // 如果是第二步 那么就先判断是否有库存 有库存的话 就将该物品加入购物车
        if (sku.quantity > 0) {
          this.currentVariation = sku;
          this.isSkuPopupShow = false;
          this.addToCart();
        }
      }
    },
    buy: function buy() {
      // 选择sku
      if (this.detail.variations && this.detail.variations.length) {
        this.isSkuPopupShow = true;
        // 2个 sku都存在
        if (this.sizeStatus.existence && this.colorStatus.existence) {
          this.currentSku.type = 'size';
          this.currentSku.step = 'begin';
          // 获取到该sku的列表 （并且进行判断 某个size后面对应的color是否包含全部）
          this.currentSku.list = [];
          var sizeList = this.sizeStatus.sizeValues;
          for (var i = 0; i < sizeList.length; i++) {
            this.currentSku.list.push({
              size: sizeList[i]
            });
          }
          // this.currentSku.list = this.detail.sizeValues
          // 或者说和pc端的一样 展示全部的颜色和sku 没有的话 就用中划线
        }
        // 只存在一个sku
        if (this.sizeStatus.existence && !this.colorStatus.existence) {
          this.currentSku.type = 'size';
          this.currentSku.step = 'end';
          // 获取到该sku的列表
          this.currentSku.list = this.detail.variations;
        }
        if (!this.sizeStatus.existence && this.colorStatus.existence) {
          this.currentSku.type = 'color';
          this.currentSku.step = 'end';
          // 获取到该sku的列表
          this.currentSku.list = this.detail.variations;
        }
      } else {
        this.addToCart();
      }
    },
    addToCart: function addToCart() {
      var _this = this;

      // 判断是否登录 没登录就去登录
      if (!this.isLogin) {
        this.$router.replace({
          path: '/login',
          query: { redirect: this.$router.currentRoute.fullPath }
        });
        return;
      }
      // 正真的进行购买
      this.isShowMask = true;
      document.body.style.overflow = 'hidden';
      // 添加到购物车接口
      // 判断是否登录
      setTimeout(function () {
        var data = {
          'productId': _this.detail.id,
          'quantity': 1 // wish是1 然后到购物车里面进行修改
        };
        if (_this.detail.variations && _this.detail.variations.length) {
          data.productAttributeId = _this.currentVariation.id;
        }
        _this.$axios.post(_this.ApiList.cartAdd, lib_default.a.stringify(data)).then(function (res) {
          // 通知头部购物车进行更新
          bus["a" /* default */].$emit('cart-refresh');
          _this.isShowMask = false;
          document.body.style.overflow = '';
          _this.popupVisible = true;
          window.setTimeout(function () {
            _this.popupVisible = false;
          }, 1500);
          //更新TK的加入购物车事件
          if (window.ttq && _this.detail) {
            try {
              window.ttq.track('AddToCart', {
                contents: [{
                  content_id: _this.detail.id,
                  content_type: "product",
                  content_name: _this.detail.name,
                  quantity: 1, // 默认添加一个
                  price: _this.detail.productPrice
                }],
                value: Number(_this.detail.productPrice), // 商品价格
                currency: _this.detail.symbol || "EUR"
              });

              console.log("TikTok Pixel AddToCart sent:", {
                content_id: _this.detail.id,
                value: _this.detail.productPrice,
                currency: _this.detail.symbol || "EUR"
              });
            } catch (e) {
              console.error("TikTok AddToCart error:", e);
            }
          }
        }).catch(function (err) {
          _this.isShowMask = false;
          document.body.style.overflow = '';
          if (!err.data.success) {
            _this.$messagebox({
              title: 'Oops!',
              message: err.data.msg,
              confirmButtonText: 'ok',
              confirmButtonHighlight: true
            });
          }
        });
      }, 500);
    },
    toggleDescr: function toggleDescr(ele) {
      this.isShow[ele] = !this.isShow[ele];
      var body = document.querySelector(ele);
      var height = body.getBoundingClientRect().height;
      if (!!height) {
        body.style.height = height + 'px';
        var f = document.body.offsetHeight; // 引起强制重绘，这样最新的样式就得到应用
        body.style.height = '0px';
      } else {
        body.style.height = 'auto';
        height = body.getBoundingClientRect().height;
        body.style.height = '0';
        var f = document.body.offsetHeight;
        // height = height > 200 ? 200 : height
        body.style.height = height + 'px';
      }
    },
    fetch: function fetch() {
      var _this2 = this;

      this.$axios(this.ApiList.productDetail + this.prodcutId).then(function (res) {
        _this2.detail = res.data.product;
        if (_this2.detail.video) {
          _this2.hasVideo = true;
        }
        if (_this2.detail.images) {
          _this2.currentImg = _this2.detail.images[0];
        } else {
          _this2.detail.images = ['https://contestimg.wish.com/api/webimage/543c8b127541ce3172f44f88-1-large.jpg', 'https://contestimg.wish.com/api/webimage/543c8b127541ce3172f44f88-2-large.jpg'];
        }
        if (!_this2.detail.mainImage) {
          _this2.detail.mainImage = 'https://contestimg.wish.com/api/webimage/562058beb92a7815fe7d3d86-large.jpg?cache_buster=a9f144ebd01cb6fe3e85dd0d73f407f5';
        }
        // 拼接sku的列表
        if (_this2.detail.variations && _this2.detail.variations.length) {
          // if (this.detail.colorValues && this.detail.colorValues.length) {
          //   this.colorStatus.existence = true
          // }
          // if (this.detail.sizeValues && this.detail.sizeValues.length) {
          //   this.sizeStatus.existence = true
          // }
          // if (this.colorStatus.existence && this.sizeStatus.existence) {
          // for (var i = 0; i < this.detail.sizeValues.length; i++) {
          //   this.sizeColorMap[this.detail.sizeValues[i]] = []
          // }
          var variations = _this2.detail.variations;
          for (var i = 0; i < variations.length; i++) {
            // this.sizeColorMap[[variations[i].size]].push(variations[i])
            // === 标准化图片字段（优先顺序：image -> img -> picUrl -> detail.mainImage） ===
            variations[i].img = variations[i].image || variations[i].img || variations[i].picUrl || _this2.detail.mainImage || '';
            var key = variations[i].color + '_' + variations[i].size;
            _this2.variationsCache[key] = variations[i];
            if (variations[i].color && _this2.colorStatus.colorValues.indexOf(variations[i].color) === -1) {
              _this2.colorStatus.colorValues.push(variations[i].color);
            }
            if (variations[i].size && _this2.sizeStatus.sizeValues.indexOf(variations[i].size) === -1) {
              _this2.sizeStatus.sizeValues.push(variations[i].size);
            }
          }
          if (_this2.colorStatus.colorValues && _this2.colorStatus.colorValues.length) {
            _this2.colorStatus.existence = true;
          }
          if (_this2.sizeStatus.sizeValues && _this2.sizeStatus.sizeValues.length) {
            _this2.sizeStatus.existence = true;
          }
          // }
        }
        //ssss
        // this.addToCart()
      }).catch(function (err) {
        console.log(err);
        if (!err.data.success) {
          _this2.$messagebox({
            title: 'Oops!',
            message: err.data.msg,
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        }
      });
    },
    onError: function onError() {
      this.hasVideo = false;
      this.hasPlayVideo = false;
    }
  },
  watch: {
    popupVisible: function popupVisible(val, oldVal) {
      // 当关闭的时候 购物车放大
      console.log(val);
      if (!val) {
        bus["a" /* default */].$emit('cart-zoom');
      }
    },
    'detail.description': function detailDescription(val) {
      var _this3 = this;

      if (val && !this.isShow['#descr']) {
        this.$nextTick(function () {
          _this3.toggleDescr('#descr');
        });
      }
    }
  },
  computed: {
    isLogin: function isLogin() {
      return this.$store.getters.getLoginStatus;
    }
  },
  mounted: function mounted() {
    var _this4 = this;

    // 尝试立即找 video
    var tryInitVideo = function tryInitVideo() {
      var video = _this4.$refs.introVideo;
      if (video && _this4.detail.video) {
        video.muted = true;
        video.defaultMuted = true;
        video.src = _this4.detail.video;
        video.load();

        var playPromise = video.play();
        if (playPromise) {
          playPromise.then(function () {
            return console.log('[DEBUG] autoplay success');
          }).catch(function (err) {
            return console.warn('[DEBUG] autoplay blocked:', err);
          });
        }
        return true;
      }
      return false;
    };

    // 第一次尝试
    if (!tryInitVideo()) {
      console.log('[DEBUG] video not found yet, start observer...');
      var observer = new MutationObserver(function () {
        if (tryInitVideo()) {
          console.log('[DEBUG] video appeared -> stop observing');
          observer.disconnect();
        }
      });
      observer.observe(this.$el, { childList: true, subtree: true });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f30927e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/productDetail.vue
var productDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_c('my-header'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFirstLoading || _vm.hasPlayVideo),expression:"!isFirstLoading || hasPlayVideo"}],staticClass:"mobile-contest-page"},[_c('div',{staticClass:"contest-image-container",style:({ height: _vm.clientWidth})},[_c('div',{staticClass:"mobile-contest-image",style:({ height: _vm.clientWidth,width: _vm.clientWidth})},[_c('div',{staticClass:"photo-slide-container",style:({ height: _vm.clientWidth, width: _vm.clientWidth})},[_c('swiper',{ref:"mySwiper",attrs:{"options":_vm.swiperOption}},[(_vm.hasVideo)?_c('swiper-slide',[_c('div',{staticClass:"video-wrapper",style:({ height: _vm.clientWidth, width: _vm.clientWidth })},[_c('video',{ref:"introVideo",staticClass:"intro-video",staticStyle:{"width":"100%","height":"100%","object-fit":"cover","border-radius":"8px"},attrs:{"src":"","autoplay":"","muted":"muted","defaultMuted":"true","loop":"","playsinline":"","webkit-playsinline":"true","x5-playsinline":"true","x-webkit-airplay":"true","preload":"auto"}})])]):_vm._e(),_vm._v(" "),_vm._l((_vm.detail.images),function(img,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"image-wrapper-cell",style:({ height: _vm.clientWidth, width: _vm.clientWidth, lineHeight: _vm.clientWidth })},[_c('img',{staticClass:"contest-imgs",style:({ maxHeight: _vm.clientWidth, maxWidth: _vm.clientWidth, lineHeight: _vm.clientWidth }),attrs:{"src":img}})])])})],2),_vm._v(" "),_vm._l((_vm.detail.images),function(img,index){return _c('swiper-slide',{key:index},[_c('div',{staticClass:"image-wrapper-cell",staticStyle:{"left":"0px"},style:({ height: _vm.clientWidth,width: _vm.clientWidth,lineHeight: _vm.clientWidth})},[_c('img',{staticClass:"contest-imgs",staticStyle:{"vertical-align":"middle","margin-bottom":"3px","height":"100%"},style:({ maxHeight: _vm.clientWidth, maxWidth: _vm.clientWidth, lineHeight: _vm.clientWidth}),attrs:{"id":"0photo-id","src":img}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.hasVideo && _vm.currentImgIndex === 1),expression:"hasVideo && currentImgIndex === 1"}],staticClass:"video-play-img"},[_c('img',{staticStyle:{"vertical-align":"middle"},attrs:{"src":__webpack_require__("iYhk")},on:{"click":function($event){_vm.playVideo()}}})])])])}),_vm._v(" "),_vm._v(" -->\n        ")],2)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasPlayVideo || _vm.currentImgIndex !== 1),expression:"!hasPlayVideo || currentImgIndex !== 1"}],staticClass:"mobile-contest-extra-photos black-pill-button"},[_c('span',{staticClass:"extra-photos-text"},[_c('span',{staticClass:"image-index"},[_vm._v(_vm._s(_vm.currentImgIndex + 1))]),_vm._v("/"+_vm._s(_vm.hasVideo ? _vm.detail.images.length + 1 : _vm.detail.images.length)+"\n        ")])])]),_vm._v(" "),_c('div',{staticClass:"mobile-contest-info-container"},[_c('div',{staticClass:"mobile-contest-info"},[_c('div',{staticClass:"mobile-contest-name"},[_vm._v("\n            "+_vm._s(_vm.detail.name)+"\n          ")])])]),_vm._v(" "),_c('CouponsRowDetail'),_vm._v(" "),_c('div',{staticClass:"mobile-contest-separator"}),_vm._v(" "),_c('div',{staticClass:"contest-product-details-container",class:{open: _vm.isShow['#descr']},on:{"click":function($event){_vm.toggleDescr('#descr')}}},[_c('span',{staticClass:"contest-product-details-text title-text"},[_vm._v("\n        "+_vm._s(_vm.$t('description'))+"\n      ")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"item-content",attrs:{"id":"descr"}},[_c('div',{staticClass:"item-detail-content",domProps:{"innerHTML":_vm._s(_vm.detail.description)}})]),_vm._v(" "),_c('div',{staticClass:"mobile-contest-separator"}),_vm._v(" "),_c('div',{staticClass:"contest-product-details-container",class:{open: _vm.isShow['#ship']},on:{"click":function($event){_vm.toggleDescr('#ship')}}},[_c('span',{staticClass:"contest-product-details-text title-text"},[_vm._v("\n        "+_vm._s(_vm.$t('shippingInfo'))+"\n      ")]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"item-content",attrs:{"id":"ship"}},[_c('div',{staticClass:"item-detail-content"},[_vm._v("\n        "+_vm._s(_vm.$t('shippingInfoDetail'))+" "),_c('br'),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"mobile-contest-separator"}),_vm._v(" "),_c('div',{staticClass:"bottom-padding-space",staticStyle:{"height":"56px","display":"block"}}),_vm._v(" "),_c('div',{staticClass:"contest-price-banner-bottom"},[_c('div',{staticClass:"contest-price"},[_c('span',{staticClass:"contest-real-price"},[_vm._v("\n          "+_vm._s(_vm.formatPrice(_vm.detail.productPrice))+"\n        ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.detail.discounted),expression:"detail.discounted"}],staticClass:"contest-retail-price"},[_vm._v("\n          "+_vm._s(_vm.formatPrice(_vm.detail.originalPrice))+"\n        ")]),_vm._v("\n        /*"),_c('span',{staticClass:"banner-currency-subscript"},[_vm._v("\n          "+_vm._s(_vm.localCurrencyName)+"\n        ")]),_vm._v("*/\n      ")]),_vm._v(" "),_c('div',{staticClass:"contest-buy-button contest-bottom-button",on:{"click":_vm.buy}},[_vm._v(_vm._s(_vm.$t('buyText')))]),_vm._v(" "),_c('div',{staticClass:"contest-sold-out-button contest-bottom-button",staticStyle:{"display":"none"}},[_vm._v("SOLD OUT")])]),_vm._v(" "),_c('div',{class:{'show-mask': _vm.isShowMask }},[_c('div',{staticClass:"mask"}),_vm._v(" "),_c('div',{staticClass:"loading"},[_c('mt-spinner',{attrs:{"type":"snake","color":"#8dd9bf","size":60}})],1)]),_vm._v(" "),_c('mt-popup',{attrs:{"position":"bottom"},model:{value:(_vm.popupVisible),callback:function ($$v) {_vm.popupVisible=$$v},expression:"popupVisible"}},[_c('div',{staticClass:"popuo-goods"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('thankyou')))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('div',{staticClass:"content-img"},[_c('img',{attrs:{"src":_vm.detail.mainImage,"height":"120","width":"120"}})]),_vm._v(" "),_c('div',{staticClass:"content-text"},[_c('div',{staticClass:"added"},[_vm._v(_vm._s(_vm.$t('addtocart')))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.detail.discounted),expression:"detail.discounted"}],staticClass:"saved"},[_vm._v(_vm._s(_vm.$t('yoursavings'))+":   "+_vm._s(_vm.formatPrice(_vm.detail.originalPrice - _vm.detail.productPrice))+"  ")])])])])]),_vm._v(" "),_c('mt-popup',{attrs:{"position":"bottom"},model:{value:(_vm.isSkuPopupShow),callback:function ($$v) {_vm.isSkuPopupShow=$$v},expression:"isSkuPopupShow"}},[_c('div',{attrs:{"id":"selectSKu"}},[_c('div',{staticClass:"sku-style",attrs:{"id":"skuTitle"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSku.step === 'end'),expression:"currentSku.step === 'end'"}],staticClass:"left-item wconfont wm-huitui",on:{"click":_vm.backToSize}}),_vm._v(" "),_c('div',{staticClass:"content"},[_vm._v("Select "+_vm._s(_vm.currentSku.type))]),_vm._v(" "),_c('div',{staticClass:"right-item wconfont wm-guanbi",on:{"click":_vm.hideSkuPopup}})]),_vm._v(" "),_c('div',{attrs:{"id":"skuContainer"}},_vm._l((_vm.currentSku.list),function(sku){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.colorStatus.existence || _vm.sizeStatus.existence),expression:"colorStatus.existence || sizeStatus.existence"}],staticClass:"sku-style",on:{"click":function($event){_vm.selectSku(sku)}}},[_c('div',{staticClass:"left-item"},[(sku.img)?_c('img',{staticClass:"sku-thumb",attrs:{"src":sku.img}}):_c('div',{staticClass:"sku-thumb placeholder"})]),_vm._v(" "),_c('div',{staticClass:"content",class:{skuless: sku.quantity <= 0, 'all-capital': _vm.currentSku.type==='size', 'first-capital': _vm.currentSku.type==='color'}},[_vm._v(_vm._s(sku[_vm.currentSku.type]))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentSku.step === 'end' && sku.quantity > 0),expression:"currentSku.step === 'end' && sku.quantity > 0"}],staticClass:"right-item price"},[_vm._v(_vm._s(_vm.formatPrice(sku.price)))])])}))])])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFirstLoading),expression:"isFirstLoading"}],staticClass:"circle-loading"},[_c('mt-spinner',{attrs:{"type":"snake","color":"#8dd9bf","size":60}})],1)],1)])}
var productDetail_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"arrow-img-container"},[_c('span',{staticClass:"arrow-icon"},[_vm._v("⌄")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"arrow-img-container"},[_c('span',{staticClass:"arrow-icon"},[_vm._v("⌄")])])}]
var productDetail_esExports = { render: productDetail_render, staticRenderFns: productDetail_staticRenderFns }
/* harmony default export */ var pages_productDetail = (productDetail_esExports);
// CONCATENATED MODULE: ./src/pages/productDetail.vue
function productDetail_injectStyle (ssrContext) {
  __webpack_require__("Of3F")
}
var productDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var productDetail___vue_template_functional__ = false
/* styles */
var productDetail___vue_styles__ = productDetail_injectStyle
/* scopeId */
var productDetail___vue_scopeId__ = "data-v-1f30927e"
/* moduleIdentifier (server only) */
var productDetail___vue_module_identifier__ = null
var productDetail_Component = productDetail_normalizeComponent(
  productDetail,
  pages_productDetail,
  productDetail___vue_template_functional__,
  productDetail___vue_styles__,
  productDetail___vue_scopeId__,
  productDetail___vue_module_identifier__
)

/* harmony default export */ var src_pages_productDetail = (productDetail_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/headerSearch.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var headerSearch = ({

  name: 'header',

  data: function data() {
    return {
      currentName: '',
      searchText: '', // 搜索内容
      searchHistory: [], // 搜索历史记录
      suggestions: [], // 搜索建议匹配
      searchActive: false // search框是否处于激活状态
    };
  },

  methods: {
    changeInputStyle: function changeInputStyle(type) {
      if (type === 'focus') {
        this.searchActive = true;
      } else {
        this.searchActive = false;
      }
    },
    autoComplete: function autoComplete(e) {
      var _this = this;

      // 请求自动补全接口
      if (e.keyCode === 13) {
        this.submit();
        return;
      }
      if (this.searchText !== '') {
        var data = {
          q: this.searchText
        };
        window.clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(function () {
          _this.$axios.post(_this.ApiList.autoComplete, lib_default.a.stringify(data)).then(function (res) {
            console.log(res);
            _this.suggestions = res.data.keywords;
          }).catch(function (err) {
            console.log(err);
          });
        }, 200);
      }
    },
    goBack: function goBack() {
      window.router = this.$router;
      this.$router.back(-1);
    },
    showMenu: function showMenu() {
      bus["a" /* default */].$emit('show-menu');
    },
    clearInput: function clearInput() {
      this.searchText = '';
    },
    searchItem: function searchItem(item) {
      // 搜索
      this.searchText = item;
      this.submit();
    },
    submit: function submit() {
      if (this.searchText === '') {
        return;
      } else {
        // search重复判断
        this.searchHistory.unshift(this.searchText);
        window.localStorage.searchHistory = stringify_default()(this.searchHistory);
        this.$router.push({ path: '/search/' + this.searchText });
      }
    }
  },
  created: function created() {
    if (window.localStorage.hasOwnProperty('searchHistory')) {
      this.searchHistory = JSON.parse(window.localStorage.searchHistory);
    }
  },

  watch: {},
  computed: {
    isLogin: function isLogin() {
      return this.$store.getters.getLoginStatus;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67f4f757","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerSearch.vue
var headerSearch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"menu"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLogin),expression:"isLogin"}],staticClass:"menu-button-container",on:{"click":_vm.showMenu}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isLogin),expression:"!isLogin"}],staticClass:"go-back-button",on:{"click":_vm.goBack}})]),_vm._v(" "),_c('ul',{staticClass:"right-btn search-mode"},[_vm._m(0),_vm._v(" "),_c('li',{staticClass:"inline-block search-input"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.searchText),expression:"searchText",modifiers:{"trim":true}}],attrs:{"type":"text","placeholder":"Search"},domProps:{"value":(_vm.searchText)},on:{"keyup":[function($event){if(!('button' in $event)&&$event.keyCode!==13){ return null; }_vm.submit($event)},function($event){_vm.autoComplete($event)}],"blur":[function($event){_vm.changeInputStyle('blur')},function($event){_vm.$forceUpdate()}],"focus":function($event){_vm.changeInputStyle('focus')},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value.trim()}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchText),expression:"searchText"}],staticClass:"cancel-button",on:{"click":_vm.clearInput}})]),_vm._v(" "),_c('li',{directives:[{name:"show",rawName:"v-show",value:(_vm.searchActive),expression:"searchActive"}],staticClass:"search-tip"},_vm._l((_vm.suggestions),function(suggest){return _c('span',{staticClass:"typeahead-autocomplete",on:{"click":function($event){_vm.searchItem(suggest)}}},[_c('span',[_vm._v(_vm._s(suggest))])])}))])])}
var headerSearch_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"search-button-container inline-block"},[_c('a',{staticClass:"search-button ui-link"})])}]
var headerSearch_esExports = { render: headerSearch_render, staticRenderFns: headerSearch_staticRenderFns }
/* harmony default export */ var components_headerSearch = (headerSearch_esExports);
// CONCATENATED MODULE: ./src/components/headerSearch.vue
function headerSearch_injectStyle (ssrContext) {
  __webpack_require__("masZ")
}
var headerSearch_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var headerSearch___vue_template_functional__ = false
/* styles */
var headerSearch___vue_styles__ = headerSearch_injectStyle
/* scopeId */
var headerSearch___vue_scopeId__ = "data-v-67f4f757"
/* moduleIdentifier (server only) */
var headerSearch___vue_module_identifier__ = null
var headerSearch_Component = headerSearch_normalizeComponent(
  headerSearch,
  components_headerSearch,
  headerSearch___vue_template_functional__,
  headerSearch___vue_styles__,
  headerSearch___vue_scopeId__,
  headerSearch___vue_module_identifier__
)

/* harmony default export */ var src_components_headerSearch = (headerSearch_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/search.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({

  name: 'search',
  components: { MyHeader: src_components_headerSearch },
  data: function data() {
    return {
      searchHistory: [] // 搜索历史
    };
  },
  created: function created() {
    if (window.localStorage.hasOwnProperty('searchHistory')) {
      this.searchHistory = JSON.parse(window.localStorage.searchHistory);
    }
  },

  methods: {
    submit: function submit(key) {
      this.$router.push({ path: '/search/' + key });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-de26ed8c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/search.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"searchPage"}},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"history-list"},_vm._l((_vm.searchHistory),function(item){return _c('li',{on:{"click":function($event){_vm.submit(item)}}},[_vm._v(_vm._s(item))])})),_vm._v(" "),(_vm.searchHistory.length === 0)?_c('div',{staticClass:"no-search-history"},[_vm._v("no search history")]):_vm._e()])],1)}
var search_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"historry"},[_vm._v("Search History")])])}]
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var pages_search = (search_esExports);
// CONCATENATED MODULE: ./src/pages/search.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("bvaf")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = "data-v-de26ed8c"
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  search,
  pages_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)

/* harmony default export */ var src_pages_search = (search_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/headerCart.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var headerCart = ({

  name: 'header',

  data: function data() {
    return {
      isCartPage: false, // 是否是cart页面 // xx按钮
      isMenu: '', // 菜单按钮
      isBack: '' // 返回按钮
    };
  },

  methods: {
    showAsideMenu: function showAsideMenu() {
      // 展示侧边按钮
      bus["a" /* default */].$emit('show-menu');
    },
    goBack: function goBack() {
      window.router = this.$router;
      this.$router.back(-1);
    },
    changeMenuBtn: function changeMenuBtn() {
      if (this.$route.name === 'Cart') {
        this.isCartPage = true;
      } else {
        this.isCartPage = false;
        if (this.$route.name === 'Settings') {
          this.isMenu = true;
          this.isBack = false;
        } else {
          if (this.$route.name !== 'ConfirmPay') {
            this.isBack = true;
            this.isMenu = false;
          }
        }
      }
    }
  },
  created: function created() {
    this.changeMenuBtn();
  },

  computed: {
    isLogin: function isLogin() {
      return this.$store.getters.getLoginStatus;
    },
    pageTitle: function pageTitle() {
      // 1. 按你说的规则拼 key：header + route.name
      var key = 'header' + this.$route.name; // 比如 route.name=Details => headerDetails

      // 2. 用你现有的 $t 去取
      //   这里假设：如果 key 不存在，$t 会原样返回 key（这是我们建议的实现方式）
      var translated = this.$t ? this.$t(key) : key;

      // 3. 如果翻译不到，就 fallback 到 route.name
      if (translated === key) {
        return this.$route.name;
      }
      return translated;
    }
  },
  watch: {
    '$route': function $route(to, from) {
      this.changeMenuBtn();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-619d2ae2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/headerCart.vue
var headerCart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"menu"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isMenu&_vm.isLogin),expression:"isMenu&isLogin"}],staticClass:"menu-button-container",on:{"click":_vm.showAsideMenu}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isCartPage),expression:"isCartPage"}],staticClass:"close-button",on:{"click":_vm.goBack}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isBack),expression:"isBack"}],staticClass:"go-back-button",on:{"click":_vm.goBack}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.$route.name !== 'notFound'),expression:"$route.name !== 'notFound'"}],staticClass:"page-name"},[_vm._v("\n       "+_vm._s(_vm.pageTitle)+"\n    ")])])])}
var headerCart_staticRenderFns = []
var headerCart_esExports = { render: headerCart_render, staticRenderFns: headerCart_staticRenderFns }
/* harmony default export */ var components_headerCart = (headerCart_esExports);
// CONCATENATED MODULE: ./src/components/headerCart.vue
function headerCart_injectStyle (ssrContext) {
  __webpack_require__("9rC8")
}
var headerCart_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var headerCart___vue_template_functional__ = false
/* styles */
var headerCart___vue_styles__ = headerCart_injectStyle
/* scopeId */
var headerCart___vue_scopeId__ = "data-v-619d2ae2"
/* moduleIdentifier (server only) */
var headerCart___vue_module_identifier__ = null
var headerCart_Component = headerCart_normalizeComponent(
  headerCart,
  components_headerCart,
  headerCart___vue_template_functional__,
  headerCart___vue_styles__,
  headerCart___vue_scopeId__,
  headerCart___vue_module_identifier__
)

/* harmony default export */ var src_components_headerCart = (headerCart_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/cart.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var pages_cart = ({

  name: 'search',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      cartInfo: {
        cartItems: [],
        totalProductPrice: ''
      },
      activeCartIndex: '', // 当前正在操作的产品
      showDialog: false, // 展现弹窗
      hasAddress: null, // 有地址，有付款方式；无地址，无付款方式；有地址，无付款方式；无地址，有付款方式
      address: {}, // 收货地址
      paymethod: '',
      stripeToken: '', // 信用卡支付的token
      errorText: '',
      showLoading: false,
      promCode: '',
      localCurrencyName: '',
      checkoutText: '' // 有checkout placeOrder 2种
    };
  },
  created: function created() {
    this.fetch();
    this.getAddress();
    this.localCurrencyName = localStorage.getItem('currency') || 'EUR';
  },
  mounted: function mounted() {
    var tg = document.querySelector('.telegram-btn');
    var wa = document.querySelector('.whatsapp-btn');
    if (tg) tg.style.visibility = 'hidden';
    if (wa) wa.style.visibility = 'hidden';
  },

  // 【新增这个方法】离开时还原
  beforeDestroy: function beforeDestroy() {
    var tg = document.querySelector('.telegram-btn');
    var wa = document.querySelector('.whatsapp-btn');
    if (tg) tg.style.visibility = 'visible';
    if (wa) wa.style.visibility = 'visible';
  },

  methods: {
    goDetail: function goDetail(productId) {
      // 访问物流详情
      this.$router.push({ path: '/product/' + productId });
    },
    formatPrice: function formatPrice(basePrice) {
      if (basePrice === null || basePrice === undefined) return '';

      var currency = localStorage.getItem('currency') || 'EUR';
      var rate = parseFloat(localStorage.getItem('currencyRate')) || 1;

      var finalPrice = basePrice * rate;

      // 非欧元强制 .99 结尾
      if (currency !== 'EUR') {
        finalPrice = Math.floor(finalPrice) + 0.99;
      }

      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: currency,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(finalPrice);
    },
    editQuantity: function editQuantity(cart, type) {
      // 改成购物车某商品数量
      var quantity = void 0;
      if (type === 'add') {
        quantity = cart.quantity + 1;
      } else {
        quantity = cart.quantity - 1;
      }
      this.changeQuantity(cart, quantity);
    },
    calProm: function calProm() {
      var _this = this;

      this.showLoading = true;
      var data = {
        promCode: this.promCode,
        price: this.cartInfo.totalProductPrice
      };
      this.$axios.post(this.ApiList.applyProm, lib_default.a.stringify(data)).then(function (res) {
        _this.showLoading = false;
        if (res.success) {
          _this.errorText = '';
          _this.cartInfo.finalPrice = res.data.after;
        } else {
          _this.errorText = res.msg;
        }
      }).catch(function (err) {
        _this.showLoading = false;
        _this.errorText = err.data.msg;
        console.log(err);
      });
    },
    fetch: function fetch() {
      var _this2 = this;

      // 获取购物车
      this.$axios(this.ApiList.cart).then(function (response) {
        _this2.cartInfo = response.data.carts;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getAddress: function getAddress() {
      var _this3 = this;

      // 获取送货地址
      this.$axios(this.ApiList.shippingAddress).then(function (response) {
        if (response.data.address.firstName) {
          _this3.hasAddress = true;
          _this3.address = response.data.address;
        } else {
          _this3.hasAddress = false;
        }
        if (response.data.paymethod) {
          _this3.paymethod = response.data.paymethod;
        }
        if (response.data.stripeToken) {
          _this3.stripeToken = response.data.stripeToken;
        }
        _this3.checkoutText = _this3.$t("placeorder");
      }).catch(function (err) {
        console.log(err);
      });
    },
    checkout: function checkout() {
      // 下单
      if (!this.hasAddress) {
        this.$router.push({ path: '/shipping' });
      } else if (!this.paymethod) {
        this.$router.push({ path: '/payment' });
      } else if (this.paymethod === 'CreditCard' && !this.stripeToken) {
        this.$router.push({ path: '/payment' });
      } else {
        this.$router.push({ name: 'pay-loading', params: { paymethod: this.paymethod, stripeToken: this.stripeToken } });
      }
    },
    changeQuantity: function changeQuantity(cart, quantity) {
      var _this4 = this;

      // 改变商品数量
      if (quantity === 0) {
        // this.$messagebox({
        //          message: `<img src="https://contestimg.wish.com/api/image/fetch?contest_id=5708c53637c447219b14ed6f&w=160&h=160&s=10" class="remove-img"/> <div class="remove-text">Remove this item from cart?</div>`,
        //          confirmButtonText: 'Remove Item',
        //          showCancelButton: true,
        //          cancelButtonText: 'cancel'
        this.$messagebox({
          message: '<img src="' + cart.image + '" class="remove-img"/> <div class="remove-text">' + this.$t("removeItemTips") + '</div>',
          confirmButtonText: this.$t("removeItem"),
          showCancelButton: true,
          cancelButtonText: this.$t("cancel")
        }).then(function (action) {
          if (action === 'confirm') {
            bus["a" /* default */].$emit('show-circle-loading', 'show');
            var _data = {
              cartItemId: cart.id
            };
            _this4.$axios.post(_this4.ApiList.cartDelete, lib_default.a.stringify(_data)).then(function (res) {
              bus["a" /* default */].$emit('show-circle-loading', 'hide');
              if (res.data.carts) {
                _this4.cartInfo = res.data.carts;
              } else {
                _this4.cartInfo = {
                  cartItems: [],
                  totalProductPrice: ''
                };
              }
            }).catch(function (err) {
              bus["a" /* default */].$emit('show-circle-loading', 'hide');
              console.log(err);
            });
          }
        });
        return;
      }
      bus["a" /* default */].$emit('show-circle-loading', 'show');
      var data = [{
        'id': cart.id,
        'quantity': quantity,
        'cartCode': cart.cartCode
      }];
      var params = {
        shoppingCartItems: stringify_default()(data)
      };
      this.$axios.post(this.ApiList.cartUpdate, lib_default.a.stringify(params)).then(function (res) {
        bus["a" /* default */].$emit('show-circle-loading', 'hide');
        _this4.cartInfo = res.data.carts;
        console.log(_this4.cartInfo);
      }).catch(function (err) {
        bus["a" /* default */].$emit('show-circle-loading', 'hide');
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6f9a1932","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cart.vue
var cart_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{staticClass:"mobile-cart-page",attrs:{"id":"cartPage"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.cartInfo.cartItems.length),expression:"cartInfo.cartItems.length"}],staticClass:"cart-item-content"},[_c('div',{staticClass:"shipment-info"},[_c('div',{staticClass:"header"},[_vm._v(_vm._s(_vm.$t('youshippinginfo')))]),_vm._v(" "),_c('router-link',{staticClass:"info-item",attrs:{"to":"/shipping","tag":"div"}},[_c('div',{staticClass:"info-item-name"},[_vm._v(_vm._s(_vm.$t('shipping')))]),_vm._v(" "),_c('div',{staticClass:"info-item-result"},[_c('span',[_vm._v(_vm._s(_vm.address.address)+" "),_c('i',{staticClass:"wconfont wm-arrow-right"})])])]),_vm._v(" "),_c('router-link',{staticClass:"info-item",attrs:{"to":"/payment","tag":"div"}},[_c('div',{staticClass:"info-item-name"},[_vm._v(_vm._s(_vm.$t('payment')))]),_vm._v(" "),_c('div',{staticClass:"info-item-result"},[_c('span',[_vm._v(_vm._s(_vm.paymethod)+" "),_c('i',{staticClass:"wconfont wm-arrow-right"})])])])],1),_vm._v(" "),_c('div',{staticClass:"cart-items-container"},_vm._l((_vm.cartInfo.cartItems),function(cart){return _c('div',{staticClass:"mobile-cart-item"},[_c('div',{attrs:{"clas":"item-details"}},[_c('div',{staticClass:"item-picture"},[_c('img',{staticClass:"cart-product-image",attrs:{"src":cart.image},on:{"click":function($event){_vm.goDetail(cart.productId)}}})]),_vm._v(" "),_c('div',{staticClass:"item-info"},[_c('div',{staticClass:"item-name"},[_vm._v("\n                "+_vm._s(cart.name)+"\n              ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(cart.color || cart.size),expression:"cart.color || cart.size"}],staticClass:"item-customization"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(cart.color),expression:"cart.color"}]},[_vm._v(_vm._s(cart.color))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(cart.size),expression:"cart.size"}]},[_vm._v("  "+_vm._s(cart.size))])]),_vm._v(" "),(cart.shippingPrice)?_c('div',{staticClass:"item-customization"},[_vm._v("\n                Shipping: "+_vm._s(_vm.cartInfo.symbol)+_vm._s(cart.shippingPrice)+"\n              ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"item-quantity"},[_c('a',{staticClass:"sub-quantity main-color wconfont wm-jian",on:{"click":function($event){_vm.editQuantity(cart, 'minus')}}}),_vm._v(" "),_c('span',{staticClass:"quantity"},[_vm._v("\n                  "+_vm._s(cart.quantity)+"\n                ")]),_vm._v(" "),_c('a',{staticClass:"add-quantity main-color wconfont wm-jia",on:{"click":function($event){_vm.editQuantity(cart, 'add')}}})])]),_vm._v(" "),_c('div',{staticClass:"item-price"},[(cart.productPrice)?_c('div',[_vm._v("\n                "+_vm._s(_vm.cartInfo.symbol)+_vm._s(cart.productPrice)+"\n              ")]):_vm._e(),_vm._v(" "),(cart.originalPrice)?_c('div',[_c('span',{staticClass:"crossed-price"},[_vm._v("\n                  "+_vm._s(_vm.cartInfo.symbol)+_vm._s(cart.originalPrice)+"\n                ")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"shipping-options"})])})),_vm._v(" "),_c('div',{staticClass:"major-divider"}),_vm._v(" "),_c('div',{staticClass:"cart-footer-container"},[_c('div',[_c('div',{staticClass:"mobile-cart-footer"},[_c('div',{staticClass:"cart-promo-container"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.promCode),expression:"promCode"}],staticClass:"promo-input",attrs:{"id":"promCode","type":"text","placeholder":_vm.$t('enterpromotioncode'),"maxlength":"20"},domProps:{"value":(_vm.promCode)},on:{"input":function($event){if($event.target.composing){ return; }_vm.promCode=$event.target.value}}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showLoading),expression:"!showLoading"}],staticClass:"clickable main-color main-color-border-color",on:{"click":_vm.calProm}},[_vm._v(_vm._s(_vm.$t('apply')))]),_vm._v(" "),_c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoading),expression:"showLoading"}],attrs:{"id":"prom-loader","src":__webpack_require__("nhJG")}})]),_vm._v(" "),_c('div',{staticClass:"row2"},[_c('div',{staticClass:"error",attrs:{"id":"errorText"}},[_vm._v(_vm._s(_vm.errorText))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('span',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.$t('itemtotal'))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.cartInfo.symbol)+" "+_vm._s(_vm.cartInfo.totalProductPrice)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row "},[_c('span',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.$t('shipping'))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.$t('freeshipping'))+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row order-total "},[_c('span',{staticClass:"label"},[_vm._v("\n                "+_vm._s(_vm.$t('ordertotal'))+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.cartInfo.symbol)+" "+_vm._s(_vm.cartInfo.finalPrice)+"\n              ")])]),_vm._v(" "),(_vm.localCurrencyName != 'EUR')?_c('div',{staticClass:"row",staticStyle:{"margin-top":"4px","color":"#999","font-size":"13px"}},[_c('span',{staticClass:"label"},[_vm._v("\n                Approx. "+_vm._s(_vm.localCurrencyName)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v("\n                "+_vm._s(_vm.formatPrice(_vm.cartInfo.finalPrice))+"\n              ")])]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"cart-footer defaulthide ui-footer ui-footer-fixed slideup ui-bar-inherit",attrs:{"data-position":"fixed","data-role":"footer","role":"contentinfo"}},[_c('div',{staticClass:"checkout-button-container"},[_c('div',{staticClass:"orange-button checkout-button touchable",on:{"click":_vm.checkout}},[_vm._v("\n            "+_vm._s(_vm.checkoutText)+"\n          ")])]),_vm._v(" "),_c('div',{staticClass:"cart-footer-cover default-hide",staticStyle:{"display":"none"}})])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.cartInfo.cartItems.length),expression:"!cartInfo.cartItems.length"}],staticClass:"cart-empty-view"},[_c('div',{staticClass:"message"},[_vm._v("\n        "+_vm._s(_vm.$t('cartisempty'))+"\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"blue-button start-shopping-button touchable default-hide",attrs:{"to":"/","tag":"div"}},[_vm._v("\n        "+_vm._s(_vm.$t('continueshopping'))+"\n      ")])],1)])],1)}
var cart_staticRenderFns = []
var cart_esExports = { render: cart_render, staticRenderFns: cart_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_cart = (cart_esExports);
// CONCATENATED MODULE: ./src/pages/cart.vue
function cart_injectStyle (ssrContext) {
  __webpack_require__("ON5F")
}
var cart_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var cart___vue_template_functional__ = false
/* styles */
var cart___vue_styles__ = cart_injectStyle
/* scopeId */
var cart___vue_scopeId__ = "data-v-6f9a1932"
/* moduleIdentifier (server only) */
var cart___vue_module_identifier__ = null
var cart_Component = cart_normalizeComponent(
  pages_cart,
  selectortype_template_index_0_src_pages_cart,
  cart___vue_template_functional__,
  cart___vue_styles__,
  cart___vue_scopeId__,
  cart___vue_module_identifier__
)

/* harmony default export */ var src_pages_cart = (cart_Component.exports);

// CONCATENATED MODULE: ./src/_common/js/validate.js
var validator = {
  email: function email(value) {
    // if (value === '') {
    //   return {
    //     status: false,
    //     errorText: 'Email field is required'
    //   }
    // }
    // let reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/
    var reg = /@([a-zA-Z0-9_-])+(\.[a-zA-Z0-9_-]+)+$/;
    if (!reg.test(value)) {
      return {
        status: false,
        errorText: 'Invalid e-mail address.'
      };
    }
    return {
      status: true
    };
  },
  zip: function zip(value) {
    if (value.length > 9) {
      return {
        status: false,
        errorText: 'Oops，zip/postal code is invalid.'
      };
    }
    var reg = /^[a-zA-Z0-9]([a-zA-Z0-9]|-|\s)+$/;
    if (!reg.test(value)) {
      return {
        status: false,
        errorText: 'Oops，zip/postal code is invalid.'
      };
    }
    return {
      status: true
    };
  }
};
/* harmony default export */ var validate = (validator);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/shipping.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var shipping = ({

  name: 'shipping',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      address: {
        firstName: '',
        lastName: '',
        address: '',
        // unit: '',
        country: '',
        state: '',
        city: '',
        zip: '',
        telephone: ''
      },
      countries: [{ code: 'AL', name: 'Albania' }, { code: 'AR', name: 'Argentina' }, { code: 'AU', name: 'Australia' }, { code: 'AT', name: 'Austria' }, { code: 'BE', name: 'Belgium' }, { code: 'BR', name: 'Brazil' }, { code: 'BG', name: 'Bulgaria' }, { code: 'CA', name: 'Canada' }, { code: 'CL', name: 'Chile' }, { code: 'CO', name: 'Colombia' }, { code: 'HR', name: 'Croatia' }, { code: 'CZ', name: 'Czech Republic' }, { code: 'DK', name: 'Denmark' }, { code: 'EC', name: 'Ecuador' }, { code: 'EG', name: 'Egypt' }, { code: 'EE', name: 'Estonia' }, { code: 'FI', name: 'Finland' }, { code: 'FR', name: 'France' }, { code: 'DE', name: 'Germany' }, { code: 'GR', name: 'Greece' }, { code: 'HU', name: 'Hungary' }, { code: 'IN', name: 'India' }, { code: 'ID', name: 'Indonesia' }, { code: 'IE', name: 'Ireland' }, { code: 'IT', name: 'Italy' }, { code: 'JP', name: 'Japan' }, { code: 'JO', name: 'Jordan' }, { code: 'LV', name: 'Latvia' }, { code: 'LI', name: 'Liechtenstein' }, { code: 'LT', name: 'Lithuania' }, { code: 'LU', name: 'Luxembourg' }, { code: 'MK', name: 'Macedonia' }, { code: 'MY', name: 'Malaysia' }, { code: 'MX', name: 'Mexico' }, { code: 'MD', name: 'Moldova' }, { code: 'MC', name: 'Monaco' }, { code: 'MA', name: 'Morocco' }, { code: 'NL', name: 'Netherlands' }, { code: 'NZ', name: 'New Zealand' }, { code: 'NO', name: 'Norway' }, { code: 'PE', name: 'Peru' }, { code: 'PH', name: 'Philippines' }, { code: 'PL', name: 'Poland' }, { code: 'PT', name: 'Portugal' }, { code: 'RO', name: 'Romania' }, { code: 'RU', name: 'Russia' }, { code: 'SA', name: 'Saudi Arabia' }, { code: 'RS', name: 'Serbia' }, { code: 'SG', name: 'Singapore' }, { code: 'SK', name: 'Slovakia' }, { code: 'SI', name: 'Slovenia' }, { code: 'KR', name: 'South Korea' }, { code: 'ES', name: 'Spain' }, { code: 'SE', name: 'Sweden' }, { code: 'CH', name: 'Switzerland' }, { code: 'TW', name: 'Taiwan' }, { code: 'TH', name: 'Thailand' }, { code: 'TR', name: 'Turkey' }, { code: 'UA', name: 'Ukraine' }, { code: 'AE', name: 'United Arab Emirates' }, { code: 'GB', name: 'United Kingdom (Great Britain)' }, { code: 'US', name: 'United States' }, { code: 'VE', name: 'Venezuela' }, { code: 'VN', name: 'Vietnam' }]
    };
  },
  created: function created() {
    this.fetch();
  },

  computed: {
    countryName: function countryName() {
      var _this = this;

      var country = this.countries.find(function (c) {
        return c.code === _this.address.country;
      });
      return country ? country.name : this.$t("country");
    }
  },
  methods: {
    fetch: function fetch() {
      var _this2 = this;

      // this.$messagebox({
      //   title: 'Are you sure?',
      //   message: 'Do you want to cancel entering your shipping info?',
      //   confirmButtonText: 'YES',
      //   showCancelButton: true,
      //   cancelButtonText: 'NO'
      // })
      this.$axios(this.ApiList.shippingAddress).then(function (response) {
        var address = response.data.address;
        if (address.firstName) {
          // this.address.firstName.value = address.firstName
          // this.address.lastName.value = address.lastName
          // this.address.address1.value = address.address
          // this.address.country.value = address.country
          // this.address.city.value = address.city
          // this.address.state.value = address.stateProvince
          // this.address.zip.value = address.postalCode
          // this.address.telephone.value = address.phone
          _this2.address.firstName = address.firstName;
          _this2.address.lastName = address.lastName;
          _this2.address.address = address.address;
          _this2.address.country = address.country;
          _this2.address.city = address.city;
          _this2.address.state = address.stateProvince;
          _this2.address.zip = address.postalCode;
          _this2.address.telephone = address.phone;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    submitAddress: function submitAddress() {
      // 提交地址
      // 验证为空
      if (this.address.firstName === '' || this.address.lastName === '' || this.address.telephone === '' || this.address.address === '' || this.address.city === '' || this.address.zip === '' || this.address.state === '' || this.address.country === '') {
        this.$messagebox({
          title: 'Oops!',
          message: 'Please provide information in all required fields',
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return;
      }
      // 验证邮编
      //let zipResult = Validator.zip(this.address.zip)
      //if (!zipResult.status) {
      //  this.$messagebox({
      //    title: 'Oops!',
      //    message: zipResult.errorText,
      //    confirmButtonText: 'ok',
      //    confirmButtonHighlight: true
      //  });
      //  return false
      //}
      var data = {
        firstName: this.address.firstName,
        lastName: this.address.lastName,
        phone: this.address.telephone,
        address: this.address.address,
        city: this.address.city,
        postalCode: this.address.zip,
        stateProvince: this.address.state,
        country: this.address.country
      };
      this.$axios.post(this.ApiList.UpdateshippingAddress, lib_default.a.stringify(data)).then(function (response) {
        console.log(response.data);
      }).catch(function (err) {
        console.log(err);
      });
      this.$router.push({ path: '/cart' });
    }
  },
  watch: {
    '$route': function $route(to, from) {
      console.log('adsf');
    }
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.address.firstName === '' || this.address.lastName === '' || this.address.telephone === '' || this.address.address === '' || this.address.city === '' || this.address.zip === '' || this.address.state === '' || this.address.country === '') {
      next(false);
      this.$messagebox({
        title: this.$t("areyousure"),
        message: this.$t("cancelshipping"),
        confirmButtonText: 'YES',
        showCancelButton: true,
        cancelButtonText: 'NO'
      }).then(function (action) {
        if (action === 'confirm') {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27f837c0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/shipping.vue
var shipping_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"shippingPage"}},[_c('div',{staticClass:"mobile-cart-shipping-page ui-page-theme-a"},[_c('div',{staticClass:"address-form"},[_c('label',{attrs:{"id":"required-text"}},[_vm._v(_vm._s(_vm.$t('signinReq')))]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address.firstName),expression:"address.firstName",modifiers:{"trim":true}}],staticClass:"full-width-input required-input",attrs:{"name":"full-name","placeholder":_vm.$t('firstName'),"type":"text"},domProps:{"value":(_vm.address.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "firstName", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address.lastName),expression:"address.lastName",modifiers:{"trim":true}}],staticClass:"full-width-input required-input",attrs:{"name":"full-name","placeholder":_vm.$t('lastName'),"type":"text"},domProps:{"value":(_vm.address.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "lastName", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address.address),expression:"address.address",modifiers:{"trim":true}}],staticClass:"full-width-input required-input",attrs:{"name":"street-address1","placeholder":_vm.$t('streetaddress'),"type":"text"},domProps:{"value":(_vm.address.address)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "address", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('table',{staticClass:"table-form-row"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"half-width-input left-cell"},[_c('div',{staticClass:"ui-select"},[_c('div',{staticClass:"ui-btn ui-icon-carat-d ui-btn-icon-right ui-corner-all ui-shadow",attrs:{"id":"select-67-button"}},[_c('span',{staticClass:"required-input country-select",attrs:{"id":"countrySelect"}},[_vm._v(_vm._s(_vm.countryName))]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.address.country),expression:"address.country"}],staticClass:"required-input country-select",attrs:{"name":"country"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.address, "country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.countries),function(c){return _c('option',{key:c.code,domProps:{"value":c.code}},[_vm._v(_vm._s(c.name))])}))])])]),_vm._v(" "),_c('td',{staticClass:"half-width-input right-cell"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address.state),expression:"address.state",modifiers:{"trim":true}}],staticClass:"state-input",attrs:{"name":"state","placeholder":_vm.$t('state'),"type":"text"},domProps:{"value":(_vm.address.state)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "state", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address.city),expression:"address.city",modifiers:{"trim":true}}],staticClass:"full-width-input required-input",attrs:{"name":"city","placeholder":_vm.$t('city'),"type":"text"},domProps:{"value":(_vm.address.city)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "city", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('table',{staticClass:"table-form-row"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"half-width-input left-cell"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address.zip),expression:"address.zip",modifiers:{"trim":true}}],staticClass:"required-input half-width-input",attrs:{"id":"zipcode","name":"zipcode","placeholder":_vm.$t('zip'),"type":"text"},domProps:{"value":(_vm.address.zip)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "zip", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('td',{staticClass:"half-width-input right-cell"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.address.telephone),expression:"address.telephone",modifiers:{"trim":true}}],staticClass:"required-input half-width-input raw_phone_number",attrs:{"name":"raw-phone-number","placeholder":_vm.$t('phone'),"type":"tel"},domProps:{"value":(_vm.address.telephone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.address, "telephone", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"cart-footer defaulthide ui-footer ui-footer-fixed slideup ui-bar-inherit"},[_c('div',{staticClass:"checkout-button-container"},[_c('div',{staticClass:"orange-button checkout-button touchable done-btn",on:{"click":_vm.submitAddress}},[_vm._v("\n              "+_vm._s(_vm.$t('done'))+"\n            ")])])])])])])],1)}
var shipping_staticRenderFns = []
var shipping_esExports = { render: shipping_render, staticRenderFns: shipping_staticRenderFns }
/* harmony default export */ var pages_shipping = (shipping_esExports);
// CONCATENATED MODULE: ./src/pages/shipping.vue
function shipping_injectStyle (ssrContext) {
  __webpack_require__("kOC9")
}
var shipping_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var shipping___vue_template_functional__ = false
/* styles */
var shipping___vue_styles__ = shipping_injectStyle
/* scopeId */
var shipping___vue_scopeId__ = "data-v-27f837c0"
/* moduleIdentifier (server only) */
var shipping___vue_module_identifier__ = null
var shipping_Component = shipping_normalizeComponent(
  shipping,
  pages_shipping,
  shipping___vue_template_functional__,
  shipping___vue_styles__,
  shipping___vue_scopeId__,
  shipping___vue_module_identifier__
)

/* harmony default export */ var src_pages_shipping = (shipping_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-stripe-elements-plus/dist/index.js
var dist = __webpack_require__("/CiQ");
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/payment.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var payment = ({

  name: 'payment',
  components: { MyHeader: src_components_headerCart, Card: dist["Card"] },
  data: function data() {
    return {
      isPayPal: false,
      isSofortPay: false,
      isCreditCard: false,
      complete: false,
      stripeOptions: {}
    };
  },
  created: function created() {
    this.fetch();
  },

  methods: {
    selectPay: function selectPay(paymethod) {
      if (paymethod === 'paypal') {
        this.isPayPal = true;
        this.isSofortPay = false;
        this.isCreditCard = false;
      } else if (paymethod === 'sofortpay') {
        this.isPayPal = false;
        this.isSofortPay = true;
        this.isCreditCard = false;
      } else if (paymethod === 'creditcard') {
        this.isPayPal = false;
        this.isSofortPay = false;
        this.isCreditCard = true;
      }
    },
    submitPay: function submitPay() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var payMethod, payToken, _ref, token, error, data;

        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                payMethod = void 0;
                payToken = void 0;

                if (!_this.isPayPal) {
                  _context.next = 6;
                  break;
                }

                payMethod = 'Paypal';
                _context.next = 31;
                break;

              case 6:
                if (!_this.isSofortPay) {
                  _context.next = 10;
                  break;
                }

                payMethod = 'Sofortpay';
                _context.next = 31;
                break;

              case 10:
                if (!_this.isCreditCard) {
                  _context.next = 29;
                  break;
                }

                payMethod = 'CreditCard';

                if (_this.complete) {
                  _context.next = 15;
                  break;
                }

                _this.$messagebox({
                  title: 'Oops!',
                  message: 'Please enter the required field.',
                  showCancelButton: true,
                  cancelButtonText: 'NO'
                });
                return _context.abrupt('return', false);

              case 15:
                _context.next = 17;
                return Object(dist["createToken"])();

              case 17:
                _ref = _context.sent;
                token = _ref.token;
                error = _ref.error;

                if (!token) {
                  _context.next = 25;
                  break;
                }

                payToken = token.id;
                console.log('token=' + payToken);
                _context.next = 27;
                break;

              case 25:
                _this.$messagebox({
                  title: 'Oops!',
                  message: error.message,
                  showCancelButton: true,
                  cancelButtonText: 'NO'
                });
                return _context.abrupt('return', false);

              case 27:
                _context.next = 31;
                break;

              case 29:
                _this.$messagebox({
                  title: 'Oops!',
                  message: 'Please select one pay method.',
                  showCancelButton: true,
                  cancelButtonText: 'NO'
                });
                return _context.abrupt('return', false);

              case 31:
                data = {
                  payMethod: payMethod,
                  stripeToken: payToken
                };


                _this.$axios.post(_this.ApiList.Updatepaymethod, lib_default.a.stringify(data)).then(function (response) {
                  console.log(response.data);
                  _this.$router.push({ path: '/cart' });
                }).catch(function (err) {
                  console.log(err);
                });

              case 33:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    fetch: function fetch() {
      var _this2 = this;

      this.$axios(this.ApiList.shippingAddress).then(function (response) {
        var paymethod = response.data.paymethod;
        if (paymethod === 'Paypal') {
          _this2.isPayPal = true;
          _this2.isSofortPay = false;
          _this2.isCreditCard = false;
        } else if (paymethod === 'Sofortpay') {
          _this2.isPayPal = false;
          _this2.isSofortPay = true;
          _this2.isCreditCard = false;
        } else if (paymethod === 'CreditCard') {
          _this2.isPayPal = false;
          _this2.isSofortPay = false;
          _this2.isCreditCard = true;
        }
      }).catch(function (err) {
        console.log(err);
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53988be4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/payment.vue
var payment_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"billingPage"}},[_c('div',{staticClass:"mobile-cart-billing-page"},[_c('ul',{attrs:{"id":"payment-header"}},[_c('li',{staticClass:"payment-option",class:{ 'selected': _vm.isPayPal },attrs:{"id":"paypal-option","tag":"div"},on:{"click":function($event){_vm.selectPay('paypal')}}},[_c('img',{staticClass:"payment-img",attrs:{"id":"paypal-img","src":__webpack_require__("2RxU")}}),_vm._v(" "),_c('i',{staticClass:"wconfont wm-Select"})]),_vm._v(" "),_c('li',{staticClass:"payment-option",class:{ 'selected': _vm.isCreditCard },attrs:{"id":"creditcard-option","tag":"div"},on:{"click":function($event){_vm.selectPay('creditcard')}}},[_c('img',{staticClass:"payment-img2",staticStyle:{"margin-left":"20%"},attrs:{"id":"credit-card-img","src":__webpack_require__("fjbu")}}),_vm._v(" "),_c('img',{staticClass:"payment-img2",attrs:{"id":"credit-card-img","src":__webpack_require__("cRZH")}}),_vm._v(" "),_c('img',{staticClass:"payment-img2",attrs:{"id":"credit-card-img","src":__webpack_require__("XD9B")}}),_vm._v(" "),_c('i',{staticClass:"wconfont wm-Select"})])]),_vm._v(" "),_c('form',{staticClass:"payment-info-form",attrs:{"id":"payment-info-form-88af3e24-e99d-4559-9ff8-69003c264f0c"}},[_c('div',{staticClass:"payment-section default-hide",staticStyle:{"display":"none"},attrs:{"id":"apple-pay-section"}}),_vm._v(" "),_c('div',{staticClass:"payment-section default-hide",staticStyle:{"display":"none"},attrs:{"id":"apple-pay-section-v2"}}),_vm._v(" "),_c('div',[(_vm.isCreditCard)?_c('div',{staticClass:"payment-section",attrs:{"data-payment-mode":"1","id":"credit-card-section"}},[_c('label',{staticClass:"section-title",attrs:{"for":"cc-number"}},[_vm._v("\n              Credit Card\n            ")]),_vm._v(" "),_c('div',{staticClass:"form-item",staticStyle:{"margin-top":"10px"}},[_c('card',{staticClass:"stripe-card",class:{ complete: _vm.complete },attrs:{"stripe":"pk_live_jez50XmOzKwHIiZ0xlrDsYR7","options":_vm.stripeOptions},on:{"change":function($event){_vm.complete = $event.complete}}})],1)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"orange-button",attrs:{"id":"nextBtn"},on:{"click":_vm.submitPay}},[_vm._v("\n         Next\n      ")])])])],1)}
var payment_staticRenderFns = []
var payment_esExports = { render: payment_render, staticRenderFns: payment_staticRenderFns }
/* harmony default export */ var pages_payment = (payment_esExports);
// CONCATENATED MODULE: ./src/pages/payment.vue
function payment_injectStyle (ssrContext) {
  __webpack_require__("3wwE")
}
var payment_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var payment___vue_template_functional__ = false
/* styles */
var payment___vue_styles__ = payment_injectStyle
/* scopeId */
var payment___vue_scopeId__ = "data-v-53988be4"
/* moduleIdentifier (server only) */
var payment___vue_module_identifier__ = null
var payment_Component = payment_normalizeComponent(
  payment,
  pages_payment,
  payment___vue_template_functional__,
  payment___vue_styles__,
  payment___vue_scopeId__,
  payment___vue_module_identifier__
)

/* harmony default export */ var src_pages_payment = (payment_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/transaction.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var transaction = ({

  name: 'transaction',
  components: { MyHeader: header["a" /* default */] },
  data: function data() {
    return {
      pagination: {
        params: {
          start: 1, // 分页
          max: 5 // pgageSize
        },
        total: null
      },
      orders: [], // 订单列表
      isLoading: false, // 是否在加载
      noMoreProducts: false // 是否没有更多的产品
    };
  },
  created: function created() {
    this.fetch();
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.loadMore);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.loadMore); // 消除滚动事件
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      this.isLoading = true;
      this.$axios(this.ApiList.orderList, {
        params: this.pagination.params
      }).then(function (res) {
        var data = res.data;
        _this.isLoading = false;
        _this.orders = _this.orders.concat(data.orders);
        _this.pagination.total = data.count;
        if (_this.orders.length >= _this.pagination.total) {
          _this.noMoreProducts = true;
        } else {
          _this.pagination.params.start++;
        }
      }).catch(function (err) {
        _this.isLoading = false;
        console.log(err);
      });
    },
    loadMore: function loadMore() {
      // 滚动加载
      var clientHeight = document.documentElement.clientHeight; // 视口宽度
      var scrollTop = document.documentElement.scrollTop;
      var scrollHeight = document.documentElement.scrollHeight;
      if (scrollHeight - (clientHeight + scrollTop) < 200 && !this.isLoading && !this.noMoreProducts) {
        this.fetch();
      }
    },
    viewDetail: function viewDetail(orderId) {
      this.$router.push({ path: '/transaction/' + orderId });
    },
    packageTrack: function packageTrack(trackId) {
      this.$router.push({ path: '/transaction/track/' + trackId });
    },
    goTo: function goTo(path) {
      this.$router.push({ path: path });
    },
    showDetail: function showDetail(proId) {
      // 展示商品详情
      this.$router.push({ path: '/product/' + proId });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1fee6dbc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/transaction.vue
var transaction_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{staticClass:"mobile-transaction-list-page",attrs:{"id":"transactionPage"}},[_c('div',{staticClass:"page-title"},[_vm._v("\n      "+_vm._s(_vm.$t('orderhistory'))+"\n    ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.pagination.total),expression:"!pagination.total"}],staticClass:"empty-view"},[_c('div',{staticClass:"empty-message"},[_vm._v("\n        "+_vm._s(_vm.$t('notorderyet'))+"\n      ")]),_vm._v(" "),_c('router-link',{staticClass:"gray-button close-button touchable",attrs:{"to":"/","tag":"div"}},[_vm._v("\n        "+_vm._s(_vm.$t('shopnow'))+"\n      ")])],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pagination.total),expression:"pagination.total"}],staticClass:"transaction-list"},[_vm._l((_vm.orders),function(order){return _c('div',{staticClass:"mobile-transaction-expanded-row"},[_c('div',{staticClass:"transaction-separator"}),_vm._v(" "),_c('div',{staticClass:"transaction-content-wrapper"},[_c('table',{staticClass:"transaction-header"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"header-text-cell"},[_c('div',{staticClass:"header-text-line-one"},[_vm._v("\n                    Order Placed:\n                  ")]),_vm._v("\n                  "+_vm._s(_vm._f("orderDate")(order.createDate))+"\n                ")]),_vm._v(" "),_c('td',{staticClass:"detail-button-cell"},[_c('div',{staticClass:"detail-button blue-button",on:{"click":function($event){_vm.viewDetail(order.id)}}},[_vm._v("\n                    Details\n                  ")])])])])]),_vm._v(" "),_c('div',{staticClass:"transaction-content-separator"}),_vm._v(" "),_c('div',{staticClass:"refund-placeholder"}),_vm._v(" "),_c('div',{staticClass:"item-list"},_vm._l((order.products),function(product){return _c('div',[_c('div',{staticClass:"mobile-transaction-expanded-row-item"},[_c('table',{staticClass:"item-info"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"product-image-container"},[_c('img',{staticClass:"product-image",attrs:{"src":product.image},on:{"click":function($event){_vm.showDetail(product.product.id)}}})]),_vm._v(" "),_c('td',{staticClass:"product-details"},[_c('table',{staticClass:"ellipsized-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"ellipsized-content product-title-text"},[_vm._v("\n                                "+_vm._s(product.name)+"\n                              ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"ellipsized-content product-sub-text"},[_vm._v("\n                                Quantity: "+_vm._s(product.quantity)+"\n                              ")])])])]),_vm._v(" "),_c('div',{staticClass:"order-information-header"},[_c('div',{staticClass:"order-state main-color"},[_vm._v("\n                            "+_vm._s(order.orderStatus)+"\n                          ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(order.orderStatus === 'delivered' || order.orderStatus === 'shipped'),expression:"order.orderStatus === 'delivered' || order.orderStatus === 'shipped'"}],staticClass:"order-tracking-number"},[_vm._v("\n                            Tracking #: "+_vm._s(order.trackNo)+"\n                          ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"contact-button blue-button",on:{"click":function($event){_vm.goTo('/contact-us')}}},[_vm._v("\n                  Contact Support\n                ")]),_vm._v(" "),(order.orderStatus === 'delivered' || order.orderStatus === 'shipped')?_c('div',{staticClass:"blue-button return-center-button",on:{"click":function($event){_vm.packageTrack(order.id)}}},[_vm._v("\n                   Where's My Package?\n                ")]):_vm._e()])])}))])])}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}],staticClass:"mobile-page-state-loading"},[_c('div',{staticClass:"page-state-loading-icon"}),_vm._v("\n        Loading\n      ")])],2)])],1)}
var transaction_staticRenderFns = []
var transaction_esExports = { render: transaction_render, staticRenderFns: transaction_staticRenderFns }
/* harmony default export */ var pages_transaction = (transaction_esExports);
// CONCATENATED MODULE: ./src/pages/transaction.vue
function transaction_injectStyle (ssrContext) {
  __webpack_require__("SkKK")
}
var transaction_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var transaction___vue_template_functional__ = false
/* styles */
var transaction___vue_styles__ = transaction_injectStyle
/* scopeId */
var transaction___vue_scopeId__ = "data-v-1fee6dbc"
/* moduleIdentifier (server only) */
var transaction___vue_module_identifier__ = null
var transaction_Component = transaction_normalizeComponent(
  transaction,
  pages_transaction,
  transaction___vue_template_functional__,
  transaction___vue_styles__,
  transaction___vue_scopeId__,
  transaction___vue_module_identifier__
)

/* harmony default export */ var src_pages_transaction = (transaction_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/track.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var track = ({

  name: 'track',
  components: { MyHeader: header["a" /* default */] },
  data: function data() {
    return {
      tid: '',
      transactionId: '',
      lc: '',
      // tid: '', // 单号
      hasTid: false, // 是否获取到了tid的值
      orderDetail: {} // 订单详情
    };
  },
  created: function created() {
    this.transactionId = this.$route.params.id;
    this.fetch();
  },

  watch: {
    hasTid: function hasTid(val, oldVal) {
      console.log(val);
      if (val) {
        this.build17Info();
      }
    }
  },
  methods: {
    fetch: function fetch() {
      var _this = this;

      this.$axios(this.ApiList.orderDetail + ('' + this.transactionId)).then(function (res) {
        _this.orderDetail = res.data.order;
        _this.tid = _this.orderDetail.trackNo;
        _this.lc = _this.orderDetail.logisticsCarrier;
        _this.hasTid = true;
      }).catch(function (err) {
        console.log(err);
      });
    },
    viewOrderDetail: function viewOrderDetail() {
      this.$router.push({ path: '/transaction/' + this.transactionId });
    },
    build17Info: function build17Info() {
      console.log("lc=" + this.lc);
      var YQV5 = window.YQV5;
      YQV5.trackSingle({
        // 必须，指定承载内容的容器ID。
        YQ_ContainerId: 'YQContainer',
        // 可选，指定查询结果高度，最大为800px，默认为560px。
        YQ_Height: 560,
        // 可选，指定运输商，默认为自动识别。
        YQ_Fc: this.lc ? this.lc : '0',
        // 可选，指定UI语言，默认根据浏览器自动识别。
        YQ_Lang: 'en',
        // 必须，指定要查询的单号。
        YQ_Num: this.tid
      });
    },
    showDetail: function showDetail(proId) {
      // 展示商品详情
      this.$router.push({ path: '/product/' + proId });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5d20bae","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/track.vue
var track_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{staticClass:"mobile-transaction-tracking",attrs:{"id":"trackPage"}},[_c('div',{staticClass:"page-title"},[_vm._v("\n      Track Package\n    ")]),_vm._v(" "),_vm._l((_vm.orderDetail.products),function(product){return _c('table',{staticClass:"item-info"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"product-image-container"},[_c('img',{staticClass:"product-image",attrs:{"src":product.image,"width":"150","height":"200"},on:{"click":function($event){_vm.showDetail(product.product.id)}}})]),_vm._v(" "),_c('td',{staticClass:"product-details"},[_c('table',{staticClass:"ellipsized-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"ellipsized-content product-title-text"},[_vm._v("\n                    "+_vm._s(product.name)+"\n                  ")])])])]),_vm._v(" "),_vm._m(0,true),_vm._v(" "),_c('table',{staticClass:"ellipsized-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"ellipsized-content product-sub-text"},[_vm._v("\n                    Quantity: "+_vm._s(product.quantity)+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"order-information-header"},[_c('div',{staticClass:"order-state main-color"},[_vm._v("\n                "+_vm._s(_vm.orderDetail.orderStatus)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"order-details"})])])])])])}),_vm._v(" "),_c('table',{staticClass:"tracking-header"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"header-text"},[_c('div',{staticClass:"tracking-line"},[_vm._v("\n              Tracking #:  "+_vm._s(_vm.orderDetail.trackNo)+"\n            ")])])])])]),_vm._v(" "),_c('div',{staticClass:"tracking-history-box",attrs:{"id":"YQContainer"}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"gray-button order-details-button touchable",on:{"click":_vm.viewOrderDetail}},[_vm._v("\n      View Order Details\n    ")]),_vm._v(" "),_c('router-link',{staticClass:"gray-button all-orders-button touchable",attrs:{"tag":"div","to":"/transaction"}},[_vm._v("\n      View All Orders\n    ")])],2)],1)}
var track_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"ellipsized-table"},[_c('tbody')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-box"},[_c('div',{staticClass:"have-questions"},[_vm._v("\n        Have Questions?\n      ")]),_vm._v("\n      If you still have questions after reading the description and information above, click here to contact support.\n    ")])}]
var track_esExports = { render: track_render, staticRenderFns: track_staticRenderFns }
/* harmony default export */ var pages_track = (track_esExports);
// CONCATENATED MODULE: ./src/pages/track.vue
function track_injectStyle (ssrContext) {
  __webpack_require__("qDMi")
}
var track_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var track___vue_template_functional__ = false
/* styles */
var track___vue_styles__ = track_injectStyle
/* scopeId */
var track___vue_scopeId__ = "data-v-b5d20bae"
/* moduleIdentifier (server only) */
var track___vue_module_identifier__ = null
var track_Component = track_normalizeComponent(
  track,
  pages_track,
  track___vue_template_functional__,
  track___vue_styles__,
  track___vue_scopeId__,
  track___vue_module_identifier__
)

/* harmony default export */ var src_pages_track = (track_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/transactionDetail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var transactionDetail = ({

  name: 'transactionDetail',
  components: { MyHeader: header["a" /* default */] },
  data: function data() {
    return {
      transactionId: '',
      emailAddress: '',
      orderDetail: { // 订单详情
        delivery: {}
      }
    };
  },
  created: function created() {
    this.transactionId = this.$route.params.tid;
    this.fetch();
  },

  methods: {
    fetch: function fetch() {
      var _this = this;

      this.$axios(this.ApiList.orderDetail + ('' + this.transactionId)).then(function (res) {
        //console.log(res)
        _this.orderDetail = res.data.order;
        _this.emailAddress = res.data.email;
        //console.log('this.orderDetail')
        //console.log(this.orderDetail)
        // ------------ TikTok 购买事件：只在支付成功页面触发 ------------
        if (_this.$route.name === 'order-confirm' && window.ttq && _this.orderDetail) {
          try {

            var order = _this.orderDetail;

            var contents = (order.products || []).map(function (item) {
              return {
                content_id: item.product.id,
                content_type: "product",
                content_name: item.name,
                quantity: item.quantity,
                price: item.price
              };
            });

            window.ttq.track('Purchase', {
              contents: contents,
              value: Number(order.totalPrice), // 订单总金额
              currency: order.symbol || "EUR" // 默认 EUR
            });

            console.log("TikTok Pixel CompletePayment sent:", {
              contents: contents,
              value: order.totalPrice,
              currency: order.symbol || "EUR"
            });
          } catch (e) {
            console.error("TikTok Pixel CompletePayment error:", e);
          }
        }
        // ==========================================================
      }).catch(function (err) {
        console.log(err);
      });
    },
    showDetail: function showDetail(proId) {
      // 展示商品详情
      this.$router.push({ path: '/product/' + proId });
    },
    packageTrack: function packageTrack(orderId) {
      // 物流详情
      this.$router.push({ path: '/transaction/track/' + orderId });
    },
    goTo: function goTo(path) {
      this.$router.push({ path: path });
    }
  },
  computed: {
    account: function account() {
      // 登录的用户名
      return this.$store.getters.getAccount;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-793be6ad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/transactionDetail.vue
var transactionDetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"transactionDetailPage"}},[_c('div',{staticClass:"mobile-transaction-detail-page mobile-transaction-detail"},[(_vm.$router.currentRoute.name === 'order-confirm')?_c('div',{staticClass:"transaction-complete"},[_c('div',{staticClass:"page-title"},[_vm._v("\n         Order Confirmed!\n       ")]),_vm._v(" "),_c('div',{staticClass:"email-container"},[_c('div',{staticClass:"email-title"},[_vm._v("\n         A confirmation email has been sent to:\n        ")]),_vm._v(" "),_c('div',{staticClass:"email-text"},[_vm._v("\n          "+_vm._s(_vm.account.email)+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"change-email"},[_c('router-link',{staticClass:"change-email-link",attrs:{"to":"/settings/change-email"}},[_vm._v(" Click here to change your email ")])],1)]),_vm._v(" "),_c('div',{staticClass:"payment-subtitle"},[_vm._v("\n         You can track your order at any time by visiting the Order History page.\n       ")]),_vm._v(" "),_c('router-link',{staticClass:"blue-button contact-button",attrs:{"to":"/","tag":"a"}},[_vm._v(" Continue Shopping ")])],1):_vm._e(),_vm._v(" "),(_vm.$router.currentRoute.name === 'transactionDetail')?_c('div',[_c('div',{staticClass:"page-title"},[_vm._v("\n          Order Details\n        ")]),_vm._v(" "),_c('div',{staticClass:"page-order-line-one"},[_vm._v("\n          Order Placed: "+_vm._s(_vm._f("orderDate")(_vm.orderDetail.createDate))+"\n        ")]),_vm._v(" "),_c('div',{staticClass:"page-order-line-two"},[_vm._v("\n          Order #: "+_vm._s(_vm.orderDetail.orderNo)+"\n        ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"detail-content"},[_c('table',{staticClass:"ship-bill-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"shipping-section"},[_c('div',{staticClass:"shipping-title"},[_vm._v("\n                  Shipping Address:\n                ")]),_vm._v(" "),_c('div',{staticClass:"shipping-address"},[_vm._v("\n                  "+_vm._s(_vm.orderDetail.delivery.firstName)+" "+_vm._s(_vm.orderDetail.delivery.lastName)+"\n                  "),_c('br'),_vm._v("\n                  "+_vm._s(_vm.orderDetail.delivery.address)+"\n                  "),_c('br'),_vm._v("\n                  "+_vm._s(_vm.orderDetail.delivery.city)+"，"+_vm._s(_vm.orderDetail.delivery.stateProvince)+" "+_vm._s(_vm.orderDetail.delivery.postalCode)+"\n                  "),_c('br'),_vm._v("\n                  "+_vm._s(_vm.orderDetail.delivery.country)+"\n                ")])])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"billing-section"},[_c('div',{staticClass:"billing-title"},[_vm._v("\n                  Payment Method:\n                ")]),_vm._v(" "),_c('div',{staticClass:"billing-text"},[_c('div',[_vm._v(_vm._s(_vm.orderDetail.paymentType))])])])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"page-subtitle"},[_vm._v("Items")]),_vm._v(" "),_c('div',{staticClass:"item-list"},_vm._l((_vm.orderDetail.products),function(product){return _c('div',{staticClass:"mobile-transaction-expanded-row-item"},[_c('table',{staticClass:"item-info"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"product-image-container"},[_c('img',{staticClass:"product-image",attrs:{"src":product.image},on:{"click":function($event){_vm.showDetail(product.product.id)}}})]),_vm._v(" "),_c('td',{staticClass:"product-details"},[_c('table',{staticClass:"ellipsized-table"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"ellipsized-content product-title-text"},[_vm._v("\n                            "+_vm._s(product.name)+"\n                          ")])]),_vm._v(" "),_c('tr',[_c('td',{staticClass:"ellipsized-content product-sub-text"},[_vm._v("\n                            Quantity: "+_vm._s(product.quantity)+"\n                          ")])])])]),_vm._v(" "),_c('div',{staticClass:"order-information-header"},[_c('div',{staticClass:"order-state main-color"},[_vm._v("\n                        "+_vm._s(_vm.orderDetail.orderStatus)+"\n                      ")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.orderDetail.orderStatus === 'delivered' || _vm.orderDetail.orderStatus === 'shipped'),expression:"orderDetail.orderStatus === 'delivered' || orderDetail.orderStatus === 'shipped'"}],staticClass:"order-tracking-number"},[_vm._v("\n                        Tracking #: "+_vm._s(_vm.orderDetail.trackNo)+"\n                      ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"price-area"},[_c('div',{staticClass:"price-text"},[_vm._v("\n                "+_vm._s(product.product.symbol)+_vm._s(product.product.productPrice)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"price-subline"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(product.size || product.color),expression:"product.size || product.color"}],staticClass:"price-subline"},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(product.size),expression:"product.size"}]},[_vm._v("Size:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(product.size))]),_c('span',{directives:[{name:"show",rawName:"v-show",value:(product.color),expression:"product.color"}]},[_vm._v(", Color:")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(product.color))])])])]),_vm._v(" "),(_vm.orderDetail.trackNo && _vm.orderDetail.orderStatus === 'shipped' || _vm.orderDetail.orderStatus === 'delivered')?_c('div',{staticClass:"track-button blue-button touchable",on:{"click":function($event){_vm.packageTrack(_vm.orderDetail.id)}}},[_vm._v("\n              Where's My Package?\n            ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"blue-button contact-button",on:{"click":function($event){_vm.goTo('/contact-us')}}},[_vm._v("\n              Contact Support\n            ")])])})),_vm._v(" "),_c('div',{staticClass:"page-subtitle"},[_vm._v("Summary")]),_vm._v(" "),_c('div',{staticClass:"summary-section"},[_c('table',{staticClass:"summary-table"},[_c('tbody',[_c('tr',{staticClass:" "},[_c('td',{staticClass:"label-col"},[_vm._v("\n                  Item Total:\n                ")]),_vm._v(" "),_c('td',{staticClass:"value-col"},[_vm._v("\n                  "+_vm._s(_vm.orderDetail.symbol)+_vm._s(_vm.orderDetail.productPrice)+"\n                ")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('tr',{staticClass:" order-total "},[_c('td',{staticClass:"label-col"},[_vm._v("\n                  Order Total:\n                ")]),_vm._v(" "),_c('td',{staticClass:"value-col"},[_vm._v("\n                  "+_vm._s(_vm.orderDetail.symbol)+_vm._s(_vm.orderDetail.totalPrice)+"\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"refund-placeholder"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('router-link',{staticClass:"gray-button all-orders-button touchable",attrs:{"to":"/transaction","tag":"div"}},[_vm._v("\n          View All Orders\n        ")])],1)])])],1)}
var transactionDetail_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"question-placeholder"},[_c('div',{staticClass:"help-title"},[_vm._v("\n            Need Help?\n          ")]),_vm._v("\n          Find the item you need help with and tap on Contact Support.\n        ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticClass:" "},[_c('td',{staticClass:"label-col"},[_vm._v("\n                  Shipping:\n                ")]),_vm._v(" "),_c('td',{staticClass:"value-col"},[_vm._v("\n                  Free Shipping\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('table',{staticClass:"mobile-guarantee"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"guarantee-text"},[_vm._v("\n                  We have your back! You never have to worry when you shop on CalmPurr.\n                ")])])])])])}]
var transactionDetail_esExports = { render: transactionDetail_render, staticRenderFns: transactionDetail_staticRenderFns }
/* harmony default export */ var pages_transactionDetail = (transactionDetail_esExports);
// CONCATENATED MODULE: ./src/pages/transactionDetail.vue
function transactionDetail_injectStyle (ssrContext) {
  __webpack_require__("BkQZ")
}
var transactionDetail_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var transactionDetail___vue_template_functional__ = false
/* styles */
var transactionDetail___vue_styles__ = transactionDetail_injectStyle
/* scopeId */
var transactionDetail___vue_scopeId__ = "data-v-793be6ad"
/* moduleIdentifier (server only) */
var transactionDetail___vue_module_identifier__ = null
var transactionDetail_Component = transactionDetail_normalizeComponent(
  transactionDetail,
  pages_transactionDetail,
  transactionDetail___vue_template_functional__,
  transactionDetail___vue_styles__,
  transactionDetail___vue_scopeId__,
  transactionDetail___vue_module_identifier__
)

/* harmony default export */ var src_pages_transactionDetail = (transactionDetail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/signin.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var pages_signin = ({

  name: 'signin',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      email: '',
      password: ''
    };
  },
  created: function created() {},

  methods: {
    tofb: function tofb() {
      this.$axios(this.ApiList.facebookAuthUrl).then(function (response) {
        var fbUrl = response.data.url;
        window.location.replace(fbUrl);
      }).catch(function (err) {
        console.log(err);
      });
    },
    signin: function signin() {
      var _this = this;

      if (this.email === '' || this.password === '') {
        this.$messagebox({
          title: 'Oops!',
          message: 'Please fill in all the fields.',
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return false;
      }
      // let emailResult = Validator.email(this.email)
      // if (!emailResult.status) {
      //   this.$messagebox({
      //     title: 'Oops!',
      //     message: emailResult.errorText,
      //     confirmButtonText: 'ok',
      //     confirmButtonHighlight: true
      //   })
      //   return false
      // }
      var data = {
        email: this.email,
        password: this.password
      };
      this.$axios.post(this.ApiList.login, lib_default.a.stringify(data)).then(function (response) {
        cookies.setCookie('user', response.data.user, 10);
        cookies.setCookie('cart', response.data.cart, 10);
        cookies.setCookie('email', _this.email, 10);
        _this.$store.commit('changeLoginStatus', {
          isLogin: true,
          account: {
            userName: response.data.user,
            email: _this.email
          }
        });
        if (_this.$route.query.redirect) {
          _this.$router.push({ path: _this.$route.query.redirect });
        } else {
          _this.$router.push({ path: '/' });
        }
      }).catch(function (err) {
        if (!err.data.success) {
          _this.$messagebox({
            title: 'Oops!',
            message: err.data.msg,
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef83f398","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/signin.vue
var signin_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msite-signin-signup-modal",attrs:{"id":"msite-signup-modal"}},[_c('my-header'),_vm._v(" "),_c('div',{staticClass:"singin-v2"},[_c('ul',[_c('li',[_c('label',{attrs:{"id":"required-text"}},[_vm._v(_vm._s(_vm.$t('signinReq')))]),_vm._v(" "),_c('form',{staticClass:"input-fields-v2 ui-mobile-input-overwrite"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email),expression:"email",modifiers:{"trim":true}}],staticClass:"highlight-v2",attrs:{"id":"signin-v2-email","spellcheck":"false","type":"email","placeholder":_vm.$t('emailReq'),"autocomplete":"off"},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],staticClass:"highlight-v2",attrs:{"id":"signin-v2-password","type":"password","placeholder":_vm.$t('passwordReq'),"autocomplete":"off"},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('button',{staticClass:"btn-v2 ui-mobile-btn-overwrite email-signin-button-v2 ui-btn ui-shadow ui-corner-all",attrs:{"type":"button"},on:{"click":_vm.signin}},[_c('span',{staticClass:"text"},[_vm._v("\n              "+_vm._s(_vm.$t('signin'))+"\n            ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"signin-new"},[_c('div',{staticClass:"signin-new-txt"},[_vm._v("\n            "+_vm._s(_vm.$t('newTo'))+"\n          ")]),_vm._v(" "),_c('router-link',{staticClass:"text-link signin-btn-signup cronkite touchable",attrs:{"to":"/signup","tag":"div"}},[_vm._v("\n            "+_vm._s(_vm.$t('createAccount'))+"\n          ")])],1)])])])],1)}
var signin_staticRenderFns = []
var signin_esExports = { render: signin_render, staticRenderFns: signin_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_pages_signin = (signin_esExports);
// CONCATENATED MODULE: ./src/pages/signin.vue
function signin_injectStyle (ssrContext) {
  __webpack_require__("R3O8")
}
var signin_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var signin___vue_template_functional__ = false
/* styles */
var signin___vue_styles__ = signin_injectStyle
/* scopeId */
var signin___vue_scopeId__ = "data-v-ef83f398"
/* moduleIdentifier (server only) */
var signin___vue_module_identifier__ = null
var signin_Component = signin_normalizeComponent(
  pages_signin,
  selectortype_template_index_0_src_pages_signin,
  signin___vue_template_functional__,
  signin___vue_styles__,
  signin___vue_scopeId__,
  signin___vue_module_identifier__
)

/* harmony default export */ var src_pages_signin = (signin_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/signup.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var signup = ({

  name: 'signup',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      email: '',
      password: '',
      firstName: '',
      lastName: ''
    };
  },
  created: function created() {},

  methods: {
    signUp: function signUp() {
      var _this = this;

      if (this.email === '' || this.password === '' || this.firstName === '' || this.lastName === '') {
        this.$messagebox({
          title: 'Oops!',
          message: 'Please fill in all the fields.',
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return false;
      }
      var emailResult = validate.email(this.email);
      if (!emailResult.status) {
        this.$messagebox({
          title: 'Oops!',
          message: emailResult.errorText,
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return false;
      }
      var data = {
        email: this.email,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName
      };
      this.$axios.post(this.ApiList.register, lib_default.a.stringify(data)).then(function (response) {
        cookies.setCookie('user', response.data.user, 10);
        cookies.setCookie('cart', response.data.cart, 10);
        cookies.setCookie('email', _this.email, 10);
        _this.$store.commit('changeLoginStatus', {
          isLogin: true,
          account: {
            userName: response.data.user,
            email: _this.email
          }
        });
        if (_this.$route.query.redirect) {
          _this.$router.push({ path: _this.$route.query.redirect });
        } else {
          _this.$router.push({ path: '/' });
        }
      }).catch(function (err) {
        if (!err.data.success) {
          _this.$messagebox({
            title: 'Oops!',
            message: err.data.msg,
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c65746ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/signup.vue
var signup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msite-signin-signup-modal",attrs:{"id":"msite-signup-modal"}},[_c('my-header'),_vm._v(" "),_c('div',{staticClass:"singup-v2"},[_c('ul',[_c('li',[_c('label',{attrs:{"id":"required-text"}},[_vm._v(_vm._s(_vm.$t('signinReq')))]),_vm._v(" "),_c('form',{staticClass:"input-fields-v2 ui-mobile-input-overwrite"},[_c('div',{staticClass:"signup-v2-names"},[_c('div',{staticClass:"signup-v2-fname-div"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.firstName),expression:"firstName",modifiers:{"trim":true}}],staticClass:"highlight-v2",attrs:{"id":"signup-v2-fname","spellcheck":"false","type":"text","placeholder":_vm.$t('firstName')},domProps:{"value":(_vm.firstName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.firstName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"signup-v2-lname-div"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.lastName),expression:"lastName",modifiers:{"trim":true}}],staticClass:"highlight-v2",attrs:{"id":"signup-v2-lname","spellcheck":"false","type":"text","placeholder":_vm.$t('lastName')},domProps:{"value":(_vm.lastName)},on:{"input":function($event){if($event.target.composing){ return; }_vm.lastName=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])])]),_vm._v(" "),_c('div',{staticClass:"signup-v2-input-div"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email),expression:"email",modifiers:{"trim":true}}],staticClass:"highlight-v2",attrs:{"id":"signup-v2-email","spellcheck":"false","type":"email","placeholder":_vm.$t('emailReq')},domProps:{"value":(_vm.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.email=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})]),_vm._v(" "),_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.password),expression:"password",modifiers:{"trim":true}}],staticClass:"highlight-v2",attrs:{"id":"signup-v2-password","type":"password","placeholder":_vm.$t('passwordReq')},domProps:{"value":(_vm.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.password=$event.target.value.trim()},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('button',{staticClass:"btn-v2 ui-mobile-btn-overwrite email-signup-button-v2 ui-btn ui-shadow ui-corner-all",attrs:{"type":"button"},on:{"click":_vm.signUp}},[_c('span',{staticClass:"text"},[_vm._v("\n              "+_vm._s(_vm.$t('createAccount'))+"\n            ")])])])]),_vm._v(" "),_c('li',[_c('div',{staticClass:"signup-existing"},[_c('div',{staticClass:"signup-existing-txt"},[_vm._v("\n            "+_vm._s(_vm.$t('alreadyHaveAccount'))+"\n          ")]),_vm._v(" "),_c('router-link',{staticClass:"text-link signup-btn-signin cronkite touchable",attrs:{"tag":"div","to":"/login"}},[_vm._v("\n            "+_vm._s(_vm.$t('signin'))+"\n          ")])],1)])])])],1)}
var signup_staticRenderFns = []
var signup_esExports = { render: signup_render, staticRenderFns: signup_staticRenderFns }
/* harmony default export */ var pages_signup = (signup_esExports);
// CONCATENATED MODULE: ./src/pages/signup.vue
function signup_injectStyle (ssrContext) {
  __webpack_require__("RquW")
}
var signup_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var signup___vue_template_functional__ = false
/* styles */
var signup___vue_styles__ = signup_injectStyle
/* scopeId */
var signup___vue_scopeId__ = "data-v-c65746ac"
/* moduleIdentifier (server only) */
var signup___vue_module_identifier__ = null
var signup_Component = signup_normalizeComponent(
  signup,
  pages_signup,
  signup___vue_template_functional__,
  signup___vue_styles__,
  signup___vue_scopeId__,
  signup___vue_module_identifier__
)

/* harmony default export */ var src_pages_signup = (signup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/forgotPassword.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var forgotPassword = ({

  name: 'forgotpassword',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {};
  },
  created: function created() {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d7b2d70","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/forgotPassword.vue
var forgotPassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"msite-signin-signup-modal",attrs:{"id":"msite-signup-modal"}},[_c('my-header'),_vm._v(" "),_vm._m(0)],1)}
var forgotPassword_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"forgotpassword-v2"},[_c('div',{staticClass:"forgotpassword-v2-div"},[_c('label',{attrs:{"id":"required-text"}},[_vm._v("* Indicates a field is required")]),_vm._v(" "),_c('form',{staticClass:"input-fields-v2 ui-mobile-input-overwrite"},[_c('div',{staticClass:"signup-v2-lname-div"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{staticClass:"highlight-v2",attrs:{"id":"signup-v2-lname","spellcheck":"false","type":"email","placeholder":"Email*"}})])]),_vm._v(" "),_c('button',{staticClass:"btn-v2 ui-mobile-btn-overwrite email-forgot-pwd-btn-v2 ui-btn ui-shadow ui-corner-all"},[_c('span',{staticClass:"text"},[_vm._v("\n            Reset Password\n          ")])])]),_vm._v(" "),_c('div',{staticClass:"message-v2 highlight-v2"})])])}]
var forgotPassword_esExports = { render: forgotPassword_render, staticRenderFns: forgotPassword_staticRenderFns }
/* harmony default export */ var pages_forgotPassword = (forgotPassword_esExports);
// CONCATENATED MODULE: ./src/pages/forgotPassword.vue
function forgotPassword_injectStyle (ssrContext) {
  __webpack_require__("2C5d")
}
var forgotPassword_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var forgotPassword___vue_template_functional__ = false
/* styles */
var forgotPassword___vue_styles__ = forgotPassword_injectStyle
/* scopeId */
var forgotPassword___vue_scopeId__ = "data-v-2d7b2d70"
/* moduleIdentifier (server only) */
var forgotPassword___vue_module_identifier__ = null
var forgotPassword_Component = forgotPassword_normalizeComponent(
  forgotPassword,
  pages_forgotPassword,
  forgotPassword___vue_template_functional__,
  forgotPassword___vue_styles__,
  forgotPassword___vue_scopeId__,
  forgotPassword___vue_module_identifier__
)

/* harmony default export */ var src_pages_forgotPassword = (forgotPassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/contactUs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var contactUs = ({

  name: 'contact',
  components: { MyHeader: header["a" /* default */] },
  data: function data() {
    return {
      info: {
        email: '',
        title: '',
        content: ''
      }
    };
  },
  created: function created() {},

  methods: {
    submit: function submit() {
      var _this = this;

      // 验证为空
      if (this.info.email === '' || this.info.title === '' || this.info.content === '') {
        this.$messagebox({
          title: 'Oops!',
          message: 'Please provide information in all required fields',
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return;
      }
      // 验证邮编
      var emailResult = validate.email(this.info.email);
      if (!emailResult.status) {
        this.$messagebox({
          title: 'Oops!',
          message: emailResult.errorText,
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return false;
      }
      var data = this.info;
      this.$axios.post(this.ApiList.contact, lib_default.a.stringify(data)).then(function (response) {
        console.log(response.data);
        _this.$toast({
          message: 'Thank you! We will be in contact with you shortly.',
          // position: 'bottom',
          duration: 3000
        });
        //this.info.content = ''
      }).catch(function (err) {
        if (!err.data.success) {
          _this.$messagebox({
            title: 'Oops!',
            message: err.data.msg,
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d314988","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/contactUs.vue
var contactUs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"shippingPage"}},[_c('div',{staticClass:"mobile-cart-shipping-page ui-page-theme-a"},[_c('div',{staticClass:"address-form"},[_c('label',{attrs:{"id":"required-text"}},[_vm._v(_vm._s(_vm.$t('signinReq')))]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.info.email),expression:"info.email",modifiers:{"trim":true}}],staticClass:"full-width-input required-input",attrs:{"name":"email","placeholder":_vm.$t('contactemail'),"type":"email"},domProps:{"value":(_vm.info.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.info, "email", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.info.title),expression:"info.title",modifiers:{"trim":true}}],staticClass:"full-width-input required-input",attrs:{"name":"subject","placeholder":_vm.$t('contactsubject'),"type":"text"},domProps:{"value":(_vm.info.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.info, "title", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"ui-input-text ui-body-inherit ui-corner-all ui-shadow-inset"},[_c('textarea',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.info.content),expression:"info.content",modifiers:{"trim":true}}],staticClass:"full-width-input required-input",attrs:{"name":"description","placeholder":_vm.$t('contactDesc'),"rows":"10"},domProps:{"value":(_vm.info.content)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.info, "content", $event.target.value.trim())},"blur":function($event){_vm.$forceUpdate()}}})])]),_vm._v(" "),_c('div',{staticClass:"cart-footer defaulthide ui-footer ui-footer-fixed slideup ui-bar-inherit"},[_c('div',{staticClass:"checkout-button-container"},[_c('div',{staticClass:"orange-button checkout-button touchable done-btn",on:{"click":_vm.submit}},[_vm._v("\n              "+_vm._s(_vm.$t('done'))+"\n            ")])])])])])])],1)}
var contactUs_staticRenderFns = []
var contactUs_esExports = { render: contactUs_render, staticRenderFns: contactUs_staticRenderFns }
/* harmony default export */ var pages_contactUs = (contactUs_esExports);
// CONCATENATED MODULE: ./src/pages/contactUs.vue
function contactUs_injectStyle (ssrContext) {
  __webpack_require__("VnPR")
}
var contactUs_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var contactUs___vue_template_functional__ = false
/* styles */
var contactUs___vue_styles__ = contactUs_injectStyle
/* scopeId */
var contactUs___vue_scopeId__ = "data-v-3d314988"
/* moduleIdentifier (server only) */
var contactUs___vue_module_identifier__ = null
var contactUs_Component = contactUs_normalizeComponent(
  contactUs,
  pages_contactUs,
  contactUs___vue_template_functional__,
  contactUs___vue_styles__,
  contactUs___vue_scopeId__,
  contactUs___vue_module_identifier__
)

/* harmony default export */ var src_pages_contactUs = (contactUs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/settings.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var settings = ({

  name: 'contact',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      info: {
        email: '',
        title: '',
        content: ''
      }
    };
  },
  created: function created() {},

  methods: {
    showLogoutModal: function showLogoutModal() {
      var _this = this;

      // 退出
      this.$luoji_confirm({
        title: 'Do you want to log out?',
        showCancelBtn: true,
        confirmText: 'Logout'
      }).then(function () {
        _this.logout();
      }).catch(function () {});
    },
    logout: function logout() {
      var _this2 = this;

      // 退出
      // 请求接口
      this.$axios.post(this.ApiList.logout).then(function (res) {
        _this2.$cookieApi.setCookie('user', '', -1);
        _this2.$cookieApi.setCookie('cart', '', -1);
        _this2.$cookieApi.setCookie('email', '', -1);
        _this2.$store.commit('changeLoginStatus', {
          isLogin: false
        });
        console.log('退出');
        _this2.$router.push({ path: '/' });
        // let notNessaryPath = ['index', 'detailPage', 'help', 'privacy', 'terms', 'return', 'login', 'notFound', 'search', 'contactUs']
        // if (notNessaryPath.indexOf(this.$router.currentRoute.name) === -1) {
        //   this.$router.push({path: '/'})
        // }
      }).catch(function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var _this3 = this;

      // 验证为空
      if (this.info.email === '' || this.info.title === '' || this.info.content === '') {
        this.$messagebox({
          title: 'Oops!',
          message: 'Please provide information in all required fields',
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return;
      }
      // 验证邮编
      var emailResult = validate.email(this.info.email);
      if (!emailResult.status) {
        this.$messagebox({
          title: 'Oops!',
          message: emailResult.errorText,
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return false;
      }
      var data = this.info;
      this.$axios.post(this.ApiList.contact, lib_default.a.stringify(data)).then(function (response) {
        console.log(response.data);
        _this3.$toast({
          message: 'Thank you! We will be in contact with you shortly.',
          // position: 'bottom',
          duration: 3000
        });
        _this3.info.content = '';
      }).catch(function (err) {
        if (!err.data.success) {
          _this3.$messagebox({
            title: 'Oops!',
            message: err.data.msg,
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f91d3b5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/settings.vue
var settings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"shippingPage"}},[_c('div',{staticClass:"mobile-cart-shipping-page ui-page-theme-a"},[_c('div',{staticClass:"mobile-page-content ui-content",attrs:{"data-role":"content","role":"main"}},[_c('div',{staticClass:"mobile-page-state-content default-hide",staticStyle:{"display":"block"}},[_c('div',{staticClass:"mobile-settings-page"},[_c('ul',[_c('router-link',{staticClass:"ui-link",attrs:{"to":"/settings/change-email"}},[_c('li',{staticClass:"settings-tab"},[_vm._v("\n                   "+_vm._s(_vm.$t('changeemail'))+"\n                ")])]),_vm._v(" "),_c('router-link',{staticClass:"ui-link",attrs:{"to":"/settings/change-password"}},[_c('li',{staticClass:"settings-tab"},[_vm._v("\n                  "+_vm._s(_vm.$t('changepass'))+"\n                ")])]),_vm._v(" "),_c('li',{staticClass:"settings-tab logout",on:{"click":_vm.showLogoutModal}},[_vm._v("\n                "+_vm._s(_vm.$t('logout'))+"\n              ")])],1),_vm._v(" "),_vm._m(0)])])])])])],1)}
var settings_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"information-text"},[_c('div',{staticClass:"terms-and-privacy"})])}]
var settings_esExports = { render: settings_render, staticRenderFns: settings_staticRenderFns }
/* harmony default export */ var pages_settings = (settings_esExports);
// CONCATENATED MODULE: ./src/pages/settings.vue
function settings_injectStyle (ssrContext) {
  __webpack_require__("XOTN")
}
var settings_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var settings___vue_template_functional__ = false
/* styles */
var settings___vue_styles__ = settings_injectStyle
/* scopeId */
var settings___vue_scopeId__ = "data-v-5f91d3b5"
/* moduleIdentifier (server only) */
var settings___vue_module_identifier__ = null
var settings_Component = settings_normalizeComponent(
  settings,
  pages_settings,
  settings___vue_template_functional__,
  settings___vue_styles__,
  settings___vue_scopeId__,
  settings___vue_module_identifier__
)

/* harmony default export */ var src_pages_settings = (settings_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/changeEmail.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var changeEmail = ({

  name: 'contact',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      email: {
        value: { // 2个输入框的值
          new: '',
          confirm: ''
        },
        invalidate: true, // 总的验证
        focus: { // 2个输入框的焦点
          new: false,
          confirm: false
        },
        firstInput: { // 2个输入框的第一次输入
          new: true,
          confirm: true
        },
        errorText: {
          new: 'Required Field',
          confirm: 'Required Field'
        },
        itemInvalidate: {
          new: false,
          confirm: false
        }
      }
    };
  },

  computed: {
    account: function account() {
      return this.$store.getters.getAccount;
    }
  },
  methods: {
    focus: function focus(type) {
      this.email.focus[type] = true;
    },
    blur: function blur(type) {
      this.email.focus[type] = false;
    },
    showLogoutModal: function showLogoutModal() {
      var _this = this;

      // 退出
      this.$luoji_confirm({
        title: 'Do you want to log out?',
        showCancelBtn: false,
        confirmText: 'Logout'
      }).then(function () {
        _this.logout();
      }).catch(function () {});
    },
    logout: function logout() {
      var _this2 = this;

      // 退出
      // 请求接口
      this.$axios.post(this.ApiList.logout).then(function (res) {
        _this2.$cookieApi.setCookie('user', '', -1);
        _this2.$cookieApi.setCookie('cart', '', -1);
        _this2.$cookieApi.setCookie('email', '', -1);
        _this2.$store.commit('changeLoginStatus', {
          isLogin: false
        });
        console.log('退出');
        _this2.$router.push({ path: '/' });
        // let notNessaryPath = ['index', 'detailPage', 'help', 'privacy', 'terms', 'return', 'login', 'notFound', 'search', 'contactUs']
        // if (notNessaryPath.indexOf(this.$router.currentRoute.name) === -1) {
        //   this.$router.push({path: '/'})
        // }
      }).catch(function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var _this3 = this;

      // 验证为空
      if (this.email.value.new !== this.email.value.confirm) {
        this.email.itemInvalidate.confirm = true;
        this.email.errorText.confirm = 'Your emails do not match';
        return;
      } else {
        this.email.itemInvalidate.confirm = false;
      }
      // 验证邮编
      var emailResult = validate.email(this.email.value.new);
      if (!emailResult.status) {
        this.email.itemInvalidate.new = true;
        this.email.errorText.new = 'Invalid e-mail address';
        return;
      }
      var data = {
        newEmail: this.email.value.new
      };
      this.$indicator.open({
        spinnerType: 'snake'
      });
      this.$axios.post(this.ApiList.changeEmail, lib_default.a.stringify(data)).then(function (response) {
        _this3.$indicator.close();
        _this3.$toast({
          message: 'Your e-mail address is updated',
          duration: 3000
        });
        _this3.$cookieApi.setCookie('email', _this3.email.value.new, 10);
        _this3.$cookieApi.setCookie('user', '', -1);
        _this3.$cookieApi.setCookie('cart', '', -1);
        _this3.$cookieApi.setCookie('email', '', -1);
        _this3.$store.commit('changeLoginStatus', {
          isLogin: false
        });
        console.log('退出');
        _this3.$router.push({ path: '/login' });
        /*this.$store.commit('changeLoginStatus', {
          isLogin: true,
          account: {
            userName: this.account.userName,
            email: this.email.value.new
          }
        })
        this.email.value.new = ''
        this.email.value.confirm = ''
        setTimeout(() => {
          this.email.firstInput.new = true
          this.email.firstInput.confirm = true
        })*/
      }).catch(function (err) {
        console.log(err);
        _this3.$indicator.close();
        if (!err.data.success) {
          _this3.email.itemInvalidate.new = true;
          _this3.email.errorText.new = err.data.msg;
        }
      });
    }
  },
  watch: {
    'email.value.new': function emailValueNew(newVal, val) {
      this.email.itemInvalidate.new = false;
      this.email.firstInput.new = false;
      if (this.email.value.new && this.email.value.confirm) {
        this.email.invalidate = false;
      } else {
        this.email.invalidate = true;
      }
    },
    'email.value.confirm': function emailValueConfirm(newVal, val) {
      this.email.itemInvalidate.confirm = false;
      this.email.firstInput.confirm = false;
      if (this.email.value.new && this.email.value.confirm) {
        this.email.invalidate = false;
      } else {
        this.email.invalidate = true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-436789aa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/changeEmail.vue
var changeEmail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"shippingPage"}},[_c('div',{staticClass:"mobile-cart-shipping-page ui-page-theme-a"},[_c('div',{staticClass:"mobile-page-content ui-content",attrs:{"data-role":"content","role":"main"}},[_c('div',{staticClass:"mobile-page-state-content default-hide",staticStyle:{"display":"block"}},[_c('div',{staticClass:"mobile-settings-change-email-page"},[_c('div',{staticClass:"mobile-settings-change-email-page-main-content"},[_c('div',{staticClass:"email-explanation"},[_c('div',{staticClass:"form-title"},[_vm._v(_vm._s(_vm.$t('changeemailtips')))])]),_vm._v(" "),_c('div',{staticClass:"old-email"},[_c('div',{staticClass:"label"},[_vm._v("\n                  "+_vm._s(_vm.$t('currentemail'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"old-email-text"},[_vm._v(_vm._s(_vm.account.email))])]),_vm._v(" "),_c('div',{staticClass:"new-email",class:{'focus': _vm.email.focus.new, 'error': !_vm.email.value.new && !_vm.email.firstInput.new || _vm.email.itemInvalidate.new}},[_c('div',{staticClass:"label"},[_vm._v("\n                  "+_vm._s(_vm.$t('newemail'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email.value.new),expression:"email.value.new",modifiers:{"trim":true}}],staticClass:"new-email-input",attrs:{"autocapitalize":"none","autocorrect":"off","placeholder":_vm.$t('enteremail'),"type":"email"},domProps:{"value":(_vm.email.value.new)},on:{"focus":function($event){_vm.focus('new')},"blur":[function($event){_vm.blur('new')},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email.value, "new", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.email.value.new && !_vm.email.firstInput.new || _vm.email.itemInvalidate.new),expression:"!email.value.new && !email.firstInput.new || email.itemInvalidate.new"}],staticClass:"required"},[_vm._v(_vm._s(_vm.email.errorText.new))])]),_vm._v(" "),_c('div',{staticClass:"new-email",class:{'focus': _vm.email.focus.confirm, 'error': !_vm.email.value.confirm && !_vm.email.firstInput.confirm || _vm.email.itemInvalidate.confirm}},[_c('div',{staticClass:"label"},[_vm._v("\n                  "+_vm._s(_vm.$t('confirmemail'))+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email.value.confirm),expression:"email.value.confirm",modifiers:{"trim":true}}],staticClass:"new-email-input",attrs:{"autocapitalize":"none","autocorrect":"off","placeholder":_vm.$t('enterconfirmemail'),"type":"email"},domProps:{"value":(_vm.email.value.confirm)},on:{"focus":function($event){_vm.focus('confirm')},"blur":[function($event){_vm.blur('confirm')},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email.value, "confirm", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.email.value.confirm && !_vm.email.firstInput.confirm || _vm.email.itemInvalidate.confirm),expression:"!email.value.confirm && !email.firstInput.confirm || email.itemInvalidate.confirm"}],staticClass:"required"},[_vm._v(_vm._s(_vm.email.errorText.confirm))])])]),_vm._v(" "),_c('div',{staticClass:"cart-footer ui-footer ui-footer-fixed ui-bar-inherit"},[_c('div',{staticClass:"checkout-button-container",class:{disabled: _vm.email.invalidate}},[_c('div',{staticClass:"orange-button checkout-button done-btn",on:{"click":_vm.submit}},[_vm._v("\n                  Save Changes\n                ")])])])])])])])])],1)}
var changeEmail_staticRenderFns = []
var changeEmail_esExports = { render: changeEmail_render, staticRenderFns: changeEmail_staticRenderFns }
/* harmony default export */ var pages_changeEmail = (changeEmail_esExports);
// CONCATENATED MODULE: ./src/pages/changeEmail.vue
function changeEmail_injectStyle (ssrContext) {
  __webpack_require__("q4nn")
}
var changeEmail_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var changeEmail___vue_template_functional__ = false
/* styles */
var changeEmail___vue_styles__ = changeEmail_injectStyle
/* scopeId */
var changeEmail___vue_scopeId__ = "data-v-436789aa"
/* moduleIdentifier (server only) */
var changeEmail___vue_module_identifier__ = null
var changeEmail_Component = changeEmail_normalizeComponent(
  changeEmail,
  pages_changeEmail,
  changeEmail___vue_template_functional__,
  changeEmail___vue_styles__,
  changeEmail___vue_scopeId__,
  changeEmail___vue_module_identifier__
)

/* harmony default export */ var src_pages_changeEmail = (changeEmail_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/changePassword.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var changePassword = ({

  name: 'contact',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      email: {
        value: { // 2个输入框的值
          new: '', // 老的值
          confirm: '' // 新的值
        },
        invalidate: true, // 总的验证
        focus: { // 2个输入框的焦点
          new: false,
          confirm: false
        },
        firstInput: { // 2个输入框的第一次输入
          new: true,
          confirm: true
        },
        errorText: {
          new: 'Required Field',
          confirm: 'Required Field'
        },
        itemInvalidate: {
          new: false,
          confirm: false
        }
      }
    };
  },

  computed: {
    account: function account() {
      return this.$store.getters.getAccount;
    }
  },
  methods: {
    focus: function focus(type) {
      this.email.focus[type] = true;
    },
    blur: function blur(type) {
      this.email.focus[type] = false;
    },
    submit: function submit() {
      var _this = this;

      // 验证邮编
      var data = {
        currentPassword: this.email.value.new,
        newPassword: this.email.value.confirm
      };
      this.$indicator.open({
        spinnerType: 'snake'
      });
      this.$axios.post(this.ApiList.changePassword, lib_default.a.stringify(data)).then(function (response) {
        _this.$indicator.close();
        _this.$toast({
          message: 'Your password is updated',
          duration: 3000
        });
        _this.email.value.new = '';
        _this.email.value.confirm = '';
        setTimeout(function () {
          _this.email.firstInput.new = true;
          _this.email.firstInput.confirm = true;
        });
      }).catch(function (err) {
        console.log(err);
        _this.$indicator.close();
        if (!err.data.success) {
          _this.email.itemInvalidate.new = true;
          _this.email.errorText.new = err.data.msg;
        }
      });
    }
  },
  watch: {
    'email.value.new': function emailValueNew(newVal, val) {
      this.email.itemInvalidate.new = false;
      this.email.firstInput.new = false;
      if (this.email.value.new && this.email.value.confirm) {
        this.email.invalidate = false;
      } else {
        this.email.invalidate = true;
      }
    },
    'email.value.confirm': function emailValueConfirm(newVal, val) {
      this.email.itemInvalidate.confirm = false;
      this.email.firstInput.confirm = false;
      if (this.email.value.new && this.email.value.confirm) {
        this.email.invalidate = false;
      } else {
        this.email.invalidate = true;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1cd4f27d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/changePassword.vue
var changePassword_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"shippingPage"}},[_c('div',{staticClass:"mobile-cart-shipping-page ui-page-theme-a"},[_c('div',{staticClass:"mobile-page-content ui-content",attrs:{"data-role":"content","role":"main"}},[_c('div',{staticClass:"mobile-page-state-content default-hide",staticStyle:{"display":"block"}},[_c('div',{staticClass:"mobile-settings-change-email-page"},[_c('div',{staticClass:"mobile-settings-change-email-page-main-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"new-email",class:{'focus': _vm.email.focus.new, 'error': !_vm.email.value.new && !_vm.email.firstInput.new || _vm.email.itemInvalidate.new}},[_c('div',{staticClass:"label"},[_vm._v("\n                  Old Password\n                ")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email.value.new),expression:"email.value.new",modifiers:{"trim":true}}],staticClass:"new-email-input",attrs:{"autocapitalize":"none","autocorrect":"off","placeholder":"Enter old password","type":"email"},domProps:{"value":(_vm.email.value.new)},on:{"focus":function($event){_vm.focus('new')},"blur":[function($event){_vm.blur('new')},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email.value, "new", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.email.value.new && !_vm.email.firstInput.new || _vm.email.itemInvalidate.new),expression:"!email.value.new && !email.firstInput.new || email.itemInvalidate.new"}],staticClass:"required"},[_vm._v(_vm._s(_vm.email.errorText.new))])]),_vm._v(" "),_c('div',{staticClass:"new-email",class:{'focus': _vm.email.focus.confirm, 'error': !_vm.email.value.confirm && !_vm.email.firstInput.confirm || _vm.email.itemInvalidate.confirm}},[_c('div',{staticClass:"label"},[_vm._v("\n                  New Password\n                ")]),_vm._v(" "),_c('div',{staticClass:"input-container"},[_c('input',{directives:[{name:"model",rawName:"v-model.trim",value:(_vm.email.value.confirm),expression:"email.value.confirm",modifiers:{"trim":true}}],staticClass:"new-email-input",attrs:{"autocapitalize":"none","autocorrect":"off","placeholder":"Enter new password","type":"email"},domProps:{"value":(_vm.email.value.confirm)},on:{"focus":function($event){_vm.focus('confirm')},"blur":[function($event){_vm.blur('confirm')},function($event){_vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.email.value, "confirm", $event.target.value.trim())}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.email.value.confirm && !_vm.email.firstInput.confirm || _vm.email.itemInvalidate.confirm),expression:"!email.value.confirm && !email.firstInput.confirm || email.itemInvalidate.confirm"}],staticClass:"required"},[_vm._v(_vm._s(_vm.email.errorText.confirm))])])]),_vm._v(" "),_c('div',{staticClass:"cart-footer ui-footer ui-footer-fixed ui-bar-inherit"},[_c('div',{staticClass:"checkout-button-container",class:{disabled: _vm.email.invalidate}},[_c('div',{staticClass:"orange-button checkout-button done-btn",on:{"click":_vm.submit}},[_vm._v("\n                  Save Changes\n                ")])])])])])])])])],1)}
var changePassword_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"email-explanation"},[_c('div',{staticClass:"form-title"},[_vm._v("Use this form to change your password.")]),_vm._v(" "),_c('div',{staticClass:"form-header-content"},[_vm._v("Enter your old password for authorization.")])])}]
var changePassword_esExports = { render: changePassword_render, staticRenderFns: changePassword_staticRenderFns }
/* harmony default export */ var pages_changePassword = (changePassword_esExports);
// CONCATENATED MODULE: ./src/pages/changePassword.vue
function changePassword_injectStyle (ssrContext) {
  __webpack_require__("cPTq")
}
var changePassword_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var changePassword___vue_template_functional__ = false
/* styles */
var changePassword___vue_styles__ = changePassword_injectStyle
/* scopeId */
var changePassword___vue_scopeId__ = "data-v-1cd4f27d"
/* moduleIdentifier (server only) */
var changePassword___vue_module_identifier__ = null
var changePassword_Component = changePassword_normalizeComponent(
  changePassword,
  pages_changePassword,
  changePassword___vue_template_functional__,
  changePassword___vue_styles__,
  changePassword___vue_scopeId__,
  changePassword___vue_module_identifier__
)

/* harmony default export */ var src_pages_changePassword = (changePassword_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/confirmPay.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var confirmPay = ({

  name: 'comfirmPay',
  components: {
    MyHeader: src_components_headerCart
  },
  data: function data() {
    return {
      failMsg: '', // 失败原因
      status: 'checking', // 付款状态: 检测 checking 、 成功 success 、失败 fail
      payStatus: '', // success cancel 支付状态 成功 失败
      checkingTitle: {
        cn: '正在检查支付状态',
        en: 'We are checking the payment status, please wait'
      },
      failTitle: {
        cn: '支付失败',
        en: 'Sorry, the payment is fail, please repay or contact us'
      }
    };
  },
  created: function created() {
    var _this = this;

    // 支付成功 直接跳转到订单详情页面
    // 支付失败 显示支付失败及其原因 还有返回购物车页面
    this.payStatus = this.$route.params.type;
    var prams = this.$route.query;
    if (this.payStatus === 'success') {
      // 调用支付成功接口
      this.$axios.post(this.ApiList.paySuccess, lib_default.a.stringify(prams)).then(function (response) {
        if (response.data.orderId) {
          // this.status = 'success'
          _this.$router.push({ 'path': '/purchase-confirmation/' + response.data.orderId }); // 并跳转到支付完成页面
        }
      }).catch(function (err) {
        _this.status = 'fail';
        _this.failMsg = err.data.msg;
      });
    } else {
      this.status = 'fail';
    }
  },

  methods: {
    repay: function repay() {
      this.$router.replace('/cart');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ef1e05a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/confirmPay.vue
var confirmPay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"content-wrapper"}},[_c('div',{staticClass:"center",attrs:{"id":"content"}},[_c('div',{attrs:{"id":"content-inner"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'checking'),expression:"status === 'checking'"}]},[_c('h1',[_vm._v(_vm._s(_vm.checkingTitle.en)+" "),_c('i',{staticClass:"fa fa-spin fa-spinner"})]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.status === 'fail'),expression:"status === 'fail'"}],staticClass:"fail"},[_c('h1',[_vm._v(_vm._s(_vm.failTitle.en))]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.failMsg),expression:"failMsg"}],staticClass:"fail-msg"},[_vm._v("The cause of failure："+_vm._s(_vm.failMsg))]),_vm._v(" "),_c('div',{staticClass:"clickable main-color main-color-border-color",attrs:{"id":"promo-code-btn"}},[_c('a',{attrs:{"id":"promo-code-btn-txt","href":"javascript:void(0)"},on:{"click":_vm.repay}},[_vm._v("Repay")])])])])])])],1)}
var confirmPay_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-loading-view"},[_c('img',{staticClass:"footer-loading-spinner",attrs:{"src":__webpack_require__("yg1H"),"width":"32px"}})])}]
var confirmPay_esExports = { render: confirmPay_render, staticRenderFns: confirmPay_staticRenderFns }
/* harmony default export */ var pages_confirmPay = (confirmPay_esExports);
// CONCATENATED MODULE: ./src/pages/confirmPay.vue
function confirmPay_injectStyle (ssrContext) {
  __webpack_require__("bPW5")
}
var confirmPay_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var confirmPay___vue_template_functional__ = false
/* styles */
var confirmPay___vue_styles__ = confirmPay_injectStyle
/* scopeId */
var confirmPay___vue_scopeId__ = "data-v-7ef1e05a"
/* moduleIdentifier (server only) */
var confirmPay___vue_module_identifier__ = null
var confirmPay_Component = confirmPay_normalizeComponent(
  confirmPay,
  pages_confirmPay,
  confirmPay___vue_template_functional__,
  confirmPay___vue_styles__,
  confirmPay___vue_scopeId__,
  confirmPay___vue_module_identifier__
)

/* harmony default export */ var src_pages_confirmPay = (confirmPay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/payloading.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var payloading = ({

  name: 'comfirmPay',
  components: {
    MyHeader: src_components_headerCart
  },
  data: function data() {
    return {
      title: {
        cn: '正在跳转到paypal支付，请稍后',
        en: 'We are going to the PayPal, please wait...'
      }
    };
  },
  created: function created() {
    var _this = this;

    this.paymethod = this.$route.params.paymethod;
    var requesturl = void 0;
    if (this.paymethod === 'Paypal') {
      requesturl = this.ApiList.paypalbuy;
      this.title.cn = '正在跳转到paypal支付，请稍后';
      this.title.en = 'We are going to the PayPal site, please wait';
    } else if (this.paymethod === 'Sofortpay') {
      requesturl = this.ApiList.sofortpaybuy;
      this.title.cn = '正在跳转到sofort支付，请稍后';
      this.title.en = 'We are going to the sofort site, please wait';
    } else if (this.paymethod === 'CreditCard') {
      requesturl = this.ApiList.creditcardbuy;
      this.title.cn = '正在通过信用卡支付，请稍后';
      this.title.en = 'We are checking out now, please wait';
    } else {
      return;
    }
    var router = this.$router;
    var timer = void 0;

    this.$axios.post(requesturl).then(function (res) {
      if (res.data.url) {
        window.location.replace(res.data.url);
      } else if (res.data.orderId) {
        _this.$router.push({ 'path': '/purchase-confirmation/' + res.data.orderId }); // 并跳转到支付完成页面
      } else {
        _this.$router.push({ path: '/transaction' });
      }
    }).catch(function (err) {
      console.log(err);
      var content = void 0;
      if (err.data.msg) {
        content = err.data.msg;
      } else {
        content = 'pay error, please send email to us';
      }
      _this.$messagebox({
        title: 'Oops!',
        message: content,
        showCancelButton: true,
        cancelButtonText: 'NO'
      });
      timer = setInterval(function () {
        router.push({ path: '/cart' });
        clearInterval(timer);
      }, 3000);
    });

    /*this.$axios.post(this.ApiList.buy)
    .then((res) => {
      if (res.data.url) {
        // window.location = res.data.url
        window.location.replace(res.data.url)
        // var tempwindow = window.open('_blank')
        // tempwindow.location = res.data.url
      }
    })
    .catch((err) => {
      console.log(err)
    })*/
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37f8e426","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/payloading.vue
var payloading_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('my-header'),_vm._v(" "),_c('div',{attrs:{"id":"content-wrapper"}},[_c('div',{staticClass:"center",attrs:{"id":"content"}},[_c('div',{staticClass:"align-center",attrs:{"id":"content-inner"}},[_c('h1',{},[_vm._v(_vm._s(_vm.title.en))]),_vm._v(" "),_vm._m(0)])])])],1)}
var payloading_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-loading-view"},[_c('img',{staticClass:"footer-loading-spinner",attrs:{"src":__webpack_require__("yg1H"),"width":"32px"}})])}]
var payloading_esExports = { render: payloading_render, staticRenderFns: payloading_staticRenderFns }
/* harmony default export */ var pages_payloading = (payloading_esExports);
// CONCATENATED MODULE: ./src/pages/payloading.vue
function payloading_injectStyle (ssrContext) {
  __webpack_require__("gFVX")
}
var payloading_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var payloading___vue_template_functional__ = false
/* styles */
var payloading___vue_styles__ = payloading_injectStyle
/* scopeId */
var payloading___vue_scopeId__ = "data-v-37f8e426"
/* moduleIdentifier (server only) */
var payloading___vue_module_identifier__ = null
var payloading_Component = payloading_normalizeComponent(
  payloading,
  pages_payloading,
  payloading___vue_template_functional__,
  payloading___vue_styles__,
  payloading___vue_scopeId__,
  payloading___vue_module_identifier__
)

/* harmony default export */ var src_pages_payloading = (payloading_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/404.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var _04 = ({

  name: 'contact',
  components: { MyHeader: src_components_headerCart },
  data: function data() {
    return {
      info: {
        email: '',
        title: '',
        content: ''
      }
    };
  },
  created: function created() {},

  methods: {
    showLogoutModal: function showLogoutModal() {
      var _this = this;

      // 退出
      this.$luoji_confirm({
        title: 'Do you want to log out?',
        showCancelBtn: false,
        confirmText: 'Logout'
      }).then(function () {
        _this.logout();
      }).catch(function () {});
    },
    logout: function logout() {
      var _this2 = this;

      // 退出
      // 请求接口
      this.$axios.post(this.ApiList.logout).then(function (res) {
        _this2.$cookieApi.setCookie('user', '', -1);
        _this2.$cookieApi.setCookie('cart', '', -1);
        _this2.$cookieApi.setCookie('email', '', -1);
        _this2.$store.commit('changeLoginStatus', {
          isLogin: false
        });
        console.log('退出');
        _this2.$router.push({ path: '/' });
        // let notNessaryPath = ['index', 'detailPage', 'help', 'privacy', 'terms', 'return', 'login', 'notFound', 'search', 'contactUs']
        // if (notNessaryPath.indexOf(this.$router.currentRoute.name) === -1) {
        //   this.$router.push({path: '/'})
        // }
      }).catch(function (err) {
        console.log(err);
      });
    },
    submit: function submit() {
      var _this3 = this;

      // 验证为空
      if (this.info.email === '' || this.info.title === '' || this.info.content === '') {
        this.$messagebox({
          title: 'Oops!',
          message: 'Please provide information in all required fields',
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return;
      }
      // 验证邮编
      var emailResult = validate.email(this.info.email);
      if (!emailResult.status) {
        this.$messagebox({
          title: 'Oops!',
          message: emailResult.errorText,
          confirmButtonText: 'ok',
          confirmButtonHighlight: true
        });
        return false;
      }
      var data = this.info;
      this.$axios.post(this.ApiList.contact, lib_default.a.stringify(data)).then(function (response) {
        console.log(response.data);
        _this3.$toast({
          message: 'Thank you! We will be in contact with you shortly.',
          // position: 'bottom',
          duration: 3000
        });
        _this3.info.content = '';
      }).catch(function (err) {
        if (!err.data.success) {
          _this3.$messagebox({
            title: 'Oops!',
            message: err.data.msg,
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        }
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-97c365d4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/404.vue
var _04_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('my-header'),_vm._v(" "),_vm._m(0)],1)}
var _04_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"shippingPage"}},[_c('div',{staticClass:"mobile-cart-shipping-page ui-page-theme-a"},[_c('div',{staticClass:"mobile-page-content ui-content",attrs:{"data-role":"content","role":"main"}},[_c('div',{staticClass:"mobile-page-state-content default-hide",staticStyle:{"display":"block"}},[_c('div',{staticClass:"error-background"},[_c('div',{staticClass:"error-code"},[_vm._v("\n              404\n            ")]),_vm._v(" "),_c('div',{staticClass:"error-title-label"},[_vm._v("\n              Error\n            ")]),_vm._v(" "),_c('div',{staticClass:"error-message-text"},[_vm._v("\n              Page Not Found\n            ")])])])])])])}]
var _04_esExports = { render: _04_render, staticRenderFns: _04_staticRenderFns }
/* harmony default export */ var pages_404 = (_04_esExports);
// CONCATENATED MODULE: ./src/pages/404.vue
function _04_injectStyle (ssrContext) {
  __webpack_require__("qf9h")
}
var _04_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var _04___vue_template_functional__ = false
/* styles */
var _04___vue_styles__ = _04_injectStyle
/* scopeId */
var _04___vue_scopeId__ = "data-v-97c365d4"
/* moduleIdentifier (server only) */
var _04___vue_module_identifier__ = null
var _04_Component = _04_normalizeComponent(
  _04,
  pages_404,
  _04___vue_template_functional__,
  _04___vue_styles__,
  _04___vue_scopeId__,
  _04___vue_module_identifier__
)

/* harmony default export */ var src_pages_404 = (_04_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/oauthCallback.vue
//
//
//
//
//
//
//
//






/* harmony default export */ var oauthCallback = ({

  name: 'oauthCallback',
  components: {
    MyHeader: src_components_headerCart
  },
  data: function data() {
    return {};
  },
  created: function created() {
    var _this = this;

    var site = this.$route.params.site;
    var code = this.getQueryString('code');
    var prams = { 'code': code, 'source': 'mobile' };
    if (site === 'facebook') {
      if (code) {
        this.$axios.post(this.ApiList.facebookAuthCallback, lib_default.a.stringify(prams)).then(function (response) {
          cookies.setCookie('user', response.data.user, 10);
          cookies.setCookie('cart', response.data.cart, 10);
          _this.$store.commit('changeLoginStatus', {
            isLogin: true,
            account: {
              userName: response.data.user
            }
          });
          _this.fetch();
          // window.location.replace('http://hitryfun.com')
          _this.$router.push({ path: '/' });
        }).catch(function (err) {
          if (!err.data.success) {
            _this.$messagebox({
              title: 'Oops!',
              message: err.data.msg,
              confirmButtonText: 'ok',
              confirmButtonHighlight: true
            });
          }
        });
      } else {
        var error = this.getQueryString('error');
        if (error) {
          this.$messagebox({
            title: 'Oops!',
            message: error + ' Please retry login facebook or contact us',
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        } else {
          this.$messagebox({
            title: 'Oops!',
            message: ' Please retry login facebook or contact us',
            confirmButtonText: 'ok',
            confirmButtonHighlight: true
          });
        }
      }
    }
  },

  methods: {
    fetch: function fetch() {
      var _this2 = this;

      // 获取购物车
      this.$axios(this.ApiList.cart).then(function (response) {
        var cartInfo = response.data.carts;
        var total = 0;
        for (var i = 0; i < cartInfo.cartItems.length; i++) {
          total += cartInfo.cartItems[i].quantity;
        }
        _this2.cartCount = total;
        // 如果是首页 就往index里面传递购物车数据
        if ((_this2.$route.name === 'index' || _this2.$route.name === 'search') && _this2.cartCount) {
          Bus.$emit('cartToIndex', cartInfo);
        }
      }).catch(function (err) {
        // console.log('未登录')
        console.log(err);
      });
    },
    getQueryString: function getQueryString(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      } else {
        return null;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6389a34c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/oauthCallback.vue
var oauthCallback_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('my-header'),_vm._v(" "),_c('my-footer'),_vm._v(" "),_c('my-dialog',{attrs:{"is-show":_vm.showDialog,"title":_vm.dialogInfo.title,"content":_vm.dialogInfo.content,"cancelButtonText":_vm.dialogInfo.cancelButtonText,"confirmButtonText":_vm.dialogInfo.confirmButtonText,"size":_vm.dialogInfo.size},on:{"close-dialog":_vm.hideDialog}})],1)}
var oauthCallback_staticRenderFns = []
var oauthCallback_esExports = { render: oauthCallback_render, staticRenderFns: oauthCallback_staticRenderFns }
/* harmony default export */ var pages_oauthCallback = (oauthCallback_esExports);
// CONCATENATED MODULE: ./src/pages/oauthCallback.vue
var oauthCallback_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var oauthCallback___vue_template_functional__ = false
/* styles */
var oauthCallback___vue_styles__ = null
/* scopeId */
var oauthCallback___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var oauthCallback___vue_module_identifier__ = null
var oauthCallback_Component = oauthCallback_normalizeComponent(
  oauthCallback,
  pages_oauthCallback,
  oauthCallback___vue_template_functional__,
  oauthCallback___vue_styles__,
  oauthCallback___vue_scopeId__,
  oauthCallback___vue_module_identifier__
)

/* harmony default export */ var src_pages_oauthCallback = (oauthCallback_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/refundPolicy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var refundPolicy = ({
  name: 'RefundPolicyPage',
  components: { MyHeader: header["a" /* default */] }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1332d448","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/refundPolicy.vue
var refundPolicy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('my-header'),_vm._v(" "),_vm._m(0)],1)}
var refundPolicy_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-box"},[_c('h1',[_vm._v("Return & Refund Policy")]),_vm._v(" "),_c('h2',[_vm._v("30-Day Return Window")]),_vm._v(" "),_c('p',[_vm._v("\n        We have a 30-day return policy, which means you have 30 days after receiving your item to request a return.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        To be eligible, your item must be in the same condition that you received it —\n        unworn or unused, with tags, and in its original packaging. You’ll also need\n        the receipt or proof of purchase.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("How to Start a Return")]),_vm._v(" "),_c('p',[_vm._v("\n        To start a return, please "),_c('strong',[_vm._v("submit a support ticket on our website")]),_vm._v(".\n        You can do this from the Contact/Support page.\n      ")]),_vm._v(" "),_c('p',{staticClass:"subtle"},[_vm._v("\n        Once your return request is accepted, we’ll issue a return shipping label and\n        provide instructions on how and where to send your package. "),_c('strong',[_vm._v("Items sent back\n        without an approved return request will not be accepted.")])]),_vm._v(" "),_c('h2',[_vm._v("Damages & Issues")]),_vm._v(" "),_c('p',[_vm._v("\n        Please inspect your order upon reception and "),_c('strong',[_vm._v("submit a ticket immediately")]),_vm._v("\n        if the item is defective, damaged, or if you received the wrong item, so that we can\n        evaluate the issue and make it right.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Exceptions / Non-Returnable Items")]),_vm._v(" "),_c('p',[_vm._v("\n        Certain types of items cannot be returned, including (but not limited to):\n      ")]),_vm._v(" "),_c('ul',[_c('li',[_c('strong',[_vm._v("Custom or personalized products")]),_vm._v(" (e.g., made-to-order or photo-customized items)")]),_vm._v(" "),_c('li',[_vm._v("Sale/clearance items and gift cards")])]),_vm._v(" "),_c('p',[_vm._v("\n        If you have questions about whether your item qualifies, please submit a ticket before returning the item.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Exchanges")]),_vm._v(" "),_c('p',[_vm._v("\n        The fastest way to get what you want is to return the item you have. Once your return is\n        accepted, you may place a new order for the replacement item separately.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("European Union — 14-Day Cooling-Off Period")]),_vm._v(" "),_c('p',[_vm._v("\n        If your order is shipped into the European Union, you have the right to cancel or return\n        your order within 14 days for any reason and without justification. As above, the item must\n        be in the same condition you received it, unworn/unused, with tags and in the original packaging,\n        and you’ll need the receipt or proof of purchase.\n      ")]),_vm._v(" "),_c('p',{staticClass:"subtle"},[_vm._v("\n        Please note: under EU consumer rules, the 14-day cooling-off right does "),_c('strong',[_vm._v("not")]),_vm._v(" apply to\n        "),_c('strong',[_vm._v("custom-made or personalized items")]),_vm._v(". For such items, we can only accept returns for\n        manufacturing defects or damage in transit.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("Refunds")]),_vm._v(" "),_c('p',[_vm._v("\n        We will notify you once we’ve received and inspected your return, and let you know if the refund is approved.\n        If approved, a refund will be issued to your original payment method within "),_c('strong',[_vm._v("10 business days")]),_vm._v(".\n        Your bank or card issuer may take additional time to post the refund.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        If more than "),_c('strong',[_vm._v("15 business days")]),_vm._v(" have passed since your return was approved and you have not\n        received your refund, please "),_c('strong',[_vm._v("submit a support ticket on our website")]),_vm._v(" so we can assist.\n      ")])])])}]
var refundPolicy_esExports = { render: refundPolicy_render, staticRenderFns: refundPolicy_staticRenderFns }
/* harmony default export */ var pages_refundPolicy = (refundPolicy_esExports);
// CONCATENATED MODULE: ./src/pages/refundPolicy.vue
function refundPolicy_injectStyle (ssrContext) {
  __webpack_require__("7sMP")
}
var refundPolicy_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var refundPolicy___vue_template_functional__ = false
/* styles */
var refundPolicy___vue_styles__ = refundPolicy_injectStyle
/* scopeId */
var refundPolicy___vue_scopeId__ = "data-v-1332d448"
/* moduleIdentifier (server only) */
var refundPolicy___vue_module_identifier__ = null
var refundPolicy_Component = refundPolicy_normalizeComponent(
  refundPolicy,
  pages_refundPolicy,
  refundPolicy___vue_template_functional__,
  refundPolicy___vue_styles__,
  refundPolicy___vue_scopeId__,
  refundPolicy___vue_module_identifier__
)

/* harmony default export */ var src_pages_refundPolicy = (refundPolicy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/privatePolicy.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var privatePolicy = ({
  name: 'PrivatePolicyPage',
  components: { MyHeader: header["a" /* default */] }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ace5131a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/privatePolicy.vue
var privatePolicy_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('my-header'),_vm._v(" "),_vm._m(0)],1)}
var privatePolicy_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-box"},[_c('h1',[_vm._v("Privacy Policy")]),_vm._v(" "),_c('p',[_vm._v("\n        Thank you for visiting "),_c('strong',[_vm._v("CalmPurr")]),_vm._v(" (“CalmPurr”, “we”, “us”, or “our”).\n        Your privacy is very important to us. This Privacy Policy explains how we collect,\n        use, and protect your personal information when you visit or make a purchase from\n        "),_c('a',{attrs:{"href":"https://www.calmpurr.com","target":"_blank"}},[_vm._v("www.calmpurr.com")]),_vm._v(" (the “Site”)\n        and when you communicate with us (collectively, the “Services”).\n      ")]),_vm._v(" "),_c('h2',[_vm._v("1. Information We Collect")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("a. Information You Provide Directly")])]),_vm._v(" "),_c('p',[_vm._v("\n        We collect personal information that you voluntarily provide when you create an account,\n        place an order, subscribe to our newsletter, or contact us. This may include your\n        name, email address, phone number, billing/shipping address, and payment details.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("b. Information Collected Automatically")])]),_vm._v(" "),_c('p',[_vm._v("\n        When you browse our Site, we automatically collect certain data such as IP address,\n        browser type, device information, and interaction history. This helps us improve our\n        website performance and user experience.\n      ")]),_vm._v(" "),_c('p',[_c('strong',[_vm._v("c. Information from Third Parties")])]),_vm._v(" "),_c('p',[_vm._v("\n        We may receive limited information about you from payment gateways, shipping partners,\n        or analytics providers strictly for processing orders, preventing fraud, or improving\n        our services.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("2. How We Use Your Information")]),_vm._v(" "),_c('p',[_vm._v("\n        We use your personal information to process orders, manage customer service,\n        send order updates, communicate promotions (with your consent), and improve our\n        website functionality. We do not sell your personal data to any third parties.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("3. Sharing Your Information")]),_vm._v(" "),_c('p',[_vm._v("\n        Your data may be shared only with trusted service providers who assist us in\n        operations such as payment processing, shipping, analytics, or email services.\n        All partners are required to keep your information secure and confidential.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("4. Data Retention and Security")]),_vm._v(" "),_c('p',[_vm._v("\n        We keep your personal data only as long as necessary for the purposes described above.\n        CalmPurr uses HTTPS encryption and secure servers, but please note that no system is\n        completely immune from risks.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("5. Your Rights and Choices")]),_vm._v(" "),_c('p',[_vm._v("\n        You have the right to access, correct, or delete your personal information, as well\n        as to withdraw consent for marketing communications.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("6. Cookies and Tracking Technologies")]),_vm._v(" "),_c('p',[_vm._v("\n        We use cookies to remember your preferences, analyze traffic, and personalize content.\n        You may disable cookies in your browser, but some features of our Site may not function\n        properly as a result.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("7. Children’s Privacy")]),_vm._v(" "),_c('p',[_vm._v("\n        Our Site is not intended for children under 16. We do not knowingly collect personal\n        data from children. If you believe a child has provided data to us, please contact us\n        immediately for removal.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("8. International Users")]),_vm._v(" "),_c('p',[_vm._v("\n        If you are visiting from outside our primary operating country, your information may\n        be transferred internationally. We ensure appropriate safeguards for data protection\n        under applicable laws.\n      ")])])])}]
var privatePolicy_esExports = { render: privatePolicy_render, staticRenderFns: privatePolicy_staticRenderFns }
/* harmony default export */ var pages_privatePolicy = (privatePolicy_esExports);
// CONCATENATED MODULE: ./src/pages/privatePolicy.vue
function privatePolicy_injectStyle (ssrContext) {
  __webpack_require__("eYOx")
}
var privatePolicy_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var privatePolicy___vue_template_functional__ = false
/* styles */
var privatePolicy___vue_styles__ = privatePolicy_injectStyle
/* scopeId */
var privatePolicy___vue_scopeId__ = "data-v-ace5131a"
/* moduleIdentifier (server only) */
var privatePolicy___vue_module_identifier__ = null
var privatePolicy_Component = privatePolicy_normalizeComponent(
  privatePolicy,
  pages_privatePolicy,
  privatePolicy___vue_template_functional__,
  privatePolicy___vue_styles__,
  privatePolicy___vue_scopeId__,
  privatePolicy___vue_module_identifier__
)

/* harmony default export */ var src_pages_privatePolicy = (privatePolicy_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/terms.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var terms = ({
  name: 'TermsPage',
  components: { MyHeader: header["a" /* default */] }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-191a5736","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/terms.vue
var terms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-container"},[_c('my-header'),_vm._v(" "),_c('div',{staticClass:"page-content"},[_c('div',{staticClass:"content-box"},[_c('h1',[_vm._v("Terms & Conditions")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('h2',[_vm._v("1. Online Store Terms")]),_vm._v(" "),_c('p',[_vm._v("\n        You represent that you are at least the age of majority in your jurisdiction, or that you\n        have obtained parental or guardian consent. You may not use our Services for any illegal\n        or unauthorized purpose, and you must comply with all applicable laws and regulations.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        You must not transmit any viruses, malicious code, or attempt to interfere with the security\n        or operation of the Site.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("2. General Conditions")]),_vm._v(" "),_c('p',[_vm._v("\n        We reserve the right to refuse service, terminate accounts, remove or edit content,\n        and cancel orders at our sole discretion. Prices, availability, and shipping terms\n        may change without notice. CalmPurr is not liable for losses resulting from misuse\n        of the Services or breach of these Terms.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("3. Products, Orders & Pricing")]),_vm._v(" "),_c('p',[_vm._v("\n        We strive to display accurate product descriptions, images, and pricing, but errors\n        may occasionally occur. After placing an order, you will receive a confirmation email.\n        Your order is not considered accepted until it has been shipped.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        We may impose quantity limits or modify promotional terms at our discretion.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("4. Custom & Personalized Products")]),_vm._v(" "),_c('p',[_vm._v("\n        For custom or personalized items (such as silicone cat toys made from your photos),\n        cancellations or modifications cannot be guaranteed once production begins.\n        Cancellations made after production starts may incur additional fees or be denied.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("5. Returns & Refunds")]),_vm._v(" "),_c('p',[_vm._v("\n        Please refer to our separate\n        "),_c('router-link',{attrs:{"to":"/refund-policy"}},[_vm._v("Return & Refund Policy")]),_vm._v("\n        for detailed information about eligibility, process, and timelines.\n        Any unauthorized or late return requests may be declined.\n      ")],1),_vm._v(" "),_c('h2',[_vm._v("6. Intellectual Property")]),_vm._v(" "),_c('p',[_vm._v("\n        All content on this Site — including text, graphics, logos, images, videos, and software —\n        is owned by or licensed to CalmPurr and protected by applicable intellectual property laws.\n        You may view, download, or print content for personal, non-commercial use only.\n        Reproduction, modification, or redistribution without permission is prohibited.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("7. User-Generated Content")]),_vm._v(" "),_c('p',[_vm._v("\n        If you submit photos, names, comments, or other materials (“User Content”), you grant\n        CalmPurr a non-exclusive, worldwide, royalty-free license to use, reproduce, and display\n        such content in connection with providing the Services. You confirm that your content\n        does not violate any laws or infringe the rights of others. We reserve the right to remove\n        inappropriate content at our discretion.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("8. Disclaimer & Limitation of Liability")]),_vm._v(" "),_c('p',[_vm._v("\n        While we make every effort to ensure quality and reliability, we do not guarantee\n        error-free performance. To the fullest extent permitted by law, CalmPurr shall not\n        be liable for any indirect, incidental, or consequential damages arising from your\n        use of the Site or Services.\n      ")]),_vm._v(" "),_c('p',[_vm._v("\n        Some jurisdictions do not allow the exclusion or limitation of liability for certain\n        damages; in such cases, our liability shall be limited to the maximum extent permitted\n        by law.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("9. Governing Law & Jurisdiction")]),_vm._v(" "),_c('p',[_vm._v("\n        These Terms and your use of the Site are governed by the laws of the jurisdiction\n        where CalmPurr is registered. Any disputes shall be resolved exclusively in the\n        competent courts of that jurisdiction.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("10. Severability")]),_vm._v(" "),_c('p',[_vm._v("\n        If any provision of these Terms is found to be invalid or unenforceable, that provision\n        shall be severed and the remaining provisions shall remain in full force and effect.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("11. Changes to Terms")]),_vm._v(" "),_c('p',[_vm._v("\n        We may update these Terms at any time by posting the revised version on this page.\n        The “Last updated” date will reflect any changes. Your continued use of the Site\n        after updates constitutes acceptance of the revised Terms.\n      ")]),_vm._v(" "),_c('h2',[_vm._v("12. Contact & Support")]),_vm._v(" "),_c('p',[_vm._v("\n        For any questions or concerns about these Terms or our Services, please submit a\n        support ticket via our website’s Contact or Support page. We will respond as soon\n        as reasonably possible.\n      ")])])])],1)}
var terms_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('strong',[_vm._v("This website is operated by calmpurr.com.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_vm._v("\n        Welcome to "),_c('strong',[_vm._v("CalmPurr")]),_vm._v(" (“we”, “us”, or “our”). These Terms & Conditions (“Terms”)\n        govern your use of our website "),_c('a',{attrs:{"href":"https://www.calmpurr.com","target":"_blank"}},[_vm._v("www.calmpurr.com")]),_vm._v("\n        (the “Site”) and any purchases, communications, or related services you engage in\n        (collectively, the “Services”). By accessing or using the Site, you agree to be bound by\n        these Terms. If you do not agree with any part of these Terms, please discontinue use\n        of the Site and our Services.\n      ")])}]
var terms_esExports = { render: terms_render, staticRenderFns: terms_staticRenderFns }
/* harmony default export */ var pages_terms = (terms_esExports);
// CONCATENATED MODULE: ./src/pages/terms.vue
function terms_injectStyle (ssrContext) {
  __webpack_require__("JZBs")
}
var terms_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var terms___vue_template_functional__ = false
/* styles */
var terms___vue_styles__ = terms_injectStyle
/* scopeId */
var terms___vue_scopeId__ = "data-v-191a5736"
/* moduleIdentifier (server only) */
var terms___vue_module_identifier__ = null
var terms_Component = terms_normalizeComponent(
  terms,
  pages_terms,
  terms___vue_template_functional__,
  terms___vue_styles__,
  terms___vue_scopeId__,
  terms___vue_module_identifier__
)

/* harmony default export */ var src_pages_terms = (terms_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js


























vue_esm["default"].use(vue_router_esm["a" /* default */]);
// Router.prototype.goBack = function () {
//   this.isBack = true
//   window.history.go(-1)
// }
var routers = new vue_router_esm["a" /* default */]({
  // mode: 'history',
  routes: [{
    path: '/',
    name: 'Browse',
    component: src_pages,
    meta: { keepAlive: true }
  }, {
    path: '/product/:id',
    name: 'Details',
    component: src_pages_productDetail
  }, {
    path: '/product-detail/:id',
    name: 'ProductDetails',
    component: src_pages_productDetail
  }, {
    path: '/about-us',
    name: 'aboutUs',
    component: function component() {
      return __webpack_require__("CFbh")("./aboutUs-" + (localStorage.getItem('lang') || 'en') + '.vue');
    }
  }, {
    path: '/private-policy',
    name: 'privatePolicy',
    component: function component() {
      return __webpack_require__("WUj0")("./privatePolicy-" + (localStorage.getItem('lang') || 'en') + '.vue');
    }
  }, {
    path: '/refund-policy',
    name: 'refundPolicy',
    component: function component() {
      return __webpack_require__("Od5u")("./refundPolicy-" + (localStorage.getItem('lang') || 'en') + '.vue');
    }
  }, {
    path: '/terms',
    name: 'terms',
    component: function component() {
      return __webpack_require__("z8T9")("./terms-" + (localStorage.getItem('lang') || 'en') + '.vue');
    }
  }, {
    path: '/search',
    name: 'search',
    component: src_pages_search
  }, {
    path: '/search/:text',
    name: 'searchResult',
    component: src_pages
  }, {
    path: '/cart',
    name: 'Cart',
    component: src_pages_cart
  }, {
    path: '/shipping',
    name: 'Shipping',
    component: src_pages_shipping
  }, {
    path: '/payment',
    name: 'Billing',
    component: src_pages_payment
  }, {
    path: '/transaction',
    name: 'transaction',
    component: src_pages_transaction
  }, {
    path: '/transaction/:tid',
    name: 'transactionDetail',
    component: src_pages_transactionDetail
  }, {
    path: '/purchase-confirmation/:tid',
    component: src_pages_transactionDetail,
    name: 'order-confirm'
  }, {
    path: '/transaction/track/:id',
    name: 'track',
    component: src_pages_track
  }, {
    path: '/login',
    name: 'Sign In',
    component: src_pages_signin
  }, {
    path: '/signup',
    name: 'Create Account',
    component: src_pages_signup
  }, {
    path: '/forgotPassword',
    name: 'Forgot Password',
    component: src_pages_forgotPassword
  }, {
    path: '/contact-us',
    name: 'ContactUs',
    component: src_pages_contactUs
  }, {
    path: '/settings',
    name: 'Settings',
    component: src_pages_settings
  }, {
    path: '/settings/change-email',
    name: 'Change Email',
    component: src_pages_changeEmail
  }, {
    path: '/settings/change-password',
    name: 'Change Password',
    component: src_pages_changePassword
  }, {
    path: '/shop/new/:paymethod/checkout/:type',
    component: src_pages_confirmPay,
    name: 'ConfirmPay'
  }, {
    path: '/pay-loading',
    component: src_pages_payloading,
    name: 'pay-loading'
  }, {
    path: '*',
    component: src_pages_404,
    name: 'notFound'
  }, {
    path: '/shop/oauth/:site/callback',
    component: src_pages_oauthCallback,
    name: 'oauthCallback'
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    // 路由跳转到其他页面时候，在最顶部；如果是浏览器前进后退，就在原来位置
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

routers.beforeEach(function (to, from, next) {
  // to.name 去掉空格
  document.body.id = to.name.replace(' ', '');
  next();
});

/* harmony default export */ var router = (routers);
// CONCATENATED MODULE: ./src/api/apiList.js
/* harmony default export */ var apiList = ({
  install: function install(Vue) {
    Vue.prototype.ApiList = {
      'register': '/shop/new/customer/register', // 注册
      'login': '/shop/new/customer/login', // 登录
      'logout': '/shop/new/customer/logout', // 退出 post
      'productList': '/shop/new/index', // 产品列表
      'productPage': '/shop/new/products', // 产品分页列表
      'productDetail': '/shop/new/product/detail/', // 产品详情
      'cart': '/shop/new/cart/displayCart', // 购物车
      'cartDelete': '/shop/new/cart/removeShoppingCartItem', // 删除购物车里面的某个商品
      'cartUpdate': '/shop/new/cart/updateShoppingCartItem', // 修改购物车里面的某个商品数量
      'cartAdd': '/shop/new/cart/addShoppingCartItem', // 添加商品到购物车
      'shippingAddress': '/shop/new/order/shippingAddress', // 收货地址
      'UpdateshippingAddress': '/shop/new/order/addOrUpdateShippingAddress', // 更新收获地址
      'Updatepaymethod': '/shop/new/order/addOrUpdatePayMethod', // 更新支付方式
      'autoComplete': '/shop/new/search/autocomplete', // 搜索自动补全接口
      'search': '/shop/new/search', // 搜索
      'orderList': '/shop/new/orders', // 订单列表 get start max
      'orderDetail': '/shop/new/order/', // 订单详情 get
      'changePassword': '/shop/new/customer/password-change', //  post
      'changeEmail': '/shop/new/customer/email-change', //  post
      'contact': '/shop/new/customer/contact', //  post 帮助我们
      'paypalbuy': '/shop/new/order/payment/init/PAYPAL', //  paypal支付接口 post
      'sofortpaybuy': '/shop/new/order/payment/init/SOFORT', //  sofortpay支付接口 post
      'creditcardbuy': '/shop/new/order/CREDITCARD/commit/', //  信用卡支付接口 post
      'applyProm': '/shop/new/order/prom/apply', // 计算促销码的价格
      'paySuccess': '/shop/new/order/commitPreAuthorized', //  支付成功接口
      'personInfo': '/shop/new/customer/personInfo',
      'facebookAuthUrl': '/shop/oauth/authurl/facebook/mobile', // 获取fb授权地址
      'facebookAuthCallback': '/shop/oauth/facebook/callback' // fb oauth回掉
    };
    Vue.prototype.getApiList = function (_this, type) {
      return Vue.prototype.ApiList[type];
    };
  }
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// CONCATENATED MODULE: ./src/store/modules/loginStatus.js
var state = {
  isLogin: '',
  account: {
    userName: '',
    email: ''
  }
};
var getters = {
  getLoginStatus: function getLoginStatus(state) {
    return state.isLogin;
  },
  getAccount: function getAccount(state) {
    return state.account;
  }
};
var mutations = {
  changeLoginStatus: function changeLoginStatus(state, loginStatus) {
    state.isLogin = loginStatus.isLogin;
    if (loginStatus.isLogin) {
      state.account.userName = loginStatus.account.userName;
      state.account.email = loginStatus.account.email;
    } else {
      state.account.userName = null;
      state.account.email = null;
    }
  }
};

/* harmony default export */ var loginStatus = ({
  state: state,
  getters: getters,
  mutations: mutations
});
// CONCATENATED MODULE: ./src/store/index.js




vue_esm["default"].use(vuex_esm["a" /* default */]);

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  modules: {
    LoginStatus: loginStatus
  }
}));
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/api/axiosConfig.js

/**
 * http配置
 * https://www.npmjs.com/package/axios
 */



// axios.defaults.baseURL = '/api' // 以后改成真正的接口地址
axios_default.a.defaults.baseURL = 'https://api.calmpurr.com:8443'; // 以后改成真正的接口地址
//axios.defaults.baseURL = 'http://localhost'
axios_default.a.defaults.timeout = 5000;
axios_default.a.defaults.withCredentials = true;

axios_default.a.interceptors.request.use(function (config) {
  // Do something before request is sent
  // config.data = qs.stringify(config.data)
  var lang = localStorage.getItem('lang') || 'en';
  config.headers['Accept-Language'] = lang;
  return config;
}, function (error) {
  // Do something with request error
  return promise_default.a.reject(error);
});

// // Add a response interceptor
// axios.interceptors.response.use((response) => {
//   // Do something with response data
//   if (response.data.success) {
//     return response.data
//   } else {
//     return Promise.reject(response)
//   }
// }, (error) => {
//   // console.log(error)
//   // console.log(error.response)
//   if (error.response) {
//     // 不需要登录的路由 产品列表页面、产品详情页、搜索页、搜索结果页、退款政策
//     let notNessaryPath = ['Browse', 'Details', 'search', 'searchResult']
//     switch (error.response.status) {
//       case 401:
//         if (notNessaryPath.indexOf(router.currentRoute.name) === -1) {
//           console.log('未登录')
//           console.log(store)
//           // 跳转到登录页面
//           router.replace({
//             path: 'login',
//             query: {redirect: router.currentRoute.fullPath}
//           })
//         } else {
//           // 修改登录状态为未登录
//           console.log(store)
//           store.commit('changeLoginStatus', {
//             isLogin: false
//           })
//         }
//         break
//     }
//   }
//   // console.log(error.response.data.)
//   // Do something with response error
//   return Promise.reject(error.response.data)
// })
// Add a response interceptor
axios_default.a.interceptors.response.use(function (response) {
  // Do something with response data
  if (response.data.success) {
    return response.data;
  } else {
    if (response.data.code === 'G0006') {
      // 不需要登录的路由 产品列表页面、产品详情页、搜索页、搜索结果页、退款政策
      var notNessaryPath = ['Browse', 'Details', 'search', 'searchResult', 'aboutUs', 'privatePolicy', 'refundPolicy', 'terms', 'ContactUs'];
      if (notNessaryPath.indexOf(router.currentRoute.name) === -1) {
        // 跳转到登录页面
        console.log(router);
        router.replace({
          path: '/signin',
          query: { redirect: router.currentRoute.fullPath }
        });
      } else {
        // vux状态修改
        store.commit('changeLoginStatus', {
          isLogin: false
        });
      }
    }
    return promise_default.a.reject(response);
  }
}, function (error) {
  return promise_default.a.reject(error.response.data);
});
/* harmony default export */ var axiosConfig = (axios_default.a);
// EXTERNAL MODULE: ./node_modules/mint-ui/lib/mint-ui.common.js
var mint_ui_common = __webpack_require__("Au9i");
var mint_ui_common_default = /*#__PURE__*/__webpack_require__.n(mint_ui_common);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/mint-ui/lib/style.css
var style = __webpack_require__("d8/S");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./src/assets/css/mintui.css
var mintui = __webpack_require__("cp58");
var mintui_default = /*#__PURE__*/__webpack_require__.n(mintui);

// EXTERNAL MODULE: ./src/assets/css/standard.css
var standard = __webpack_require__("C5za");
var standard_default = /*#__PURE__*/__webpack_require__.n(standard);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/plugins/confirm/src/main.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var main = ({
  name: 'luoji-confirm',
  data: function data() {
    return {
      message: '',
      title: '',
      isShow: true,
      showConfirmBtn: true, // 确认按钮
      showCancelBtn: true, // 取消按钮
      confirmText: 'Yes', // 取消按钮
      cancelText: 'No' // 取消按钮
    };
  },

  methods: {
    handleAction: function handleAction(type) {
      if (type === 'cancel') {
        this.fail();
      } else {
        console.log('确认');
        this.success();
      }
    },
    close: function close() {
      var _this = this;

      this.isShow = false;
      setTimeout(function () {
        _this.$destroy();
        _this.$el.remove();
      }, 500);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ad57e2e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/plugins/confirm/src/main.vue
var main_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"zoom-fade","appear":""}},[(_vm.isShow)?_c('div',{staticClass:"modern-confirmation-modal"},[_c('div',{staticClass:"modern-confirmation-modal-pane"},[_c('div',{staticClass:"header"},[_c('i',{staticClass:"wconfont wm-guanbi",on:{"click":function($event){_vm.handleAction('cancel')}}})]),_vm._v(" "),_c('div',{staticClass:"content"},[(_vm.title)?_c('div',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.title)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.message)?_c('div',{staticClass:"message"},[_vm._v("\n            "+_vm._s(_vm.message)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.showConfirmBtn)?_c('a',{staticClass:"cancel main-color-background",on:{"click":function($event){_vm.handleAction('confirm')}}},[_vm._v("\n            "+_vm._s(_vm.confirmText)+"\n          ")]):_vm._e(),_vm._v(" "),(_vm.showCancelBtn)?_c('a',{staticClass:"confirm main-color",on:{"click":function($event){_vm.handleAction('cancel')}}},[_vm._v("\n            "+_vm._s(_vm.cancelText)+"\n          ")]):_vm._e()])])]):_vm._e()]),_vm._v(" "),_c('transition',{attrs:{"name":"modal-fade","appear":""}},[(_vm.isShow)?_c('div',{staticClass:"luoji-modal"}):_vm._e()])],1)}
var main_staticRenderFns = []
var main_esExports = { render: main_render, staticRenderFns: main_staticRenderFns }
/* harmony default export */ var src_main = (main_esExports);
// CONCATENATED MODULE: ./src/plugins/confirm/src/main.vue
function main_injectStyle (ssrContext) {
  __webpack_require__("z8yg")
}
var main_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
  var main___vue_template_functional__ = false
/* styles */
var main___vue_styles__ = main_injectStyle
/* scopeId */
var main___vue_scopeId__ = "data-v-1ad57e2e"
/* moduleIdentifier (server only) */
var main___vue_module_identifier__ = null
var main_Component = main_normalizeComponent(
  main,
  src_main,
  main___vue_template_functional__,
  main___vue_styles__,
  main___vue_scopeId__,
  main___vue_module_identifier__
)

/* harmony default export */ var confirm_src_main = (main_Component.exports);

// CONCATENATED MODULE: ./src/plugins/confirm/index.js



function merge(target) {
  for (var i = 1, j = arguments.length; i < j; i++) {
    var source = arguments[i] || {};
    for (var prop in source) {
      if (source.hasOwnProperty(prop)) {
        var value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }
  return target;
}

confirm_src_main.installMessage = function (options) {
  if (options === undefined || options === null) {
    options = {
      message: '',
      title: ''
    };
  } else if (typeof options === 'string' || typeof options === 'number') {
    options = {
      message: options,
      title: ''
    };
  }
  var NewMessage = vue_esm["default"].extend(confirm_src_main);
  console.log(NewMessage);
  var component = new NewMessage().$mount();
  document.querySelector('body').appendChild(component.$el);

  merge(component.$data, options);
  return new promise_default.a(function (resolve, reject) {
    component.success = function () {
      component.close();
      resolve('confirm'); // 再执行自定义函数
    };
    component.fail = function () {
      component.close();
      reject(new Error('点击取消按钮')); // 再执行自定义函数
    };
  });
};

/* harmony default export */ var plugins_confirm = (confirm_src_main);
// CONCATENATED MODULE: ./src/plugins/index.js


var plugins_install = function install(Vue) {
  Vue.component(plugins_confirm.name, plugins_confirm);

  Vue.prototype.$luoji_confirm = plugins_confirm.installMessage;
};
/* harmony default export */ var plugins = (plugins_install);
// EXTERNAL MODULE: ./node_modules/vue-video-player/dist/vue-video-player.js
var vue_video_player = __webpack_require__("iqGf");
var vue_video_player_default = /*#__PURE__*/__webpack_require__.n(vue_video_player);

// EXTERNAL MODULE: ./node_modules/vue-iscroll-view/index.js
var vue_iscroll_view = __webpack_require__("j1M6");
var vue_iscroll_view_default = /*#__PURE__*/__webpack_require__.n(vue_iscroll_view);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./src/lang/en.js


var _headerDetails$header;

/* harmony default export */ var en = (_headerDetails$header = {
  headerDetails: "Product Details",
  "headerSign In": "Sign In",
  headerSettings: "Settings",
  headertransaction: "Orders",
  signin: "Sign In",
  signinReq: "* Indicates a field is required",
  emailReq: "Email*",
  passwordReq: "Password*",
  newTo: "New to CalmPurr?",
  createAccount: "Create Account",
  firstName: "First Name*",
  lastName: "Last Name*",
  streetaddress: "Street Address*",
  state: "State*",
  city: "City*",
  zip: "Zip/Postal Code*",
  phone: "Phone*",
  country: "Country*",
  done: "Done",
  categoryPopular: "Popular",
  categoryCustom: "Photo Custom",
  categoryFat: "Fat Cat",
  categorySlim: "Slim Cat",
  categoryMini: "Mini Cat",
  freeShippingTips: "Worldwide Free Shipping on All Orders!",
  alreadyHaveAccount: "Already have an account?",
  code: "Code",
  bestseller: "Best Sellers",
  recommendforyou: "Recommended for You",
  ourcustomershow: "Our Customer Show",
  faq: "FAQ",
  faq1: "Do you ship overseas?",
  faq1answer: "We ship to over 90 countries and regions worldwide. To check if delivery is available to your area, please try entering your address during the checkout process. We’re constantly working to expand our global shipping services✈️",
  faq2: "How long will it take to get my order?",
  faq2answer: "Depending on your region, standard shipping orders may take only 6–10 working days to arrive. Customized products require an additional 3–7 days of production time before shipping. You’ll receive a tracking email when your order is shipped.💖",
  faq3: "How to track my order?",
  faq3answer: "Once your order has been shipped, you can find the tracking number and all tracking information on your Order Details page to see the real-time status of your shipment.",
  faq4: "What is it made of? Is it safe?",
  faq4answer: "Our CalmPurr squishies are made with food-grade silicone — soft, safe, non-toxic, and gentle to the touch.",
  faq5: "How many times can it be squeezed? Is it easy to break?",
  faq5answer: "Our squishies are very durable and can be squeezed many times! We recommend keeping them in their original packaging when playing to maintain shape and quality longer.",
  review1: "I love him so much, and the packaging and presentation were very thoughtful as well. Looking forward to displaying this squishy guy somewhere special!",
  review2: "Super sweet squishy, amazing quality! It comes with a cute pouch with its accessories 😍",
  review3: "Demorou a chegar mas valeu completamente a pena. É uma réplica perfeita dum gatinho de Bengala, amoroso, bem pintado, lindo! 😍",
  review4: "I wasn\'t expecting so much fur, but honestly I don\'t even care because IT\'S SO CUTEEEEEEE. It\'s like a perfect little stress toy for me!",
  review5: "Super cute, super quality. Didn’t expect it to be such high quality with great accessories.",
  review6: "I lost my kitty in January and ordered this in her image... it has legitimately been healing for me.",
  review7: "I got this as a gift for my amazing friend 💓 the squishy came in perfect condition and it was 100% worth it!",
  review8: "I love my cat! Shipping was fast and I love the basket it came with! I want to get another one soon. Thank you Bambi!",
  aboutus: "About Us",
  contactus: "Contact Us",
  privacypolicy: "Privacy Policy",
  terms: "Terms & Conditions",
  returnpolicy: "Return Policy",
  footertitle: "Handmade Silicone Cats",
  home: "Home",
  shoppingcart: "Shopping Cart",
  orderhistory: "Order History",
  settings: "Settings",
  youshippinginfo: "Your Shipment Info",
  shipping: "Shipping",
  payment: "Payment",
  apply: "Apply",
  description: "Description",
  shippingInfo: "Shipping Information",
  buyText: "Buy",
  addtocart: "Items Added to Cart!",
  thankyou: "Thank you",
  yoursavings: "Your Savings",
  shippingInfoDetail: "Free Shipping.  Ships to Worldwide",
  cartisempty: "Your cart is empty",
  continueshopping: "Continue Shopping",
  itemtotal: "Item Total",
  freeshipping: "Free Shipping",
  ordertotal: "Order Total"
}, defineProperty_default()(_headerDetails$header, "orderhistory", "Order History"), defineProperty_default()(_headerDetails$header, "notorderyet", "You haven't made any orders."), defineProperty_default()(_headerDetails$header, "shopnow", "Shop Now"), defineProperty_default()(_headerDetails$header, "changeemail", "Change Email Address"), defineProperty_default()(_headerDetails$header, "changepass", "Change Password"), defineProperty_default()(_headerDetails$header, "logout", "Logout"), defineProperty_default()(_headerDetails$header, "changeemailtips", "Use this form to change your email address."), defineProperty_default()(_headerDetails$header, "currentemail", "Current e-mail address"), defineProperty_default()(_headerDetails$header, "newemail", "New e-mail address"), defineProperty_default()(_headerDetails$header, "confirmemail", "Confirm e-mail address"), defineProperty_default()(_headerDetails$header, "enteremail", "Enter e-mail address"), defineProperty_default()(_headerDetails$header, "enterconfirmemail", "Confirm new e-mail address"), defineProperty_default()(_headerDetails$header, "couponoff5title", "5% OFF"), defineProperty_default()(_headerDetails$header, "couponoff5desc", "Orders €50+"), defineProperty_default()(_headerDetails$header, "couponoff10title", "10% OFF"), defineProperty_default()(_headerDetails$header, "couponoff10desc", "Orders €60+"), defineProperty_default()(_headerDetails$header, "couponoff15title", "15% OFF"), defineProperty_default()(_headerDetails$header, "couponoff15desc", "Orders €80+"), defineProperty_default()(_headerDetails$header, "contactemail", "Please enter your email*"), defineProperty_default()(_headerDetails$header, "contactsubject", "Subject*"), defineProperty_default()(_headerDetails$header, "contactDesc", "Description*"), defineProperty_default()(_headerDetails$header, "areyousure", "Are you sure?"), defineProperty_default()(_headerDetails$header, "cancelshipping", "Do you want to cancel entering your shipping info?"), defineProperty_default()(_headerDetails$header, "enterpromotioncode", "Enter Promo Code"), defineProperty_default()(_headerDetails$header, "removeItemTips", "Remove this item from cart?"), defineProperty_default()(_headerDetails$header, "removeItem", "Remove Item"), defineProperty_default()(_headerDetails$header, "cancel", "Cancel"), defineProperty_default()(_headerDetails$header, "placeorder", "Place Order"), defineProperty_default()(_headerDetails$header, "currencyChangeTips", "Reference only. Transactions are settled in Euro (€)."), defineProperty_default()(_headerDetails$header, "selectCurrency", "Select Currency"), defineProperty_default()(_headerDetails$header, "approx", "Approx."), defineProperty_default()(_headerDetails$header, "specialOffer", "Special Offer"), defineProperty_default()(_headerDetails$header, "christmasOffer", "New Year Special 2026"), defineProperty_default()(_headerDetails$header, "christmasOfferCopy", "Click the code below to copy it"), defineProperty_default()(_headerDetails$header, "christmasOfferCondition", "Order amount over €50"), _headerDetails$header);
// CONCATENATED MODULE: ./src/lang/de.js
/* harmony default export */ var de = ({
  headerDetails: "Produktdetails",
  "headerSign In": "Anmelden",
  headerSettings: "Einstellungen",
  headertransaction: "Bestellungen",
  signin: "Anmelden",
  signinReq: "* Kennzeichnet ein Pflichtfeld",
  emailReq: "E-Mail*",
  passwordReq: "Passwort*",
  newTo: "Neu bei CalmPurr?",
  createAccount: "Konto erstellen",
  firstName: "Vorname*",
  lastName: "Nachname*",
  streetaddress: "Straße und Hausnummer*",
  state: "Bundesland*",
  city: "Stadt*",
  zip: "PLZ*",
  phone: "Telefon*",
  country: "Land*",
  done: "Fertig",
  categoryPopular: "Beliebt",
  categoryCustom: "Foto-Anfertigung",
  categoryFat: "Dicker Kater",
  categorySlim: "Schlanker Kater",
  categoryMini: "Mini-Katze",
  freeShippingTips: "Weltweiter kostenloser Versand auf alle Bestellungen!",
  alreadyHaveAccount: "Schon ein Konto?",
  code: "Code",
  bestseller: "Bestseller",
  recommendforyou: "Empfohlen für dich",
  ourcustomershow: "Kundenfotos",
  faq: "FAQ",
  faq1: "Versendet ihr international?",
  faq1answer: "Ja! Wir versenden in über 90 Länder weltweit. Um zu prüfen, ob wir in deine Region liefern, gib deine Adresse einfach während des Checkouts ein. Wir arbeiten ständig daran, unsere internationalen Versandmöglichkeiten zu erweitern✈️",
  faq2: "Wie lange dauert der Versand?",
  faq2answer: "Je nach Region dauert der Standardversand etwa 6–10 Werktage. Für maßgefertigte Produkte benötigen wir zusätzlich 3–7 Tage Produktionszeit. Sobald dein Paket versendet wurde, erhältst du eine Sendungsverfolgung per E-Mail.💖",
  faq3: "Wie verfolge ich meine Bestellung?",
  faq3answer: "Nach dem Versand findest du die Sendungsnummer sowie alle Tracking-Informationen auf deiner Bestellseite — dort kannst du den aktuellen Status jederzeit einsehen.",
  faq4: "Woraus besteht das Produkt? Ist es sicher?",
  faq4answer: "Unsere CalmPurr-Squishies werden aus lebensmittelechtem Silikon hergestellt — weich, sicher, ungiftig und angenehm anzufassen.",
  faq5: "Wie langlebig ist es? Geht es leicht kaputt?",
  faq5answer: "Unsere Squishies sind sehr strapazierfähig und können viele Male gedrückt werden! Wir empfehlen, sie in der Originalverpackung aufzubewahren, um Form und Qualität länger zu erhalten.",
  review1: "Ich liebe ihn so sehr! Auch die Verpackung war super liebevoll gestaltet. Ich freue mich darauf, ihn an einem besonderen Platz auszustellen!",
  review2: "Super süßer Squishy, tolle Qualität! Er kommt sogar mit einem niedlichen Beutel und Zubehör 😍",
  review3: "Es hat etwas gedauert, aber es hat sich absolut gelohnt. Eine perfekte Nachbildung einer Bengalkatze – wunderschön und so liebevoll bemalt! 😍",
  review4: "Ich habe so viel Fell nicht erwartet, aber es ist mir egal, denn ER IST SOOOO SÜSS! Perfekt als kleiner Stressball für mich!",
  review5: "Super süß, super Qualität. Ich hätte nicht erwartet, dass es so hochwertig ist!",
  review6: "Ich habe meinen Kater im Januar verloren und diesen Squishy nach seinem Bild bestellt… es hat mir wirklich geholfen.",
  review7: "Ich habe es als Geschenk für eine wundervolle Freundin bestellt 💓 – perfekter Zustand, absolut lohnenswert!",
  review8: "Ich liebe meine Katze! Der Versand war schnell und der kleine Korb ist so süß! Ich werde bald noch einen bestellen. Danke, Bambi!",
  aboutus: "Über uns",
  contactus: "Kontakt",
  privacypolicy: "Datenschutzerklärung",
  terms: "AGB",
  returnpolicy: "Rückgaberecht",
  footertitle: "Handgefertigte Silikonkatzen",
  home: "Startseite",
  shoppingcart: "Warenkorb",
  orderhistory: "Bestellverlauf",
  settings: "Einstellungen",
  youshippinginfo: "Deine Versanddaten",
  shipping: "Versand",
  payment: "Zahlung",
  apply: "Anwenden",
  description: "Beschreibung",
  shippingInfo: "Versandinformationen",
  buyText: "Kaufen",
  addtocart: "Zum Warenkorb hinzugefügt!",
  thankyou: "Vielen Dank",
  yoursavings: "Deine Ersparnis",
  shippingInfoDetail: "Kostenloser Versand. Weltweiter Versand möglich.",
  cartisempty: "Dein Warenkorb ist leer",
  continueshopping: "Weiter einkaufen",
  itemtotal: "Zwischensumme",
  freeshipping: "Kostenloser Versand",
  ordertotal: "Gesamt",
  notorderyet: "Du hast noch keine Bestellung aufgegeben.",
  shopnow: "Jetzt einkaufen",
  changeemail: "E-Mail ändern",
  changepass: "Passwort ändern",
  logout: "Abmelden",
  changeemailtips: "Verwende dieses Formular, um deine E-Mail-Adresse zu ändern.",
  currentemail: "Aktuelle E-Mail",
  newemail: "Neue E-Mail",
  confirmemail: "Neue E-Mail bestätigen",
  enteremail: "E-Mail eingeben",
  enterconfirmemail: "E-Mail bestätigen",
  couponoff5title: "5% RABATT",
  couponoff5desc: "Ab €50 Bestellwert",
  couponoff10title: "10% RABATT",
  couponoff10desc: "Ab €60 Bestellwert",
  couponoff15title: "15% RABATT",
  couponoff15desc: "Ab €80 Bestellwert",
  contactemail: "Bitte gib deine E-Mail ein*",
  contactsubject: "Betreff*",
  contactDesc: "Beschreibung*",
  areyousure: "Bist du sicher?",
  cancelshipping: "Möchtest du das Eingeben deiner Versandinformationen abbrechen?",
  enterpromotioncode: "Gutscheincode eingeben",
  removeItemTips: "Diesen Artikel aus dem Warenkorb entfernen?",
  removeItem: "Artikel entfernen",
  cancel: "Abbrechen",
  placeorder: "Bestellung abschicken",
  currencyChangeTips: "Nur zur Orientierung. Die Zahlung erfolgt in Euro (€).",
  selectCurrency: "Währung auswählen",
  approx: "Ca.",
  specialOffer: "Sonderangebot",
  christmasOffer: "Neujahrs-Special 2026",
  christmasOfferCopy: "Klicken Sie auf den untenstehenden Code, um ihn zu kopieren",
  christmasOfferCondition: "Bestellwert über 50 €"
});
// CONCATENATED MODULE: ./src/lang/fr.js
/* harmony default export */ var fr = ({
  headerDetails: "Détails du produit",
  "headerSign In": "Se connecter",
  headerSettings: "Paramètres",
  headertransaction: "Commandes",
  signin: "Se connecter",
  signinReq: "* Indique un champ obligatoire",
  emailReq: "E-mail*",
  passwordReq: "Mot de passe*",
  newTo: "Nouveau sur CalmPurr ?",
  createAccount: "Créer un compte",
  firstName: "Prénom*",
  lastName: "Nom*",
  streetaddress: "Adresse*",
  state: "Région*",
  city: "Ville*",
  zip: "Code postal*",
  phone: "Téléphone*",
  country: "Pays*",
  done: "Terminé",
  categoryPopular: "Populaire",
  categoryCustom: "Personnalisation photo",
  categoryFat: "Chat dodu",
  categorySlim: "Chat mince",
  categoryMini: "Mini chat",
  freeShippingTips: "Livraison gratuite dans le monde entier sur toutes les commandes !",
  alreadyHaveAccount: "Vous avez déjà un compte ?",
  code: "Code",
  bestseller: "Meilleures ventes",
  recommendforyou: "Recommandé pour vous",
  ourcustomershow: "Photos des clients",
  faq: "FAQ",
  faq1: "Livrez-vous à l'international ?",
  faq1answer: "Oui ! Nous livrons dans plus de 90 pays. Pour vérifier la disponibilité dans votre région, entrez simplement votre adresse lors du paiement. Nous élargissons constamment nos services de livraison internationale✈️",
  faq2: "Quel est le délai de livraison ?",
  faq2answer: "Selon votre région, la livraison standard prend environ 6 à 10 jours ouvrables. Les articles personnalisés nécessitent 3 à 7 jours supplémentaires de production. Vous recevrez un e-mail avec le numéro de suivi une fois votre commande expédiée.💖",
  faq3: "Comment suivre ma commande ?",
  faq3answer: "Après l’expédition, vous trouverez votre numéro de suivi et les informations en temps réel sur votre page Détails de la commande.",
  faq4: "De quoi est-il fait ? Est-ce sûr ?",
  faq4answer: "Nos squishies CalmPurr sont fabriqués en silicone de qualité alimentaire — doux, sûr, non toxique et agréable au toucher.",
  faq5: "Est-ce solide ? Peut-il se casser facilement ?",
  faq5answer: "Nos squishies sont très résistants et peuvent être pressés de nombreuses fois ! Nous recommandons de les garder dans leur emballage d'origine pour préserver leur forme et leur qualité.",
  review1: "Je l’adore tellement ! L’emballage était également très soigné. Hâte de l’exposer dans un endroit spécial !",
  review2: "Squishy super mignon, excellente qualité ! Livré avec une petite pochette adorable 😍",
  review3: "Cela a pris du temps mais ça valait vraiment le coup. Une réplique parfaite d’un chat du Bengale — magnifique ! 😍",
  review4: "Je ne m’attendais pas à autant de poils, mais honnêtement je m’en fiche, IL EST TROP MIGNON ! Parfait comme jouet anti-stress !",
  review5: "Super mignon et très qualitatif. Je ne pensais pas qu’il serait aussi bien fait !",
  review6: "J’ai perdu mon chat en janvier et j’ai commandé ce squishy à son image… cela m’a vraiment aidé.",
  review7: "C’était un cadeau pour une amie géniale 💓 — arrivé en parfait état, 100% satisfait !",
  review8: "J’adore mon chat ! Livraison rapide et joli panier inclus ! Je pense en commander un autre bientôt. Merci Bambi !",
  aboutus: "À propos",
  contactus: "Nous contacter",
  privacypolicy: "Politique de confidentialité",
  terms: "Conditions générales",
  returnpolicy: "Politique de retour",
  footertitle: "Chats en silicone faits à la main",
  home: "Accueil",
  shoppingcart: "Panier",
  orderhistory: "Historique des commandes",
  settings: "Paramètres",
  youshippinginfo: "Vos informations d’expédition",
  shipping: "Livraison",
  payment: "Paiement",
  apply: "Appliquer",
  description: "Description",
  shippingInfo: "Informations sur la livraison",
  buyText: "Acheter",
  addtocart: "Ajouté au panier !",
  thankyou: "Merci",
  yoursavings: "Vos économies",
  shippingInfoDetail: "Livraison gratuite. Expédition dans le monde entier.",
  cartisempty: "Votre panier est vide",
  continueshopping: "Continuer vos achats",
  itemtotal: "Sous-total",
  freeshipping: "Livraison gratuite",
  ordertotal: "Total",
  notorderyet: "Vous n’avez encore passé aucune commande.",
  shopnow: "Acheter maintenant",
  changeemail: "Changer l’e-mail",
  changepass: "Changer le mot de passe",
  logout: "Se déconnecter",
  changeemailtips: "Utilisez ce formulaire pour modifier votre adresse e-mail.",
  currentemail: "E-mail actuel",
  newemail: "Nouvel e-mail",
  confirmemail: "Confirmer l’e-mail",
  enteremail: "Saisir l’e-mail",
  enterconfirmemail: "Confirmer le nouvel e-mail",
  couponoff5title: "5% DE RÉDUCTION",
  couponoff5desc: "Commandes à partir de 50 €",
  couponoff10title: "10% DE RÉDUCTION",
  couponoff10desc: "Commandes à partir de 60 €",
  couponoff15title: "15% DE RÉDUCTION",
  couponoff15desc: "Commandes à partir de 80 €",
  contactemail: "Veuillez entrer votre e-mail*",
  contactsubject: "Sujet*",
  contactDesc: "Description*",
  areyousure: "Êtes-vous sûr ?",
  cancelshipping: "Voulez-vous annuler la saisie de vos informations de livraison ?",
  enterpromotioncode: "Saisir le code promo",
  removeItemTips: "Retirer cet article du panier ?",
  removeItem: "Retirer l’article",
  cancel: "Annuler",
  placeorder: "Passer la commande",
  currencyChangeTips: "À titre indicatif. Le règlement s'effectue en Euro (€).",
  selectCurrency: "Sélectionner la devise",
  approx: "Env.",
  specialOffer: "Offre spéciale",
  christmasOffer: "Offre spéciale Nouvel An 2026",
  christmasOfferCopy: "Cliquez sur le code ci-dessous pour le copier",
  christmasOfferCondition: "Commande supérieure à 50 €"
});
// CONCATENATED MODULE: ./src/lang/es.js
/* harmony default export */ var es = ({
  headerDetails: "Detalles del producto",
  "headerSign In": "Iniciar sesión",
  headerSettings: "Configuración",
  headertransaction: "Pedidos",
  signin: "Iniciar sesión",
  signinReq: "* Indica un campo obligatorio",
  emailReq: "Correo electrónico*",
  passwordReq: "Contraseña*",
  newTo: "¿Nuevo en CalmPurr?",
  createAccount: "Crear cuenta",
  firstName: "Nombre*",
  lastName: "Apellido*",
  streetaddress: "Dirección*",
  state: "Provincia*",
  city: "Ciudad*",
  zip: "Código postal*",
  phone: "Teléfono*",
  country: "País*",
  done: "Listo",
  categoryPopular: "Popular",
  categoryCustom: "Personalizado con foto",
  categoryFat: "Gato gordito",
  categorySlim: "Gato delgado",
  categoryMini: "Mini gato",
  freeShippingTips: "¡Envío gratuito a todo el mundo en todos los pedidos!",
  alreadyHaveAccount: "¿Ya tienes una cuenta?",
  code: "Código",
  bestseller: "Más vendidos",
  recommendforyou: "Recomendado para ti",
  ourcustomershow: "Fotos de clientes",
  faq: "Preguntas frecuentes",
  faq1: "¿Hacen envíos internacionales?",
  faq1answer: "¡Sí! Enviamos a más de 90 países. Para verificar la disponibilidad en tu zona, simplemente introduce tu dirección en la página de pago. Estamos ampliando constantemente nuestras opciones de envío internacional✈️",
  faq2: "¿Cuánto tarda el envío?",
  faq2answer: "Dependiendo de la región, el envío estándar tarda entre 6 y 10 días laborables. Los productos personalizados necesitan 3–7 días adicionales de producción. Recibirás un correo con el número de seguimiento cuando tu pedido sea enviado.💖",
  faq3: "¿Cómo rastreo mi pedido?",
  faq3answer: "Una vez enviado, encontrarás tu número de seguimiento y toda la información en la página de Detalles del Pedido, donde podrás ver el estado en tiempo real.",
  faq4: "¿De qué está hecho? ¿Es seguro?",
  faq4answer: "Nuestros squishies CalmPurr están hechos de silicona de grado alimenticio — suave, segura, no tóxica y muy agradable al tacto.",
  faq5: "¿Es resistente? ¿Se rompe fácil?",
  faq5answer: "Nuestros squishies son muy duraderos y pueden presionarse muchas veces. Recomendamos guardarlos en su empaque original para mantener su forma y calidad por más tiempo.",
  review1: "¡Lo amo muchísimo! El empaque también fue muy detallado. ¡Deseando colocarlo en un sitio especial!",
  review2: "Súper tierno y de excelente calidad. Viene con una bolsita muy linda 😍",
  review3: "Tardó un poco en llegar pero valió totalmente la pena. ¡Una réplica perfecta de un gato Bengalí, hermoso! 😍",
  review4: "No esperaba tanto pelo, pero honestamente no me importa porque ¡ES DEMASIADO TIERNO! Perfecto como juguete antiestrés.",
  review5: "Muy lindo y de gran calidad. No esperaba que fuera tan bueno.",
  review6: "Perdí a mi gatita en enero y pedí este squishy basado en su foto… realmente me ha ayudado.",
  review7: "Lo compré como regalo para mi amiga 💓 — llegó perfecto y valió totalmente la pena.",
  review8: "¡Amo mi gatito! El envío fue rápido y me encantó la cestita incluida. Creo que compraré otro pronto. ¡Gracias Bambi!",
  aboutus: "Sobre nosotros",
  contactus: "Contacto",
  privacypolicy: "Política de privacidad",
  terms: "Términos y condiciones",
  returnpolicy: "Política de devoluciones",
  footertitle: "Gatos de silicona hechos a mano",
  home: "Inicio",
  shoppingcart: "Carrito",
  orderhistory: "Historial de pedidos",
  settings: "Configuraciones",
  youshippinginfo: "Información de envío",
  shipping: "Envío",
  payment: "Pago",
  apply: "Aplicar",
  description: "Descripción",
  shippingInfo: "Información de envío",
  buyText: "Comprar",
  addtocart: "Añadido al carrito!",
  thankyou: "Gracias",
  yoursavings: "Tu ahorro",
  shippingInfoDetail: "Envío gratis. Entrega disponible a todo el mundo.",
  cartisempty: "Tu carrito está vacío",
  continueshopping: "Seguir comprando",
  itemtotal: "Subtotal",
  freeshipping: "Envío gratis",
  ordertotal: "Total",
  notorderyet: "Aún no has realizado ningún pedido.",
  shopnow: "Comprar ahora",
  changeemail: "Cambiar correo",
  changepass: "Cambiar contraseña",
  logout: "Cerrar sesión",
  changeemailtips: "Usa este formulario para cambiar tu correo electrónico.",
  currentemail: "Correo actual",
  newemail: "Nuevo correo",
  confirmemail: "Confirmar correo",
  enteremail: "Introducir correo",
  enterconfirmemail: "Confirmar nuevo correo",
  couponoff5title: "5% DE DESCUENTO",
  couponoff5desc: "Pedidos desde €50",
  couponoff10title: "10% DE DESCUENTO",
  couponoff10desc: "Pedidos desde €60",
  couponoff15title: "15% DE DESCUENTO",
  couponoff15desc: "Pedidos desde €80",
  contactemail: "Por favor ingresa tu correo*",
  contactsubject: "Asunto*",
  contactDesc: "Descripción*",
  areyousure: "¿Estás seguro?",
  cancelshipping: "¿Quieres cancelar la introducción de tu información de envío?",
  enterpromotioncode: "Introducir código promo",
  removeItemTips: "¿Eliminar este artículo del carrito?",
  removeItem: "Eliminar artículo",
  cancel: "Cancelar",
  placeorder: "Realizar pedido",
  currencyChangeTips: "Solo como referencia. El pago se procesará en Euro (€).",
  selectCurrency: "Seleccionar moneda",
  approx: "Aprox.",
  specialOffer: "Oferta especial",
  christmasOffer: "Especial de Año Nuevo 2026",
  christmasOfferCopy: "Haz clic en el código abajo para copiarlo",
  christmasOfferCondition: "Pedido superior a 50 €"
});
// CONCATENATED MODULE: ./src/lang/index.js





var messages = { en: en, de: de, fr: fr, es: es };

function t(key) {
  var lang = localStorage.getItem("lang") || "en";
  return messages[lang][key] || messages["en"][key] || key;
}
// EXTERNAL MODULE: ./node_modules/iscroll/build/iscroll-probe.js
var iscroll_probe = __webpack_require__("gZet");
var iscroll_probe_default = /*#__PURE__*/__webpack_require__.n(iscroll_probe);

// CONCATENATED MODULE: ./src/_common/js/filters.js
var orderDate = function orderDate(val) {
  if (!val) {
    return val;
  }
  var year = val.split('-')[0];
  var month = Number(val.split('-')[1]);
  console.log(month);
  // 去掉 09前面的0 或者直接转成number
  var day = val.split('-')[2];
  var monthsInEng = ['', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  // return monthsInEng[month] + '' + day + ',' + year
  return monthsInEng[month] + ' ' + day + ', ' + year;
};

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

















//import IScroll from 'iscroll'
// 改为使用 probe 版本：

__webpack_require__("g3Gj");
__webpack_require__("5LIk");
// import './plugins/plugins.css'

fastclick_default.a.attach(document.body);


// 导出的是对象，可以直接通过key和value来获得过滤器的名和过滤器的方法
keys_default()(filters_namespaceObject).forEach(function (key) {
  vue_esm["default"].filter(key, filters_namespaceObject[key]);
});

vue_esm["default"].prototype.$t = t;
vue_esm["default"].prototype.$axios = axiosConfig;
vue_esm["default"].prototype.$cookieApi = cookies;

vue_esm["default"].use(vue_iscroll_view_default.a, iscroll_probe_default.a);
vue_esm["default"].use(plugins);
vue_esm["default"].use(vue_video_player_default.a);
vue_esm["default"].use(apiList);
vue_esm["default"].config.productionTip = false;
vue_esm["default"].use(mint_ui_common_default.a);

/* eslint-disable no-new */
new vue_esm["default"]({
  el: '#app',
  router: router,
  store: store,
  template: '<App/>',
  components: { App: src_App }
});

/***/ }),

/***/ "ON5F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Od5u":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./refundPolicy-de.vue": [
		"Kwyo",
		7
	],
	"./refundPolicy-en.vue": [
		"Sfrg",
		6
	],
	"./refundPolicy-es.vue": [
		"KsD3",
		5
	],
	"./refundPolicy-fr.vue": [
		"rYGY",
		4
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "Od5u";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "Of3F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "R3O8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RquW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "S7Ll":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ee263eb8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SiteFooter.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"site-footer"},[_c('div',{staticClass:"socials"},[_c('a',{attrs:{"href":"https://www.tiktok.com/@calmpurr","target":"_blank","aria-label":"TikTok"}},[_c('svg',{staticClass:"icon",attrs:{"t":"1761753473283","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"6835","width":"200","height":"200"}},[_c('path',{attrs:{"d":"M795.097316 453.530738c-56.061724 0.622364-106.519893-16.195129-153.860552-47.341796V624.833422c0 97.174187-66.030933 180.647253-160.091022 202.449351-128.318578 29.27616-236.705564-63.538062-250.410098-174.415644-14.326898-110.879858 56.684089-208.05632 165.073352-229.858418 21.177458-4.359964 52.324124-4.359964 69.766257-0.622364v117.109191c-4.984604-1.247004-9.969209-2.490596-14.951537-3.11296-42.358329-7.4752-83.470791 13.703396-100.29056 52.324124-16.817493 38.620729-5.606969 83.469653 28.656071 109.632854 28.653796 22.424462 60.421689 25.536284 92.813084 10.587022 32.393671-14.32576 49.835804-40.487822 53.571129-75.994454 0.62464-4.982329 0.62464-10.589298 0.62464-16.193991V196.265529c0-11.834027 0-11.834027 11.832889-11.834027h92.81536c6.85056 0 9.344569 1.244729 9.966933 9.343431 4.982329 72.257991 59.800462 133.926684 130.189085 143.271254 7.4752 1.245867 15.57504 1.868231 24.296106 2.489457v113.995094z","fill":"#333333","p-id":"6836"}})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/calmpurr","target":"_blank","aria-label":"Instagram"}},[_c('svg',{staticClass:"icon",attrs:{"t":"1761753668967","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"8273","width":"32","height":"32"}},[_c('path',{attrs:{"d":"M682.666667 128H341.333333a213.333333 213.333333 0 0 0-213.333333 213.333333v341.333334a213.333333 213.333333 0 0 0 213.333333 213.333333h341.333334a213.333333 213.333333 0 0 0 213.333333-213.333333V341.333333a213.333333 213.333333 0 0 0-213.333333-213.333333z m138.666666 554.666667A139.093333 139.093333 0 0 1 682.666667 821.333333H341.333333A139.093333 139.093333 0 0 1 202.666667 682.666667V341.333333A139.093333 139.093333 0 0 1 341.333333 202.666667h341.333334A139.093333 139.093333 0 0 1 821.333333 341.333333z m-64-373.333334a42.666667 42.666667 0 1 1-42.666666-42.666666 42.666667 42.666667 0 0 1 42.666666 42.666666zM512 320a192 192 0 1 0 192 192A191.573333 191.573333 0 0 0 512 320z m0 309.333333A117.333333 117.333333 0 1 1 629.333333 512 117.333333 117.333333 0 0 1 512 629.333333z","p-id":"8274"}})])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.facebook.com/862252023639525","target":"_blank","aria-label":"Facebook"}},[_c('svg',{staticClass:"icon",attrs:{"t":"1762019438711","viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","p-id":"4631","width":"48","height":"48"}},[_c('path',{attrs:{"d":"M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32z m-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z","p-id":"4632"}})])])]),_vm._v(" "),_c('div',{staticClass:"links-row"},[_c('router-link',{attrs:{"to":"/about-us"}},[_vm._v(_vm._s(_vm.$t('aboutus')))]),_vm._v(" ·\n    "),_c('router-link',{attrs:{"to":"/contact-us"}},[_vm._v(_vm._s(_vm.$t('contactus')))])],1),_vm._v(" "),_c('div',{staticClass:"links-row"},[_c('router-link',{attrs:{"to":"/private-policy"}},[_vm._v(_vm._s(_vm.$t('privacypolicy')))]),_vm._v(" ·\n    "),_c('router-link',{attrs:{"to":"/terms"}},[_vm._v(_vm._s(_vm.$t('terms')))]),_vm._v(" ·\n    "),_c('router-link',{attrs:{"to":"/refund-policy"}},[_vm._v(_vm._s(_vm.$t('returnpolicy')))])],1),_vm._v(" "),_c('p',[_vm._v("© 2025 CalmPurr · "+_vm._s(_vm.$t('footertitle')))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var SiteFooter = (esExports);
// CONCATENATED MODULE: ./src/components/SiteFooter.vue
function injectStyle (ssrContext) {
  __webpack_require__("4W1K")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee263eb8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  SiteFooter,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_SiteFooter = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SkKK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "VnPR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WUj0":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./privatePolicy-de.vue": [
		"oZJk",
		11
	],
	"./privatePolicy-en.vue": [
		"QeKR",
		10
	],
	"./privatePolicy-es.vue": [
		"UazA",
		9
	],
	"./privatePolicy-fr.vue": [
		"pg06",
		8
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "WUj0";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "XD9B":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "XOTN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Y6Yn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bPW5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bvaf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cPTq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cRZH":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "cp58":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d8/S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eYOx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "fMn/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");


var bus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/* harmony default export */ __webpack_exports__["a"] = (bus);

/***/ }),

/***/ "fjbu":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "g3Gj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gAK1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gFVX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hfyF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iYhk":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "kOC9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "masZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nhJG":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,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"

/***/ }),

/***/ "q4nn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qDMi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qf9h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "tGic":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "v2ns":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vDM/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wwva":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "x0eS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yg1H":
/***/ (function(module, exports) {

module.exports = "data:image/gif;base64,R0lGODlhQABAAPIAABAOEDIyMk1NTW1ubZOSk7Ozs87Ozv7+/iH5BAgJAAAAIf8LTkVUU0NBUEUyLjADAQAAACwAAAAAQABAAAAD/ni63P6qjGGgvTjbIrqoWiiKhCcQY6o+pYeuMGNMxdV2LzQEVGxNgkHOcTv9AkiB7zGbTECOgWnIKCCv0OUC6IQUqQvBFal1SJyCGnHKGgfA2lmnu3Y93IHy4wxUM6R2DTtjfnp/Uk5ZB18NBm5Khg4GQUFCgmx/boqRCgRoPQuMC1ZjA3EZTogMogp4mzKvCwYEnoVEiDSjtLR+BG5wCjMASLGenkKxB1wTGWJXkG3DAADQDce0EwSvfMkNHEi2EUjTAeRe2MZCcAPhqNXBAtPS5O+r10L47WUE5OXyAfUapctmrJsKX/LmgQsxYyA6Pf6G+SsH7MIZbLnKDEjo/s9UjGu0Il2Z9iHOMYMp+A3TB6NAxRhvOMmcSbOmzRUGchookJNnz50oYRyjBGhZhVm7kirlSTNewqcJCbh0yatq0qArNkLdGoBqUq9XaWrdCnWn1V1gsapwSjbqgZ48fQLVqTYlrkp4M97cy7ev3xg5ZQY2tLMAU8KGDy9JnDgSY8M+Cj+ue0EyY8pvH1/Wo3lziM6JMVcGDRmD5ck0zXZORnob5sGNQMeSzaQxw9C1GUvVNznZ6QyaLZxmbbjbcFl0oRwXbls48MdVPEeAbjoOalnSM2efedqWZUXBbYaXsb17zeXkccfebmh8+uJ7qHNC/15xffuc5a+Hn7t5JXv2wQConX/58dcffuTtJpiBBxrH4F/f/aXCdRKOwFiFKswlUwIAIfkECAkAAAAsAAAAAEAAQACCDw4PNDI0Tk5OcHFwlZSVsrKy0NHQ/v7+A/54utz+ygxioL04WymGqFooioQ3TGOqPuUpFGvcGAQBW0TX3Q/dgTLWacBzlDooSE7ADPZKtQGw0dpBDMzs1KmYDAlKV9KRzXIdhdakuDiewMayAH5mTFp0hvr1KAcEdWhfNkZDY21ybIEHNWpxHnwMWGUDiw4SXjVUhmyQfx+WRmoUepCHk1mVTlsPb2+lXwxyoBesVGmKDGleUgtpjUBLWbkRAwF/tge/NQXJB7yHEJBmSsfWgCzMjc09d84NBcMP4dblEMuNNbaEKSWXxuXWquPa6eyhBPHl81fo9t8qCui7BnABDRsIt9URMPAYsQsFluF6mAJePFIrDERMt/4oHq0gGm0UHCHwD8WAJ1fMCcWypcuXMEMYmEmzZs2Wagzp7KUxos+fP0euMAYgQNGjRo0CAAC0KVChKgYsXap0atKiTrNCrXiUqlekH7I23TpCKtKpXZfesMmWJs6dcFPGnEu3rt1LZDMYCJCHS09ugQhM7Ruj6SK0RfMadKq4FeKl2EbM1FrnMVp+GMQCrmPWMlMMf8e2FOC5qAXN4/JqvFQVcWRwTk9HhOrznOdzT2X/zGBYGuIAur+F3sx2cdANnYXztlHb+GxdQEHLlX7c+eYDf0XGzC2puvXpMnp398lKfKjhrEKn5x7KvHVb7Beh7+F9PPn20enf1998USV8+9cBCJ4I9c1QIIDnPbfBgdAFWJd6d6UAYYQihEahhM00dkECACH5BAgJAAAALAAAAABAAEAAgg8ODzMyM05OTnBxcJKSkrOys9DQ0P7+/gP+eLrc/soQYqC9OFszyBiVJo5j4XkFqa5P8XUpKzOGGUPmeT9nOLe5XcPVGQgZH8Hn96hNJr7GCQbhJEFMByG3xXk+R8VVmXXYtpTWB9VSDpTh7PPZmlAd12XZITlHFV93DB5uRnt1c2aBQgZubodNE0FDa12DL0p/kAoFXAVRLl87Vm8dWZpaczuhbAulLxmoDJ2fF51zPrSduUoCSgQbBL5YQLqyB082GS+wOL7PAzi6tFWSxw0cmW3P3FXTukArHg9v3AIBAsDe37ubC8Lm0Bg17J/XKwXx0PcL9PVl2fQJiHPBn7E98Mypk/EN0jN0xH4YoMePRD5fFUfUcGf+yJ3HjyBDitQwsaTJkx/tnJii6oDBeu08EghAs6ZNmzDZZRR3s2fNgTkPyvTpU8BLmDtVDCDaM8bJpyVTsuzAMs3Iq1izalWxcVOAhXtoJc0wE0AAghaF7gkAoC0AozOO1iozoC1btgCicUW61q1ds19L8D1U9q7fs/MGb+KA929bARZythh7YCkfAX8N6zWjUxpaKW7BLihgGG8Az7uONcTgt60FAo4he7720sdTV603k7NLO8PqCGoPNG5LmzKfaVEMRoHtVzbIo0OCC2/9mcnvftILtAbwHPlxsQ4w+xV96Dp28Ni2e6zdRLqY3O7Mn4/pQP0m7+3Rm2lt3JYi/u/0OTCcOxQV5F4/mCG2FXD/LRjLgQ6u00mEJEw0FyQJAAAh+QQICQAAACwAAAAAQABAAIIQDxAyMjJOTk5ub26Tk5Ozs7PQ0ND+/v4D/ni63P7KlGKgvThbQzqpWiiKRVeCY6o2XPmtsCOhj9vRjofHzORvJkLB0hkMCLyHxEeB2IQQztG4SzInTuENQph2ksprtbV1lIzdIdh8rQWr3e5xHWbunuqecVqlX/MLZC8MUnFIdHVMDTZYDHJofYhLPjQcOoRHRYAwkQtiPR6DCnFoGZ0HlBeTEygzM55eA5uLAlROPkKRnxhyRRYFA7XBh2x2sxGpGlIDY8F7wlF/P2anbjIEws6l0dJNiHpG2bXE3NIG1SPAtcICwugHq390z3t7xxjd7xmP4bI8LdPmrTuib8OSgqb2IMQg4ZsCfw4jSpxIseKKcxgzapz4/iSUxwrxunmLiK2dyZMnRZqbWNJkAJQmZam0wxKmzVoh89WE+RKlGo1AMXL0SLSMxaNIkyqNcS6iAHJgJi28UCDAy3sp5CGyypUZ05VrCHAdKypETlZ0BIxVyxVrMbB0sI1de+rsyG8GBswdO+CXTmoqgsnQuzdA3xpwCSXLUDUAgGMF2K6NJgRtuUYXHAPYHODXXAF+78rYdQBbOGIDODuG2oBwgE7VtCoQsHnzYQWaa8OeyoL0Adq1QXvS7Pj2xCWVcQC33QC4ZrdgZC9YDkB4IM6brUeMt4O68YfYAbD208ZB6uAyHBOXyP2B9wcEahePKJ3B+wfENzts7752LHUnuQHAW2ii2eefds3JJ5FlENzX4EsDJuHgUiJMSKEG8dUG3YU5WDVeEgkAACH5BAgJAAAALAAAAABAAEAAgg8NDzIxMk1NTW9vb5OTk7KxstDR0P7+/gP+eLrc/sqYAqu92M7Cs//gsXFGaJ7MWJRou5AaB1cFQbmQvFYq+9Q1As6h2j16EANhuRw6VrqkztcI2oTOlM7YQBKZS2r2INscpw9wbdzdikXo6jL4Hm9v2rJjPmcT3W16DFY2dWxFVF4RfDZDhoMkHQuKB2BNF48KglJxIhKfk0w1mQUDYTmAqJs0aqwEpqaqZXiBEh4Tp1+vsLFnd5JVmTlYVby7jZy/wi2lu8bESUVlyyA1pksDsATUcL/AONjOsNx5qUPN2aItEltsx6bkPBvxGAbp9Jj4GNt+/f7/AAOi+ESwoC1/MuYAuTKqm7dOfggIyDYx24CKFaU91Jf+odRFihgtZtOo7F+pkBVBwntoLuJHkR9TUjBI82C/hEEWAuEosKfPn0An8awggJaTVecETDR6gl2UMUqjDuCpcSgDiVGjQvuwMctFAQGyKmVKo6sdsVmnYjLbDytaAVsheXsQYIAJiV/ewpX11MEAAIDj5ghAmOzJsFn5cnEAuHEADGAJh6Uh1q6qTH8bA7BcydgCApLDCv6MOJMwA5oBM8gMoC6DyJJPDwmQmtZfwpsHhXYdkEDqx6s1c1YAm7DVC6kBiLlNeLiI3QIAsgYcvcFtwM4PDNhN1lHyB9OzHyhe3c/03H4BN0+ze/S67w8EtMYOoThwO7UhbFcvnswt7uMNaFZeeo25t51kN9E2oF+00dafAtsJAOAJ4QVlAnO8WciVZt1pSFlR/SQAACH5BAgJAAAALAAAAABAAEAAgg8NDzIxMk5OTnBxcJOSk7Oys9DR0P7+/gP+eLrc/sqYAqu92M7Cs//gwY1GaJ7MxpVou0wspBaxI9FuNeLyXjeznG3HG5J6PmGDSHnMfgumEkiEHp7O6nSZdGi9xC21myK/vuJoeLxit9Pl9fkYp8Pn9qt5VmxZuXlYajsYf4OGemQSizF8iBwEBDpoYHlIb04EBZGaEEx9cRIeKlYTnKeXm4ReiD0PqpGbmk1Zn6BbsrKxnRq2NK0hpqect6lSSrmau8BGlC660M9yyKe0LjfFfrHMH6Jp2Xfh4uPk5Yzn5+G+Wny+3CYFAwME8vP1kfPt7ur29PTz/wCuc4arnryABw/q+/QuxCaACfEBZIGuYkMQCwmW28j+saNHDAMCwBlgTQgBACglbTEgQN5FJwFQynxZwaAAAjSvCJDJc8CUAi0FtDxoYgDPoyKVyBs6VF5JHUePqvy5tOqAlq1iRkXp807AplenOti5VQCUAF1B0LPx1aBYBlsBPD1AIIDdua+uCpgb76rflhCivmWgFaUAkEIT6/BL9JXMtA9Cygww1d88WkAT37RAD6sFcFcAxBzNoK5dtAw0C22VM3VhuQxCnhYLNEDiwd8mA4B8QLZd3noTt85QOOYP35tTqOYtpq5org7qCvgdXXMAvEJQak3awDflB6oPjyyO2ztzuqpxXxutHYJ39cGFpjHA87r76dRfqR7+QDsoAPGRnfbdfYrNlx8EptmlngJ+8deCeR+FkOCAEXpQgIAOkpMZdi0kAAAh+QQICQAAACwAAAAAQABAAIIRDxEzMjNNTU1tbm2SkpKzs7POzc7+/v4D/ni63P7KmAKrvdjOwrP/4LFxRmiezFiUaLuQGgdXm1vJK42zD07ZDVXuoeI5fEbgwfdzFCFMZRBJ3FWtUgbViW1Es6ltWJYUicGKr7b78qGnbDPZ637D54tnnkOY2dc4Y35LdRoxg1xdEos8QmWCN2d0eIcyOnFtanePV0N3hZ+gL5waj0KUiUyeaKeonUwSYK0kpKGiLaquGbm1ILMumkDBKBKINiO9IbFoq3/Oz9DRzwUDAgID1djV1wMEfxsTxcUrOQQA5+jp6QLfBO7v7wV9fQYB6vfoA+3y8vPw7gXwCdRnx0C8gwflCbzHzk6/fvAgEihBzZo2bha7fRNH/otcM2kgQ4ocWYFAgDcTwRSwB6CJEoPdkmEwIAAAy5NZsLmLSWzAOZY2vSmhRkBnN5ceTNr8eVNK0ac7i8pcYu8mugBIj3XT9pSnBQFWfwIg+IbaVqgaIdS0GiCAgDIChIKQ1+Os0awKlqbD+sBkW7xEtOGF2a1oWgc37cl1ALatWwwXsdHo6g5KVbJ9HbeVK7GJWa4WiKakUaue5oYKtllbnI3bTCADNPNdQMDaai2RFzuUjflAbdu6a2O7NhVFY8dJft9OEbm3Stm6fduO60C4tuIhZONsoJq6g+Ha7MTWHF068Lrgy7ugeRqCcu/fwTs/JpvTe/UGsmHDnkHzJ3wF95XEzX/rgUXgAbGdV9J+JAE4nXoN9vVghB7QZBt/JJkFmAsJAAAh+QQICQAAACwAAAAAQABAAIIPDQ8zMjNNTU1wcXCVlJWysrLQ0ND+/v4D/ni63P7KmAKrvdjOwrP/4LFxRmiezFiUaLtMLKTGD+xWHFnNeE7dDdVK5qM1fEMgA/lz8B5MZRBpjBRrVOkRic1VD1FtKjv1OsniF7es25rT47X6vWB+xULa03q9SS5oIn0KYS0GAIgCGmgSjTF5iwRNDgGIlgM9dDtyZ5wMlqABk3NJGCNfQjkQAqChVaUff51FsCmVrZdwfEy1DgW4oAR4vCR3DgTAiAFSxG2xrLiYSqm9HwW3lsM+SsiIwlqnYshw1brm5+jp6gUEA+7vA+3v33CO9vYK3a2V2ADS9c2oBOAHYOC+gvTSUCPWT9nBhNoC5iBA8JZBbP8USlQF/mYevI+jwN0bqa6kyZMoTxBQlKYcimsCROEhIMnYs4EDWTKTRDMkiAE4g0JswY6mUUkmVgYNqvPG0Z5GbS6JuTSnT0NQn7pUALTqwIwzeWqt0LXqgCrxTLA7I7YogTteBXwpIEDAgKtOaJ6tcdTtqqV468a0i0FevKFq+srAiXjBSsEC6LlFSsgjXjBRNdg0AJmwY3iTjL4rOaAzjXZ2I6eYR/kcZ8hgDd9tINqd1BulIRtZWTrtank0z9GFPFT20ALxkt9G0bnpZ7uzjyX3neaxYJ/y7CI2YBlOZ7Cf311tR76xoc7j65ZubAD4XjGwKxiXn9y8ofUWeNu9TH65Fq7s0aX0AWru2CegE9DJdSAI3L0FRwIAIfkECAkAAAAsAAAAAEAAQACCEA4QMTExTU1Nb3BvkZCRsrKy0NDQ/v7+A/54utz+ypgCq73YzsKz/+CxcUZonsxYlGgbAYCgceTMuo4BwzKk3g5aB9fQ7QCUx68iXBFTR0DAJwQymsnnQhAdKKtfsJYRBVhF4gZ23BhEe6n0QuVkk6PW5nltv0ancTR5TX0OAVFZaIKBizhnRWWMdQp8LUYAXhVcRwRzEp9zehZCFYeHUp0Qfxh0FXSJDKZSPLAKbjC1VDU5r7kHt7M7A2cBmSASYViPIgKnUgGnqXNavbtMp7KmvijVQxkEZdhaWHIet9iY1OTLGQZc4mOtRAWn2ycj7CcDcGOThf8AAwocmIIAgQEGDyZEOMCei08QIyI7QACaxYsYpdnppv6nGcaP0DSy4VjFI8iM/0g2OflRZDxy5CIoNIiQZk2HliTqzEewp8+fQBcUMBaPZ4gCApLiPEbCKKt9SQUQnUeoRcWoUV1yW2cCKVasU1vAtHZhaNQAX5d+4IgB6tekWp90Y+f2K4EzDU1MSCbqwVupj4YOGObBgEF/oWI+qCtg22CpAuJeSUhgG51l7uCOGvw4i+FGIg4bzDfiAk8Dj6USLaAw74KErO+aJnLwMWGhDF3LrFxZrdh9wEUKRgiLA2WBnIHnqal7N2/fXYEPrsV6cOUcvEf/sy31wVCFubJf70NA9XTv1pvPEQ/dA2TrEIaPDyJaMjfpApbFPuhrwidxO8lJVt158YnWB2oIWTCTemrMF5R87QFVHX9BHcOQbBWupZ0dCQAAIfkECAkAAAAsAAAAAEAAQACCEA4QMzIzT09Pbm9uk5OTs7Ozzs/O/v7+A/54utz+ioBQoL042wI6qFooioIHDGOqPqUnrHBjCAFqtd1rGYURXwGXZWCyPQpI5O/YCVIgRI/RgSQgfctGswnBnSDJZNZBDHYILJNOFu6NZZN4IC09tt8OySRQc3jXCzxhWHgMZh6ECl5TCm0ghQwcRQ2LDY6QLHxmjwd/DIJhWYkPBmZODJULlxijMjR9Q3FnCwQCAwICaAqgVxegN5oBuRayExm8rYFtyQfBmgLJek8aoMm8oQ8DzpoDrQG6Izykjr1Q25rgkNeDGAWv2wKcouRiIbXnwm/05SIGBOeMYqxTAmNGMEBZVi1xx0fekmqFamFyg6mixYsYMx4jwP6xo8eODt8YGEmyZMlGuIThWslyWMWB5AzcatlSZbpCMAtYSSKTps94FnOSo/GTqEtMQtn5+8jUSlCTUEdqnEq1qtUVBQKKYgYj64BuOK9w7Ufg1letMRSuKGvWbMgVA8eCaWvrLFoV+ygea2vXltwUQjPU+lr37FtROx1xLVt4JoFWTgFba7OTGd+61r4+DgHRAUwohL8eHlC2dAa1bNiROnvTEmmOAx6V1Htt7C9fGUizjuQxEWpSWWC/9u2R07qMMjWTlmHFyqjfkEoPt9Sbyp2gukV7rs5cNSa2HY9wt3QdUlbwIavoDFkbE+vl4kFCuOYePLOlHO+Xx6OZ4yKG5npZVw9O4e1QnC8EXdXIeApSo1N+DZL14F8RKhPgGwkAACH5BAgJAAAALAAAAABAAEAAgg8ODzQzNE5PTm9wb5SUlLKxstDQ0P7+/gP+eLrc/oqEUKC9ONsCQjdaKI4DYALDqK7P4HkpKzOGEMRQ+eLPC86QyYTX0JmIDM8J+DAIJ5WWCQbhnAA/5sL5FOSuSMXVlNUqXE+CdIJ6EMZh7XMinSINY6zZIUk7SnYOAmNqe4JzZQdGbQxWJwGGDwVzRIAdREonUZFFc5uKU4wRY5BMBokNXEJeC4s8eaipFwYDAgKFOXO4BAO9A7iWR7MFxBa1trafDXOsF5kmFgbE07EHyNcDyhETAtoQbya4NNLT0znX1wSoAeIhNk3l5dWK6OmcW/HyGAXHAfXeM8jlKxaiQD1kcVYMpKbCAAFk/my1CyiQoQxa2CLlM8P+L1kkgfNYPLxXIOS9kyhTqlyJj0ABAjBdxjR38pTNmzgVGPTFs2c2lBUXEnPYS8CxokaPAdQSVCitokeTGjW61JTQeNKS9tTaa+KepgtBSINJTKZMmvdwqrXJsq3bt3BZvExrsiGvAXVHkDtl5m5MjfGA+P3Vq6regXlT8VrcFeYep4mJEvbr8uPVDPxg/tJcueblb4R7lnRA8LCksKC7bo7l0GXiA2hJD/zGuLOkmLY3BIYQtBrR3KRxj1agFp++aLGbZCD71/jQRrujcZypjsZx4lhXtp6Z6jr2citxO+5u0Xlyy2a1VUTVG6Vwr+tPl9fIvLqD+PezcxIPEH8tfvAfMTfcf8/BA2AkwiE3X3cuGSbDS1X5Z+BrnEgYlwYWXohBRRo2VBKFISQAACH5BAgJAAAALAAAAABAAEAAgg8ODzExMU1NTXBwcJKSkrKystDQ0P7+/gP+eLrc/qoIYaC9OFsTeqhaKIqDFxBjqj6lh64wY0wv1HY1G1CxNU0DC8EUhAgAyEDvMfvxdJ6io5BEgpYMp0DaKAlwkA4S8ME2CNrCY9gR5BYE8phrVmgF0A79YJCTlXVnWm8HNycOJX6EgQNaVwqGbxxjAHiBDk0/dIZ0RwFjj5cLjU6PbGALVJR7KqGYdwycDJ9/ZRuuMo0Di3BpcAS7A2qQYki8fEdWNlsDzcMPWqwNtElClGQ2uswDuBITuA8FYouq1wAQaM3buyzHFo2v5kiWa7r2W+4xBgPy1Rf7WzQ143YpTr8AzzAUGKguYD4R1Mw9dACMlK6JGpJdI7j+wkDFgYH6UEKIBSDHOgYBJMSyUNQBANJcypxJs6bNBgYK6NzJcye4kgaCCh0qVIFHhh8rAlsZsqdTn8CiBpMalWmdnDoJPIXajIDUrmCtmsG6tee+pLuU7hJbsmxPo259ziRKd+jNu3jz6m3FVt/PjloJ/OVbIKiZAl699lVhtgfixI8HiyDLUzKmx4EDLxbRU6tcDR4VJ05sebLbDIizjhY89zQEzJC1histo9tWcI9Ta8VFdsRnnJR3vl79MzjqtxCCg8up+F9jo0QXKHeukyXyCJUZOM1Ae8NzuL/5fKe5XUZ27ddnljcfHjtPmtNxnmffPtB6+oXDpW86Hz8v7/F13Offa/sd1t+ATBRonU7FHYifS1j9RZmEDO4lnYMWUldhhiFQxuEIORkmSgIAOw=="

/***/ }),

/***/ "z8T9":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./terms-de.vue": [
		"qO2k",
		3
	],
	"./terms-en.vue": [
		"fASz",
		2
	],
	"./terms-es.vue": [
		"SjdR",
		1
	],
	"./terms-fr.vue": [
		"u+1q",
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "z8T9";
module.exports = webpackAsyncContext;

/***/ }),

/***/ "z8yg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// mstatic/js/app.f6c0398f401035147c2b.js